/* Mini i18n dictionaries for 5 languages */
export const dict = {
  fr: {
    res_dl_all: "Tout télécharger ({n} fichiers, ZIP)",
    res_dl_error: "Téléchargement impossible",
    res_dl_one: "Télécharger",
    nl_invalid_email: "Email invalide",
    nl_success_toast: "Merci ! Vous êtes inscrit·e à la newsletter",
    nl_confirmed: "Inscription confirmée — à très vite !",
    nl_card_title: "Restez informé·e",
    nl_card_desc: "Recevez notre newsletter mensuelle : événements à venir, opportunités, actualités de la WineTech.",
    nl_email_ph: "votre@email.com",
    nl_subscribe: "S'abonner",
    nl_gdpr: "Désinscription en 1 clic depuis chaque email. Données protégées (RGPD).",
    media_copy_failed: "Impossible de copier l'URL — copiez-la manuellement : {url}",
    unit_mb: "Mo",
    unit_gb: "Go",
    media_load_error: "Impossible de charger la médiathèque",
    media_format_unsupported: "Format non supporté. Acceptés : {formats}",
    media_too_large: "Fichier trop volumineux ({size}). Max : {max}.",
    media_published: "Vidéo publiée",
    media_upload_failed: "Échec de l'upload",
    media_delete_confirm: "Supprimer la vidéo \"{title}\" ?\n\nCette action est définitive.",
    media_deleted: "Vidéo supprimée",
    media_url_copied: "URL publique copiée",
    media_meta_saved: "Métadonnées enregistrées",
    media_title: "Ma médiathèque",
    media_intro: "Hébergez vos pitchs, démos et vidéos de présentation. Les URL générées peuvent être copiées dans vos actualités, événements et offres Le Club.",
    media_upload_btn: "Uploader une vidéo",
    media_finalizing: "Finalisation…",
    media_uploading: "Upload en cours — {pct}%",
    media_formats_label: "Formats :",
    media_max_label: "Taille max :",
    media_hosting_label: "Hébergement :",
    media_hosting_value: "stockage sécurisé, lecture optimisée mobile",
    media_no_transcode: "Pas de transcodage",
    media_no_transcode_hint: "— exportez vos vidéos en format web (MP4 H.264) avant upload.",
    media_empty_title: "Votre médiathèque est vide",
    media_empty_desc: "Uploadez votre première vidéo (pitch de 2 min, démo produit, ou présentation).",
    media_edit: "Éditer",
    media_edit_title: "Éditer la vidéo",
    media_field_title: "Titre",
    media_field_desc: "Description",
    inv_status_paid: "Payée",
    inv_status_open: "En attente",
    inv_status_pending: "Paiement en cours",
    inv_status_draft: "Brouillon",
    inv_status_void: "Annulée",
    inv_status_uncollectible: "Non recouvrable",
    inv_title: "Factures",
    inv_my_title: "Mes factures Stripe",
    inv_empty: "Aucune facture Stripe pour l'instant.",
    inv_my_empty: "Aucune facture Stripe pour l'instant. Vos futures cotisations et paiements d'événements apparaîtront ici.",
    inv_load_error: "Impossible de charger les factures",
    inv_total_paid: "Total payé :",
    inv_refresh_title: "Rafraîchir depuis Stripe",
    inv_refresh: "Rafraîchir",
    inv_stripe_not_configured: "Stripe n'est pas configuré côté serveur — seules les sessions checkout locales sont visibles.",
    inv_col_date: "Date",
    inv_col_number: "Numéro",
    inv_col_description: "Description",
    inv_col_amount: "Montant",
    inv_col_status: "Statut",
    inv_col_actions: "Actions",
    inv_checkout_session: "Session paiement",
    inv_open_payment: "Ouvrir la page de paiement",
    inv_view_stripe: "Voir la facture Stripe",
    inv_pay: "Payer",
    inv_view: "Voir",
    inv_download_pdf: "Télécharger le PDF",
    proj_seo_title: "Projets WineTech — Initiatives collectives de la filière vin",
    proj_seo_desc: "Découvrez les projets et programmes portés par La WineTech : agroécologie, logistique zéro carbone, souveraineté data… Les membres qui construisent l'avenir du vin.",
    proj_badge: "Programmes WineTech",
    proj_h1_a: "Les projets qui façonnent",
    proj_h1_b: "le vin de demain",
    proj_intro: "Chaque projet rassemble des membres volontaires autour d'un enjeu stratégique : innovation, durabilité, souveraineté, nouveaux usages. Explorez, inspirez-vous, rejoignez-nous.",
    proj_empty: "Les projets WineTech arrivent bientôt. Revenez vite !",
    proj_tag: "Projet",
    proj_discover: "Découvrir",
    proj_not_found: "Projet introuvable",
    proj_back: "Retour aux projets",
    proj_all: "Tous les projets",
    proj_tag_full: "Projet WineTech",
    proj_members_one: "{n} membre impliqué",
    proj_members_many: "{n} membres impliqués",
    proj_members_title: "Les membres qui portent le projet",
    proj_members_empty: "Soyez le premier membre à rejoindre ce projet.",
    exh_no_company: "Aucune fiche entreprise liée à votre compte.",
    exh_resynced: "Infos resynchronisées depuis votre fiche entreprise",
    exh_resync_error: "Impossible de resynchroniser",
    exh_name_required: "Nom de l'entreprise requis",
    exh_choose_role: "Choisissez un rôle",
    exh_validated: "Exposant validé",
    exh_submitted: "Candidature envoyée — en attente de validation admin",
    exh_title: "Inscription Exposant",
    exh_company_card: "Fiche entreprise membre",
    exh_resync_title: "Recharger les infos depuis votre fiche entreprise membre",
    exh_resync: "Resynchroniser",
    exh_company_name: "Nom de l'entreprise *",
    exh_role: "Votre rôle *",
    exh_select: "— Sélectionner —",
    exh_booth: "N° de stand",
    exh_booth_ph: "ex : B12",
    exh_logo: "Logo (URL)",
    exh_desc: "Description courte",
    exh_desc_ph: "Présentez votre entreprise en quelques mots…",
    exh_fee_title: "Frais d'inscription exposant",
    exh_secure_payment: "Paiement sécurisé par Stripe. Votre inscription sera validée automatiquement après paiement.",
    exh_free_title: "Inscription gratuite",
    exh_auto_admin: "Validation automatique (admin).",
    exh_review_team: "Votre candidature sera examinée par l'équipe La WineTech.",
    exh_pay: "Payer {price}",
    exh_confirm: "Confirmer l'inscription",
    sidebar_member_shared_services: "Services mutualisés",
    sidebar_member_media: "Médiathèque",
    nav_formations: "Formations",
    nav_support_us: "Soutenez-nous",
    nav_opportunities: "Opportunités",
    nav_community: "La Communauté",
    newsletter_band_title: "Restez informé·e de l'actualité WineTech",
    newsletter_band_desc: "Événements à venir, opportunités, pétitions et innovations — 1 email par mois, désinscription en 1 clic.",
    newsletter_subscribe_aria: "S'abonner à la newsletter",
    newsletter_later: "Plus tard",
    credit_dev_by: "Plateforme développée gratuitement par",
    credit_for: "pour La WineTech.",
    nav_home: "Accueil",
    nav_news: "Actualités",
    nav_events: "Événements",
    nav_members: "Membres",
    nav_projects: "Projets",
    nav_about: "À propos",
    nav_contact: "Contact",
    nav_back_to_site: "Retour au site",
    auto_translated: "Traduit automatiquement",
    loading: "Chargement...",
    news_title: "News Magazine",
    news_subtitle: "Toute l'innovation de l'écosystème WineTech : interviews, analyses, levées de fonds, lancements.",
    news_seo_title: "Actualités & Décryptages",
    news_seo_desc: "Dernières actualités, analyses et histoires de l'écosystème mondial du wine tech — startups, technologies, tendances marché et annonces des membres.",
    news_search_placeholder: "Rechercher une actualité...",
    back_to_news: "Retour aux actualités",
    related_articles: "Articles liés",
    read_more: "Lire la suite",
    filter_all: "Tous",
    cat_innovation: "Innovation",
    cat_technology: "Technologie",
    cat_startup: "Startup",
    cat_market: "Marché",
    cat_digital: "Digital",
    cat_announcement: "Communiqué",
    events_title: "Événements",
    events_subtitle: "Conférences, webinaires, afterworks, masterclasses : les rendez-vous de la communauté WineTech.",
    events_seo_title: "Événements",
    events_seo_desc: "Découvrez les prochains événements WineTech — conférences, RDV 1:1 individuels, ateliers et rencontres d'innovation à travers l'écosystème vinicole mondial.",
    events_upcoming: "À venir",
    events_past: "Passés",
    events_all_formats: "Tous formats",
    events_format_physical: "Physique",
    events_format_digital: "Digital",
    events_format_hybrid: "Hybride",
    events_registered: "inscrits",
    back_to_events: "Retour aux événements",
    cta_join: "Rejoindre",
    cta_explore: "Découvrir la communauté",
    cta_see_events: "Voir les événements",
    cta_visit_website: "Visiter le site",
    hero_title_pre: "La communauté",
    hero_title_brand: "de la WineTech",
    hero_subtitle: "Connecter les talents, partager l'innovation et façonner ensemble l'avenir du vin.",
    innovate_together: "Innovons ensemble",
    actu: "Actualités",
    upcoming_events: "Événements à venir",
    community_members: "Membres de la communauté",
    see_all_news: "Voir toutes les actualités",
    see_all_events: "Voir tous les événements",
    see_all_members: "Voir tous les membres",
    learn_more: "En savoir plus",
    apply_now: "Postuler maintenant",
    login: "Se connecter",
    login_title: "Connexion",
    login_welcome_back: "Heureux de vous revoir.",
    login_loading: "Connexion...",
    login_no_account: "Pas encore membre ?",
    login_create_account: "Créer un compte",
    login_welcome_toast: "Bienvenue !",
    login_brand_title_pre: "Bienvenue dans la",
    login_brand_title_brand: "communauté WineTech",
    login_brand_subtitle: "Connectez-vous pour accéder à votre espace dédié, vos rendez-vous et l'annuaire privé.",
    login_demo_accounts: "Comptes de démo (cliquez pour pré-remplir) :",
    login_demo_admin: "Admin",
    login_demo_member: "Membre",
    login_demo_press: "Presse",
    email: "Email",
    password: "Mot de passe",
    register: "Inscription",
    register_title: "Créer un compte",
    register_loading: "Création...",
    register_have_account: "Déjà inscrit ?",
    register_first_name: "Prénom",
    register_last_name: "Nom",
    register_submit: "S'inscrire",
    register_role_applicant: "Candidat (membre)",
    register_role_event: "Visiteur événement",
    register_role_journalist: "Journaliste / Presse",
    register_company_or_media: "Entreprise / Média",
    register_i_am: "Je suis",
    register_brand_title_pre: "Rejoignez la",
    register_brand_subtitle: "Créez votre compte pour candidater, participer aux événements ou accéder à l'espace presse.",
    logout: "Déconnexion",
    forgot_password: "Mot de passe oublié ?",
    dashboard: "Tableau de bord",
    my_profile: "Mon profil",
    portal_member: "Espace membre",
    portal_press: "Espace presse",
    portal_admin: "Admin CRM",
    apply_join: "Postuler à La WineTech",
    join_intro: "Rejoignez l'écosystème mondial de la WineTech.",
    sidebar_member_dashboard: "Tableau de bord",
    sidebar_member_profile: "Profil entreprise",
    sidebar_member_my_company: "Mon entreprise",
    sidebar_member_score: "Mon score",
    sidebar_member_notifications: "Notifications",
    sidebar_member_matchmaking: "Matchmaking",
    sidebar_member_products: "Produits & Services",
    sidebar_member_team: "Équipe",
    sidebar_member_news: "Publications",
    sidebar_member_events: "Événements",
    sidebar_member_directory: "Annuaire",
    sidebar_member_meetings: "Rendez-vous",
    sidebar_member_messages: "Messages",
    sidebar_member_resources: "Ressources",
    sidebar_personal_profile: "Profil personnel",
    sidebar_admin_dashboard: "Tableau de bord",
    sidebar_admin_pipeline: "Pipeline CRM",
    sidebar_admin_members: "Membres",
    sidebar_admin_applications: "Candidatures",
    sidebar_admin_news: "Actualités",
    sidebar_admin_events: "Événements",
    sidebar_admin_meetings: "Rendez-vous",
    sidebar_admin_analytics: "Analytics",
    sidebar_admin_settings: "Réglages",
    sidebar_press_dashboard: "Tableau de bord",
    sidebar_press_releases: "Communiqués",
    sidebar_press_events: "Événements",
    sidebar_press_members: "Membres",
    sidebar_press_resources: "Ressources",
    sidebar_need_help: "Besoin d'aide ?",
    sidebar_help_text: "Notre équipe est là pour vous accompagner.",
    sidebar_contact_us: "Nous contacter",
    search: "Rechercher",
    search_placeholder: "Rechercher une entreprise, une technologie...",
    category: "Catégorie",
    country: "Pays",
    all: "Tous",
    all_categories: "Toutes catégories",
    all_poles: "Tous les pôles",
    all_countries: "Tous pays",
    no_results: "Aucun résultat trouvé.",
    no_members_found: "Aucun membre trouvé. Modifiez vos filtres.",
    submit: "Envoyer",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    close: "Fermer",
    confirm: "Confirmer",
    publish: "Publier",
    download: "Télécharger",
    open: "Ouvrir",
    pending: "En attente",
    approved: "Approuvé",
    rejected: "Refusé",
    draft: "Brouillon",
    active: "Actif",
    published: "Publié",
    archived: "Archivé",
    paid: "Payé",
    pending_payment: "Paiement en attente",
    confirmed: "Confirmé",
    book_meeting: "Prendre rendez-vous",
    exhibitors: "Exposants",
    matchmaking: "Mise en relation",
    register_for_event: "S'inscrire à l'événement",
    visitor: "Visiteur",
    exhibitor: "Exposant",
    media: "Média / Presse",
    free: "Gratuit",
    speakers: "Intervenants",
    sponsors: "Sponsors",
    attendees: "Participants",
    check_in: "Check-in",
    pricing: "Tarification",
    transactions: "Transactions",
    about: "À propos",
    expertise: "Expertise",
    products_services: "Produits & Services",
    company_news: "Actualités",
    technologies: "Technologies",
    activities: "Activités",
    founded_in: "Fondée en",
    employees: "employés",
    active_member: "Membre actif",
    tags: "Tags",
    community_score: "Score communauté",
    points: "pts",
    back_to_members: "Retour aux membres",
    resources: "Ressources",
    press_releases: "Communiqués de presse",
    media_kit: "Kit médias",
    welcome: "Bienvenue",
    success_saved: "Enregistré avec succès",
    error_generic: "Une erreur est survenue",
    footer_intro: "La WineTech connecte les talents de l'innovation viticole à travers le monde. Une communauté unique pour partager, apprendre, collaborer.",
    footer_platform: "Plateforme",
    footer_spaces: "Espaces",
    footer_rights: "Tous droits réservés.",
    footer_made_with: "Made with ♥ for the wine industry.",
    members_directory_intro: "Découvrez tous les acteurs de l'innovation WineTech, leurs spécialités, leurs technologies.",
    portal_exhibitormatchmaking_01: "Créneaux disponibles",
    portal_exhibitormatchmaking_02: "Aucun créneau disponible pour ce contact.",
    portal_matchmaking_01: "Suggérés :",
    portal_matchmaking_02: "et ce que vous",
    portal_matchmaking_03: ". La plateforme vous met automatiquement en relation avec les meilleurs profils.",
    portal_matchmaking_04: "Vos expertises, services, technologies, marchés que vous adressez.",
    portal_matchmaking_05: "Partenariats, technos, ressources, marchés que vous souhaitez accéder.",
    portal_memberdashboard_01: "Voici un aperçu de votre activité dans la communauté WineTech.",
    portal_memberdashboard_02: "Mon entreprise",
    portal_memberdashboard_03: "Aucune entreprise associée.",
    portal_memberdashboard_04: "Compléter mon profil →",
    portal_memberdashboard_05: "Prochains événements",
    portal_memberdashboard_06: "Voir tout",
    portal_memberdashboard_07: "Développez votre visibilité dans la communauté",
    portal_memberdashboard_08: "Publiez des actualités, participez aux événements, prenez rendez-vous avec les autres acteurs.",
    portal_memberdashboard_09: "Publier une actualité",
    portal_memberdirectory_01: "Découvrez et connectez-vous avec les autres membres de la communauté.",
    portal_memberdirectory_02: "Plus récents d&apos;abord",
    portal_memberevents_01: "Événements",
    portal_memberevents_02: "Inscrivez-vous aux prochains événements de la communauté.",
    portal_memberevents_03: "À venir",
    portal_memberevents_04: "Passés",
    portal_memberevents_05: "Toutes audiences",
    portal_memberevents_06: "Date la plus proche",
    portal_memberevents_07: "Date la plus éloignée",
    portal_memberevents_08: "Publié récemment",
    portal_memberevents_09: "Publié il y a longtemps",
    portal_membermeetings_01: "Mes rendez-vous",
    portal_membermeetings_02: "Gérez vos rendez-vous, vos disponibilités et votre planning RDV 1:1 individuels.",
    portal_membermeetings_03: "Mon planning RDV 1:1 individuels",
    portal_membermeetings_04: "Découvrez les événements",
    portal_membermeetings_05: "et réservez votre prochain rendez-vous.",
    portal_membermeetings_06: "Mes événements en tant qu'exposant",
    portal_membermeetings_07: "Sélectionnez les créneaux pendant lesquels vous êtes disponible pour rencontrer des visiteurs. Seuls les créneaux cochés seront proposés à la réservation.",
    portal_membermeetings_08: "Validé",
    portal_membermeetings_09: "⚠️ Aucun créneau sélectionné. Les visiteurs ne peuvent pas réserver tant que vous n'avez pas indiqué vos disponibilités.",
    portal_membermeetings_10: "Mes disponibilités",
    portal_membermessages_01: "Conversations privées avec la communauté.",
    portal_membermessages_02: "Sélectionnez une conversation.",
    portal_membernews_01: "Mes actualités",
    portal_membernews_02: "Soumettez vos news, lancements, levées de fonds.",
    portal_membernews_03: "Validation requise par l'équipe La WineTech",
    portal_membernews_04: "Votre actualité sera relue par un administrateur. Délai de validation :",
    portal_membernews_05: "24 à 72h",
    portal_membernews_06: "Soumettre pour validation",
    portal_membernews_07: "Catégorie",
    portal_membernews_08: "Aucune actualité publiée pour l&apos;instant.",
    portal_memberproducts_01: "Aucune entreprise associée.",
    portal_memberproducts_02: "Vitrine de vos offres dans l'écosystème WineTech.",
    portal_memberproducts_03: "Vidéo",
    portal_memberproducts_04: "Démo",
    portal_memberproducts_05: "Aucun produit ni service publié.",
    portal_memberprofile_01: "Soignez votre fiche pour gagner en visibilité dans l&apos;écosystème.",
    portal_memberprofile_02: "Voir ma fiche publique",
    portal_memberprofile_03: "Publier une actualité",
    portal_memberprofile_04: "Complétude",
    portal_memberprofile_05: "Mes événements",
    portal_memberprofile_06: "Tout voir →",
    portal_memberprofile_07: "Aucun événement à venir.",
    portal_memberprofile_08: "Découvrir les événements →",
    portal_memberprofile_09: "Mes publications",
    portal_memberprofile_10: "Gérer →",
    portal_memberprofile_11: "Partagez vos nouveautés avec la communauté WineTech pour augmenter votre visibilité.",
    portal_memberprofile_12: "Présentation longue (Markdown)",
    portal_memberprofile_13: "Pôle principal",
    portal_memberprofile_14: "Tags spéciaux",
    portal_memberprofile_15: "Activités secondaires",
    portal_memberprofile_16: "Marchés adressés",
    portal_memberprofile_17: "Aidez l&apos;écosystème à vous trouver — choisissez tous les tags qui s&apos;appliquent à votre activité. Filtrables sur l&apos;annuaire et utilisés sur les fiches événement.",
    portal_memberresources_01: "Télécharger",
    portal_memberteam_01: "Aucune entreprise associée.",
    portal_memberteam_02: "Équipe",
    portal_memberteam_03: "Gérez les collaborateurs de votre entreprise et leurs rôles.",
    portal_memberteam_04: "Invitation créée ✓",
    portal_memberteam_05: "Mot de passe temporaire",
    portal_memberteam_06: "(à transmettre manuellement — l'email d'invitation Brevo sera connecté dans une prochaine itération) :",
    portal_memberteam_07: "Inviter un autre collaborateur",
    portal_memberteam_08: "Rôle",
    portal_mycompany_01: "Mon entreprise",
    portal_mycompany_02: "Complétez les infos de votre fiche entreprise et gérez vos collaborateurs.",
    portal_mycompany_03: "Le",
    portal_mycompany_04: "est affiché partout (annuaire, événements, visuels, badges). L&apos;",
    portal_mycompany_05: "entité légale",
    portal_mycompany_06: "est utilisée uniquement pour la facturation Stripe.",
    portal_mycompany_07: "Affiché sur tous les supports publics",
    portal_mycompany_08: "Entité légale (facturation)",
    portal_mycompany_09: "Utilisée pour Stripe & factures",
    portal_mycompany_10: "Seul le contact principal peut modifier ces informations",
    portal_mycompany_11: "Ajouter un collaborateur",
    portal_mycompany_12: "Définir comme contact principal",
    portal_mycompany_13: "Aucun collaborateur. Ajoutez votre équipe pour profiter pleinement des avantages La WineTech.",
    portal_myeventpage_01: "← Mon portail",
    portal_myeventpage_02: "Se désinscrire",
    portal_myeventpage_03: "Voir la page publique",
    portal_myeventpage_04: "Vous n'êtes pas encore inscrit·e à cet événement.",
    portal_myeventpage_05: "Rendez-vous sur la",
    portal_myeventpage_06: "pour vous inscrire.",
    portal_myeventpage_07: "🎥 Événement en ligne",
    portal_myeventpage_08: "Code d'accès :",
    portal_myeventpage_09: "Rejoindre la visio →",
    portal_myeventpage_10: "Étape 1",
    portal_myeventpage_11: "Téléchargez votre badge",
    portal_myeventpage_12: "Présentez-le à l'accueil le jour J.",
    portal_myeventpage_13: "Télécharger le PDF",
    portal_myeventpage_14: "Étape 2",
    portal_myeventpage_15: "Voir la section ↓",
    portal_myeventpage_16: "Le jour J",
    portal_myeventpage_17: "Mes disponibilités RDV 1:1 individuels",
    portal_myeventpage_18: "Vous êtes inscrit·e comme exposant·e",
    portal_myeventpage_19: "Cochez les créneaux pendant lesquels vous serez disponible pour rencontrer des visiteurs. Seuls les créneaux cochés seront proposés à la réservation.",
    portal_myeventpage_20: "Validé",
    portal_myeventpage_21: "Aucun créneau sélectionné — les visiteurs ne peuvent pas vous réserver.",
    portal_myeventpage_22: "Vue calendrier complète",
    portal_myeventpage_23: "Aucun exposant validé pour le moment. Revenez plus tard ⏳",
    portal_myeventpage_24: "Mes RDV confirmés",
    portal_myscore_01: "Mon score communauté",
    portal_myscore_02: "Votre engagement dans la communauté WineTech, calculé selon des critères transparents.",
    portal_myscore_03: "Plus vous contribuez, plus votre visibilité grandit",
    portal_myscore_04: "Détail des points",
    portal_myscore_05: "Complétez votre fiche entreprise (logo, description, site web) — gain immédiat.",
    portal_myscore_06: "Renseignez LinkedIn et un lien calendrier pour chaque collaborateur.",
    portal_myscore_07: "Publiez vos actualités via votre portail membre.",
    portal_myscore_08: "Inscrivez-vous et participez aux événements communautaires.",
    portal_myscore_09: "Ajoutez vos collaborateurs depuis la page « Mon entreprise ».",
    portal_notifications_01: "Tout ce qui se passe dans votre communauté, en un coup d'œil.",
    portal_notifications_02: "Préférences email",
    portal_notifications_03: "Pour chaque catégorie, choisissez si vous voulez recevoir un email en plus de la notification dans l'app.",
    portal_notifications_04: "Aucune notification pour le moment.",
    portal_notifications_05: "Voir →",
    portal_personalprofile_01: "Mon profil personnel",
    portal_personalprofile_02: "Mettez à jour vos informations personnelles, votre photo et votre agenda public.",
    portal_personalprofile_03: "Identité",
    portal_personalprofile_04: "Prénom",
    portal_personalprofile_05: "Téléphone",
    portal_personalprofile_06: "Calendly, Cal.com, Google Agenda… ce lien sera proposé pour réserver des rendez-vous avec vous.",
    press_pressdashboard_01: "Bienvenue dans votre espace presse WineTech. Accédez aux dernières actualités de la communauté.",
    press_pressdashboard_02: "Accès journaliste approuvé",
    press_pressdashboard_03: "Vous avez un accès complet à toutes les news de la plateforme.",
    press_pressdashboard_04: "Voir mon profil",
    press_pressdashboard_05: "Dernières news",
    press_pressdashboard_06: "Catégories",
    press_pressdashboard_07: "Toutes les catégories",
    press_pressdashboard_08: "Notre équipe presse est à votre disposition pour toute demande.",
    press_pressevents_01: "Événements",
    press_pressevents_02: "Accédez à tous les événements de la communauté WineTech.",
    press_pressevents_03: "À venir",
    press_pressevents_04: "Passés",
    press_pressevents_05: "Date la plus proche",
    press_pressevents_06: "Date la plus éloignée",
    press_pressevents_07: "Publié récemment",
    press_pressevents_08: "Publié il y a longtemps",
    press_pressmembers_01: "Découvrez les acteurs de l&apos;innovation vin.",
    press_pressmembers_02: "Plus récents d&apos;abord",
    press_pressreleases_01: "Communiqués de presse",
    press_pressreleases_02: "Plus récents d&apos;abord",
    press_pressreleases_03: "Aucun communiqué pour l&apos;instant.",
    press_pressresources_01: "Kit médias & ressources",
    press_pressresources_02: "Logos, photos officielles, communiqués et rapports.",
    press_pressresources_03: "Télécharger",
    layout_publiclayout_01: "📝 Déposer ma candidature",
    layout_publiclayout_02: "Besoin d'un CRM, d'un portail client, d'un extranet, d'une application métier ou d'une plateforme SaaS sur mesure pour booster votre développement ?",
    portal_mycompany_readonly: "Vous consultez ce profil en lecture seule. Seul le contact principal (ou un administrateur) peut modifier ces informations. Demandez à votre contact principal d'activer l'option « Autoriser les autres collaborateurs à modifier » dans cette page.",
  
    portal_exhibitormatchmaking_90: "Chargement...",
    portal_memberdashboard_90: "Actualités publiées",
    portal_memberdashboard_91: "Événements rejoints",
    portal_memberdashboard_92: "Vues de votre profil",
    portal_memberdashboard_93: "Modifier",
    portal_memberevents_90: "Rechercher un événement, une ville…",
    portal_membermeetings_90: "Ajouter",
    portal_membermessages_90: "Nouveau message",
    portal_membermessages_91: "Votre réponse…",
    portal_membermessages_92: "Envoyer",
    portal_membermessages_93: "Rechercher un membre, admin, presse…",
    portal_membermessages_94: "Votre message…",
    portal_membernews_90: "Image de couverture",
    portal_memberproducts_90: "Description détaillée",
    portal_memberproducts_91: "URL vidéo YouTube/Vimeo",
    portal_memberproducts_92: "URL démo",
    portal_memberproducts_93: "Ajouter",
    portal_memberproducts_94: "Supprimer",
    portal_memberprofile_90: "Identité",
    portal_memberprofile_91: "Bannière (16:5 recommandé)",
    portal_memberprofile_92: "Année de création",
    portal_memberprofile_93: "Présentation",
    portal_memberprofile_94: "Réseaux sociaux",
    portal_memberteam_90: "Prénom",
    portal_memberteam_91: "Envoyer l&apos;invitation",
    portal_memberteam_92: "Aucun collaborateur.",
    portal_mycompany_90: "Chargement…",
    portal_mycompany_91: "Email de contact",
    portal_mycompany_92: "Téléphone",
    portal_mycompany_93: "Description / présentation",
    portal_mycompany_94: "Logo (PNG/SVG, format libre, 512px min.)",
    portal_mycompany_95: "Bannière (16:9, 1600×900 conseillé)",
    portal_mycompany_96: "Enregistrer",
    portal_mycompany_97: "Prénom *",
    portal_mycompany_98: "Ajouter &amp; envoyer l&apos;invitation",
    portal_mycompany_99: "Annuler",
    portal_mycompany_100: "Renvoyer",
    portal_mycompany_101: "Inviter",
    portal_myeventpage_90: "Chargement…",
    portal_myscore_90: "Chargement…",
    portal_personalprofile_90: "Chargement...",
    portal_personalprofile_91: "Importer une photo (JPG/PNG, ≤ 5 Mo)",
    portal_personalprofile_92: "Quelques lignes pour vous présenter…",
    layout_portallayout_90: "Fermer le menu",
    layout_portallayout_91: "Ouvrir le menu",
    layout_publiclayout_90: "Découvrir l'adhésion La WineTech",
    layout_publiclayout_91: "Déposer ma candidature",
  
    sidebar_help_mode_emploi: "Mode d'emploi",
    sidebar_admin_prospects: "Prospects",
    sidebar_admin_contacts: "Contacts",
    sidebar_admin_formations: "Formations",
    sidebar_admin_checkin_qr: "Check-in (QR)",
    sidebar_admin_administrators: "Administrateurs",
    sidebar_admin_emails: "Emails",
    sidebar_admin_mailshot: "Mailshot CRM",
    sidebar_admin_scoring: "Scoring",
    sidebar_admin_renewals: "Renouvellements",
    sidebar_admin_activity_log: "Activity Log",
    sidebar_admin_ai_feedback: "AI Feedback",
    subtitle_admin: "Admin",
    subtitle_press: "Innovation & Partage",
    subtitle_member: "Communauté & Innovation",
    user_label_default: "Utilisateur",
    role_admin: "Administrateur",
    role_member: "Membre",
    role_press: "Presse",
    role_applicant: "Candidat",
    role_event_visitor: "Visiteur événement",
    role_journalist: "Journaliste",
    title_admin_dashboard: "Admin Dashboard",
    title_press_portal: "Portail Presse",
    title_member_portal: "Portail Membre",
  
    portal_mycompany_section_title: "Fiche entreprise",
    portal_mycompany_name_label: "Nom commercial *",
    portal_mycompany_legal_label: "Raison sociale",
    portal_mycompany_name_term: "nom commercial",
    portal_mycompany_legal_term: "raison sociale",
    portal_mycompany_name_placeholder: "Ex : VineaTech",
    portal_mycompany_legal_placeholder: "Ex : VineaTech SAS",
    portal_mycompany_vat_placeholder: "N° TVA intracom.",
    portal_mycompany_website_placeholder: "Site web",
    portal_mycompany_city_placeholder: "Ville",
    portal_mycompany_collaborators_title: "Collaborateurs",
    portal_mycompany_email_required_placeholder: "Email *",
    portal_mycompany_lastname_required_placeholder: "Nom *",
    portal_mycompany_jobtitle_placeholder: "Fonction",
    portal_mycompany_linkedin_placeholder: "URL LinkedIn",
    portal_mycompany_calendar_placeholder: "Lien calendrier (Calendly, Google…)",
    portal_mycompany_primary_badge: "Principal",
    image_upload_replace: "Remplacer",
    image_upload_loading: "Upload…",
    search_button: "Rechercher",
    common_required: "(obligatoire)",
  
    comp_aboutpage_90: "About La WineTech",
    comp_aboutpage_91: "À propos de La WineTech",
    comp_aboutpage_92: "Notre mission",
    comp_aboutpage_93: "L'écosystème",
    comp_activateaccount_90: "Activer mon compte",
    comp_activateaccount_91: "Vérification du lien…",
    comp_activateaccount_92: "Demander un nouveau lien",
    comp_activateaccount_93: "Compte activé !",
    comp_activateaccount_94: "Redirection vers la page de connexion…",
    comp_activateaccount_95: "Activer votre compte",
    comp_activateaccount_96: "Choisissez un mot de passe pour terminer l'activation.",
    comp_activateaccount_97: "Mot de passe (6+ caractères)",
    comp_activateaccount_98: "Confirmer le mot de passe",
    comp_applypage_90: "Candidater | La WineTech",
    comp_applypage_91: "La WineTech",
    comp_applypage_92: "Rejoindre la communauté",
    comp_applypage_93: "3 minutes pour nous présenter votre projet. Notre équipe revient vers vous sous 48 h.",
    comp_applypage_94: "Vos coordonnées personnelles. Nous traitons vos données conformément au RGPD.",
    comp_applypage_95: "Prénom *",
    comp_applypage_96: "Téléphone",
    comp_applypage_97: "Votre LinkedIn",
    comp_applypage_98: "J&apos;accepte de recevoir des communications de La WineTech (événements, opportunités, newsletter). Désinscription possible à tout moment.",
    comp_applypage_99: "À propos de votre structure",
    comp_applypage_100: "Ces informations nous permettent d&apos;évaluer votre profil et la cotisation adaptée.",
    comp_applypage_101: "Nom de la société *",
    comp_applypage_102: "Votre fonction",
    comp_applypage_103: "Nous adaptons la cotisation à la taille de votre structure.",
    comp_applypage_104: "Catégorie *",
    comp_applypage_105: "Type(s) d'innovation / d'intérêts",
    comp_applypage_106: "Présentez votre structure en quelques lignes *",
    comp_applypage_107: "Quelle est votre activité ? Quels sont vos enjeux principaux ?",
    comp_applypage_108: "Dernière étape",
    comp_applypage_109: "Aidez-nous à comprendre ce que vous attendez de La WineTech.",
    comp_applypage_110: "Ce qui vous intéresse en priorité *",
    comp_applypage_111: "💡 Prochaines étapes",
    comp_applypage_112: "Nous étudions votre candidature sous 48 h ouvrées",
    comp_applypage_113: "Vous recevez une confirmation par email immédiatement",
    comp_applypage_114: "Si éligible, un créneau d&apos;échange vous sera proposé",
    comp_applypage_115: "politique de confidentialité",
    comp_applythankspage_90: "Candidature envoyée | La WineTech",
    comp_applythankspage_91: "48 h ouvrées",
    comp_applythankspage_92: "Réservez votre RDV de découverte",
    comp_applythankspage_93: "Suivez La WineTech",
    comp_applythankspage_94: "Une question ?",
    comp_billingpage_90: "Informations de facturation transmises",
    comp_billingpage_91: "Notre équipe va à présent émettre votre facture. Vous recevrez prochainement un email avec le lien de paiement sécurisé Stripe.",
    comp_billingpage_92: "! Votre candidature pour",
    comp_billingpage_93: "Numéro TVA",
    comp_billingsuccess_90: "Confirmation du paiement…",
    comp_billingsuccess_91: "Bienvenue dans",
    comp_billingsuccess_92: "la communauté",
    comp_billingsuccess_93: "Votre paiement de",
    comp_billingsuccess_94: "est confirmé. Notre équipe va finaliser votre onboarding et vous contacter rapidement pour votre call de bienvenue.",
    comp_billingsuccess_95: "Accéder à mon espace",
    comp_billingsuccess_96: "Stripe traite votre paiement. Vous recevrez un email dès la confirmation.",
    comp_billingsuccess_97: "Erreur",
    comp_billingsuccess_98: "Impossible de vérifier le paiement. Contactez l'équipe.",
    comp_contactpage_90: "Une question, un projet, une candidature ? Écrivez-nous et notre équipe vous répond sous 48h.",
    comp_contactpage_91: "Message bien reçu !",
    comp_contactpage_92: "Notre équipe a reçu votre message et reviendra vers vous très bientôt.",
    comp_contactpage_93: "Envoyer un autre message",
    comp_contactpage_94: "Prénom *",
    comp_contactpage_95: "Téléphone",
    comp_contactpage_96: "— Pôle d&apos;activité (optionnel) —",
    comp_contactpage_97: "Votre message *",
    comp_contactpage_98: "J&apos;accepte que mes données soient enregistrées par La WineTech pour traiter ma demande (conformément au RGPD). Mes données ne seront jamais revendues.",
    comp_contactpage_99: "Ou écrivez-nous directement à",
    comp_digestsubscribepage_90: "C&apos;est noté !",
    comp_digestsubscribepage_91: "Vous recevrez votre premier Weekly Digest jeudi prochain à 9h. Vous pourrez modifier vos préférences ou vous désinscrire depuis chaque email.",
    comp_digestsubscribepage_92: "Chaque jeudi à 9h, recevez l&apos;essentiel de la WineTech selon vos centres d&apos;intérêt — actualités des membres, innovations, science, réglementaire et événements à venir.",
    comp_digestsubscribepage_93: "Prénom",
    comp_digestsubscribepage_94: "🇫🇷 Français",
    comp_digestsubscribepage_95: "🇵🇹 Português",
    comp_digestsubscribepage_96: "Centres d&apos;intérêt",
    comp_digestsubscribepage_97: "— tout coché par défaut",
    comp_eventdetail_90: "Chargement...",
    comp_eventdetail_91: "Vous êtes connecté en tant que",
    comp_eventdetail_92: "← Retour à mon espace",
    comp_eventdetail_93: "📄 Catalogue de l&apos;événement",
    comp_eventdetail_94: "PDF complet avec la liste des exposants, visiteurs et intervenants — mis à jour en temps réel.",
    comp_eventdetail_95: "Voir les RDV",
    comp_eventdetail_96: "Qui sera là ?",
    comp_eventdetail_97: "Liste publique des inscrits confirmés — venez rencontrer ces membres et exposants de la communauté WineTech.",
    comp_eventdetail_98: "Inscription confirmée",
    comp_eventdetail_99: "Confirmer la désinscription ?",
    comp_eventdetail_100: "Confirmer",
    comp_eventdetail_101: "Annuler",
    comp_eventdetail_102: "Déjà membre ?",
    comp_eventdetail_103: "Inscription confirmée !",
    comp_eventdetail_104: "activer votre compte",
    comp_eventdetail_105: "Télécharger mon badge PDF",
    comp_eventdetail_106: "Inscription à l'événement",
    comp_eventdetail_107: "💳 Après ce formulaire, vous serez redirigé vers la page de paiement sécurisée Stripe. Votre badge sera émis à l'issue du paiement.",
    comp_eventdetail_108: "— Gratuit. Votre badge sera émis immédiatement.",
    comp_eventdetail_109: "Prénom *",
    comp_eventdetail_110: "Société",
    comp_eventdetail_111: "Téléphone",
    comp_eventdetail_112: "Un compte personnel vous sera créé automatiquement (email d'activation envoyé) afin de retrouver votre badge et participer aux RDV 1:1 individuels.",
    comp_eventdetail_113: "Rechercher un nom, société, produit…",
    comp_eventdetail_114: "Trier : Prénom A→Z",
    comp_eventdetail_115: "Trier : Société A→Z",
    comp_eventdetail_116: "Trier : Profils les plus riches",
    comp_eventpaymentsuccess_90: "Vérification du paiement…",
    comp_eventpaymentsuccess_91: "Paiement confirmé !",
    comp_eventpaymentsuccess_92: "Votre inscription est validée. Voici votre badge.",
    comp_eventpaymentsuccess_93: "Le paiement prend plus de temps que prévu. Vous recevrez un email de confirmation dès qu'il sera validé.",
    comp_eventpaymentsuccess_94: "Retour à l'événement",
    comp_eventpaymentsuccess_95: "Paiement non confirmé",
    comp_eventpaymentsuccess_96: "Une erreur est survenue. Si vous avez été débité, contactez-nous.",
    comp_eventslist_90: "Rechercher un événement, une ville…",
    comp_eventslist_91: "Date la plus proche",
    comp_eventslist_92: "Date la plus éloignée",
    comp_eventslist_93: "Publié récemment",
    comp_eventslist_94: "Publié il y a longtemps",
    comp_exhibitorpaymentsuccess_90: "Vérification du paiement…",
    comp_exhibitorpaymentsuccess_91: "Inscription exposant confirmée !",
    comp_exhibitorpaymentsuccess_92: "Votre paiement a bien été pris en compte. Vous êtes désormais validé(e) comme exposant pour ces RDV 1:1 individuels.",
    comp_exhibitorpaymentsuccess_93: "Prochaine étape :",
    comp_exhibitorpaymentsuccess_94: "rendez-vous sur votre",
    comp_exhibitorpaymentsuccess_95: "espace événement",
    comp_exhibitorpaymentsuccess_96: "pour",
    comp_exhibitorpaymentsuccess_97: "sélectionner vos créneaux de disponibilité",
    comp_exhibitorpaymentsuccess_98: "Gérer mes disponibilités",
    comp_exhibitorpaymentsuccess_99: "Retour à l'événement",
    comp_exhibitorpaymentsuccess_100: "Paiement non confirmé",
    comp_exhibitorpaymentsuccess_101: "Le paiement n'a pas pu être vérifié. Si vous avez bien payé, le webhook Stripe finalisera l'inscription sous quelques minutes.",
    comp_forgotpassword_90: "Mot de passe oublié ?",
    comp_forgotpassword_91: "Entrez votre email. Si un compte existe, vous recevrez un lien de réinitialisation valide 1 heure.",
    comp_forgotpassword_92: "Email envoyé",
    comp_formationdetail_90: "Chargement…",
    comp_formationdetail_91: "Lien de connexion (inscrits)",
    comp_formationdetail_92: "Mot de passe :",
    comp_formationdetail_93: "Prénom *",
    comp_formationslist_90: "Formations La WineTech Academy",
    comp_formationslist_91: "Sessions pour monter en compétences dans l&apos;univers du vin & des technologies associées.",
    comp_formationslist_92: "Rechercher une formation…",
    comp_formationslist_93: "Aucune formation pour le moment.",
    comp_home_90: "la communauté WineTech",
    comp_home_91: "Échangez, collaborez et participez à construire le futur du vin.",
    comp_joinpage_90: "Rejoindre La WineTech | Adhésion & Cotisations",
    comp_joinpage_91: "Rejoignez l'écosystème international de",
    comp_joinpage_92: "écosystème d'innovation",
    comp_joinpage_93: "Le socle commun",
    comp_joinpage_94: "Quelle que soit votre catégorie d'adhésion, vous bénéficiez de ces avantages.",
    comp_joinpage_95: "Choisissez votre catégorie",
    comp_joinpage_96: "Chaque profil bénéficie d'avantages complémentaires pensés pour son métier.",
    comp_joinpage_97: "En complément du socle commun",
    comp_joinpage_98: "Calculez votre",
    comp_joinpage_99: "Indiquez votre catégorie et votre chiffre d'affaires annuel pour découvrir votre tarif d'adhésion estimé. Aucune création de compte requise.",
    comp_joinpage_100: "Catégorie",
    comp_joinpage_101: "Cotisation annuelle indicative — sous réserve de validation par notre comité.",
    comp_joinpage_102: "Au-delà de l'adhésion",
    comp_joinpage_103: "Notre comité étudie votre candidature et vous répond sous 5 jours ouvrés.",
    comp_joinpage_104: "Déjà candidat·e ? Se connecter",
    comp_leaderboard_90: "Top membres La WineTech",
    comp_leaderboard_91: "Les acteurs les plus engagés dans la communauté chaque mois.",
    comp_leaderboard_92: "Classement en cours de constitution.",
    comp_leaderboard_93: "Ce que disent nos membres",
    comp_memberprofile_90: "Vous êtes connecté en tant que",
    comp_memberprofile_91: "← Retour à mon espace",
    comp_memberprofile_92: "Vidéo",
    comp_memberprofile_93: "Démo",
    comp_memberprofile_94: "Connectez-vous directement avec l'équipe.",
    comp_memberprofile_95: "Téléphone",
    comp_memberprofile_96: "Réserver un RDV",
    comp_membersdirectory_90: "Plus récents d&apos;abord",
    comp_newslist_90: "Plus récentes d&apos;abord",
    comp_publicmeetingrequest_90: "Demander un rendez-vous",
    comp_publicmeetingrequest_91: "Demande envoyée !",
    comp_publicmeetingrequest_92: "Notre équipe vous répond très vite à",
    comp_publicmeetingrequest_93: ". À bientôt 🍷",
    comp_publicmeetingrequest_94: "Votre nom *",
    comp_publicmeetingrequest_95: "Téléphone",
    comp_publicmeetingrequest_96: "Société",
    comp_publicmeetingrequest_97: "Sujet du rendez-vous *",
    comp_publicmeetingrequest_98: "Date souhaitée (optionnel)",
    comp_publicmeetingrequest_99: "Présentez brièvement votre demande, votre activité, vos attentes…",
    comp_publicmeetingrequest_100: "En soumettant ce formulaire, vous acceptez que vos informations soient utilisées par l'équipe La WineTech pour vous recontacter. Consultez notre politique de confidentialité.",
    comp_renewalform_90: "Paiement annulé. Vous pouvez réessayer ci-dessous.",
    comp_renewalform_91: "Chargement…",
    comp_renewalform_92: "Lien invalide ou expiré. Contactez La WineTech.",
    comp_renewalform_93: "Votre réponse a été enregistrée. Nous serions ravis de continuer à échanger avec vous.",
    comp_renewalform_94: "Redirection vers le paiement…",
    comp_renewalform_95: "Note globale (sur 5)",
    comp_renewalform_96: "Votre commentaire",
    comp_renewalform_97: "Vos retours sur l'année écoulée…",
    comp_renewalform_98: "Sert à calculer automatiquement votre cotisation selon la grille La WineTech.",
    comp_renewalform_99: "Chargé",
    comp_renewalform_100: "Mode de paiement",
    comp_resetpassword_90: "Le lien de réinitialisation est incomplet ou expiré.",
    comp_resetpassword_91: "Demander un nouveau lien",
    comp_resetpassword_92: "Nouveau mot de passe",
    comp_resetpassword_93: "Choisissez un mot de passe d'au moins 8 caractères.",
    comp_resetpassword_94: "Confirmer le mot de passe",
    comp_resetpassword_95: "Mot de passe mis à jour",
    comp_resetpassword_96: "Vous allez être redirigé(e) vers la page de connexion…",
    press_pressdashboard_90: "Événements à venir",
    press_pressdashboard_91: "Communiqués",
    press_pressdashboard_92: "Rechercher une news...",
    press_pressevents_90: "Rechercher un événement, une ville…",
    press_pressmembers_90: "Rechercher un membre, ville, technologie…",
  
    join_seg_startups_name: "Startups & Innovation",
    join_seg_startups_desc: "Jeunes entreprises innovantes développant des solutions pour la filière vin.",
    join_seg_startups_extra_1: "Visibilité auprès des producteurs, partenaires et acteurs de la filière",
    join_seg_startups_extra_2: "Accès aux investisseurs et partenaires de l'écosystème",
    join_seg_startups_extra_3: "Opportunités d'expérimentation terrain",
    join_seg_startups_extra_4: "Possibilité d'être intégrées aux programmes d'accélération et initiatives collectives",
    join_seg_startups_extra_5: "Participation aux groupes de travail et projets collaboratifs",
    join_seg_experts_name: "Experts & Consultants",
    join_seg_experts_desc: "Cabinets de conseil, experts indépendants et accompagnateurs spécialisés.",
    join_seg_experts_extra_1: "Référencement comme expert de l'écosystème",
    join_seg_experts_extra_2: "Valorisation des expertises et retours d'expérience",
    join_seg_experts_extra_3: "Participation aux groupes de travail et chantiers thématiques",
    join_seg_experts_extra_4: "Opportunités de collaboration avec les membres de l'écosystème",
    join_seg_producteurs_name: "Producteurs",
    join_seg_producteurs_desc: "Domaines, caves coopératives, maisons de négoce et producteurs engagés dans l'innovation.",
    join_seg_producteurs_extra_1: "Veille sur les innovations du secteur",
    join_seg_producteurs_extra_2: "Découverte des startups et solutions membres",
    join_seg_producteurs_extra_3: "Opportunités d'expérimentation et de collaboration",
    join_seg_producteurs_extra_4: "Possibilité de participer aux programmes d'accélération thématiques",
    join_seg_producteurs_extra_5: "Participation aux projets collectifs portés par la WineTech",
    join_seg_fournisseurs_name: "Communication, Équipement & Distribution",
    join_seg_fournisseurs_desc: "Fournisseurs de solutions, équipementiers, distributeurs et prestataires de services de la filière.",
    join_seg_fournisseurs_extra_1: "Valorisation des solutions et services proposés",
    join_seg_fournisseurs_extra_2: "Visibilité auprès des producteurs et des startups",
    join_seg_fournisseurs_extra_3: "Participation aux projets collaboratifs",
    join_seg_fournisseurs_extra_4: "Intégration aux initiatives collectives de l'écosystème",
    join_seg_ecoles_name: "Instituts & Écoles",
    join_seg_ecoles_desc: "Établissements d'enseignement, centres de recherche, laboratoires et organismes de formation.",
    join_seg_ecoles_extra_1: "Valorisation des projets pédagogiques et scientifiques",
    join_seg_ecoles_extra_2: "Connexion avec les entreprises et startups de la filière",
    join_seg_ecoles_extra_3: "Participation aux projets collaboratifs",
    join_seg_ecoles_extra_4: "Contribution aux réflexions et travaux de l'écosystème",
    join_seg_partenaires_name: "Partenaires",
    join_seg_partenaires_desc: "Institutions, interprofessions, organisations professionnelles et entreprises souhaitant soutenir durablement l'écosystème WineTech.",
    join_seg_partenaires_extra_1: "Visibilité institutionnelle renforcée",
    join_seg_partenaires_extra_2: "Participation aux orientations stratégiques de l'association",
    join_seg_partenaires_extra_3: "Soutien aux programmes structurants de la filière",
    join_seg_partenaires_extra_4: "Présence privilégiée lors des événements WineTech",
    join_seg_partenaires_extra_5: "Participation aux initiatives collectives portées par la WineTech",
    join_common_1: "Profil membre sur la plateforme WineTech",
    join_common_2: "Présence dans l'annuaire des membres",
    join_common_3: "Accès aux événements WineTech",
    join_common_4: "Accès aux Wine Tech Coffee",
    join_common_5: "Participation au Wine Tech Campus",
    join_common_6: "Accès à la veille et aux actualités de l'écosystème",
    join_common_7: "Accès au groupe communautaire",
    join_common_8: "Identification au sein de l'écosystème WineTech",
    join_common_9: "Référencement dans les communications WineTech",
    join_prog_accel_title: "Programmes d'accélération",
    join_prog_accel_desc: "Accompagnement collectif autour de l'innovation, du développement commercial, de la croissance, de l'expérimentation terrain et du financement.",
    join_prog_export_title: "Missions export",
    join_prog_export_desc: "Découverte de nouveaux marchés, rencontres d'affaires et opérations collectives à l'international.",
    join_prog_academy_title: "WineTech Academy",
    join_prog_academy_desc: "Formations, ateliers, masterclass et partage de bonnes pratiques entre membres et experts.",
    join_prog_press_title: "Visibilité & Presse",
    join_prog_press_desc: "Valorisation des initiatives, communication, relations presse et actions de promotion de l'écosystème.",
    join_prog_events_title: "Événements & opérations collectives",
    join_prog_events_desc: "Wine Tech Tour, Wine Tech Coffee, Wine Tech Campus, salons professionnels et rencontres thématiques.",
    apply_innovation_ai: "Intelligence artificielle",
    apply_innovation_robot: "Robotique / agtech",
    apply_innovation_iot: "Capteurs / IoT",
    apply_innovation_blockchain: "Traçabilité / blockchain",
    apply_innovation_marketplace: "Marketplace / e-commerce",
    apply_innovation_tourism: "Tourisme & expérience",
    apply_innovation_energy: "Énergie & durabilité",
    apply_innovation_oeno: "Œnologie / data vin",
    apply_innovation_logistics: "Logistique & supply",
    apply_innovation_other: "Autre",
    apply_interest_member: "Devenir membre La WineTech",
    apply_interest_partner: "Partenariat commercial",
    apply_interest_invest: "Investissement / levée de fonds",
    apply_interest_mentor: "Mentorat / réseau",
    apply_interest_event: "Participer aux événements",
    apply_interest_visibility: "Visibilité presse / communication",
    apply_interest_export: "Programme international",
  
    join_annual_fee: "Cotisation annuelle",
    apply_step_label: "Étape",
    apply_step_you: "Vous",
    apply_step_you_short: "Identité",
    apply_step_company: "Votre entreprise",
    apply_step_company_short: "Société",
    apply_step_expectations: "Vos attentes",
    apply_step_expectations_short: "Finalisation",
    apply_btn_previous: "Précédent",
    apply_btn_continue: "Continuer",
    apply_btn_submit: "Envoyer ma candidature",
    apply_btn_submitting: "Envoi…",
    apply_desc_min_chars: "Minimum 30 caractères",
  
    portal_mycompany_collab_subtitle: "Invitez vos collègues à rejoindre votre espace membre — ils profiteront de votre adhésion sans frais supplémentaires.",
    portal_mycompany_invite_cta_title: "Invitez un collègue à rejoindre votre entreprise",
    portal_mycompany_invite_cta_subtitle: "Votre adhésion couvre toute l'équipe : ajoutez-les pour qu'ils accèdent aux événements, au matchmaking et à la veille.",
  
    cta_apply: "Candidater",
  
    join_calc_chip: "Simulateur instantané",
    join_calc_word_fee: "cotisation",
    join_calc_revenue_label: "Chiffre d'affaires annuel (€)",
    join_calc_revenue_placeholder: "ex : 1 500 000",
    join_calc_loading: "Calcul...",
    join_calc_submit: "Calculer mon tarif",
    join_calc_bracket: "Tranche estimée",
    apply_step0_title: "Faisons connaissance",
    apply_field_lastname: "Nom *",
    apply_field_email: "Email professionnel *",
    apply_form_required_toast: "Merci de compléter les champs requis avant de continuer.",
    apply_form_privacy_before: "Vos données sont traitées conformément à notre",
    apply_form_privacy_after: ". Aucun spam, désinscription en 1 clic.",
    not_found_title: "Page introuvable",
    not_found_message: "Cette page n'existe pas ou n'est plus accessible. Vérifiez l'URL ou revenez à l'accueil.",
    not_found_back: "Retour",
    not_found_home: "Accueil",
    portal_mycompany_collab_status_active: "Actif",
    portal_mycompany_collab_status_pending: "Invitation en attente",
    portal_mycompany_collab_status_no_account: "Sans compte",
  
    join_beyond_membership_desc: "L'adhésion constitue la porte d'entrée de l'écosystème WineTech. Les membres peuvent ensuite participer aux initiatives et programmes développés tout au long de l'année.",
    apply_thanks_title: "Candidature envoyée",
    apply_thanks_intro: "Merci ! Nous avons bien reçu votre candidature et un email de confirmation vient d'être envoyé.",
    apply_thanks_within: "Notre équipe reviendra vers vous sous",
    apply_thanks_within_value: "48 h ouvrées",
    apply_thanks_calendar_h: "Réservez votre RDV de découverte",
    apply_thanks_calendar_desc: "Pour aller plus vite, choisissez un créneau de <strong>30 min</strong> avec notre équipe directement dans le calendrier ci-dessous.",
    apply_thanks_book_cta: "Choisir un créneau",
    apply_thanks_no_calendar: "📅 Nous reviendrons vers vous avec une proposition de créneau pour échanger.",
    apply_thanks_back_home: "Retour à l'accueil",
    apply_thanks_follow: "Suivez La WineTech",
    apply_thanks_questions: "Une question ?",
    apply_field_website: "Site web",
    apply_field_revenue: "Chiffre d'affaires annuel (€)",
    apply_field_country: "Pays *",
    apply_field_choose: "— Choisissez —",
    apply_toast_success: "Candidature envoyée !",
    apply_toast_error: "Erreur lors de l'envoi. Réessayez ou contactez-nous.",
    apply_toast_error_short: "Erreur d'envoi",
    apply_lang_label: "Langue / Language",
    application_validated_by: "Validée par {name} · le {date}",
    application_rejected_by: "Refusée par {name} · le {date}",
  },
  en: {
    res_dl_all: "Download all ({n} files, ZIP)",
    res_dl_error: "Download failed",
    res_dl_one: "Download",
    nl_invalid_email: "Invalid email",
    nl_success_toast: "Thank you! You are subscribed to the newsletter",
    nl_confirmed: "Subscription confirmed — see you soon!",
    nl_card_title: "Stay informed",
    nl_card_desc: "Receive our monthly newsletter: upcoming events, opportunities, WineTech news.",
    nl_email_ph: "your@email.com",
    nl_subscribe: "Subscribe",
    nl_gdpr: "Unsubscribe in 1 click from every email. Data protected (GDPR).",
    media_copy_failed: "Could not copy URL — copy it manually: {url}",
    unit_mb: "MB",
    unit_gb: "GB",
    media_load_error: "Unable to load media library",
    media_format_unsupported: "Unsupported format. Accepted: {formats}",
    media_too_large: "File too large ({size}). Max: {max}.",
    media_published: "Video published",
    media_upload_failed: "Upload failed",
    media_delete_confirm: "Delete video \"{title}\"?\n\nThis action is irreversible.",
    media_deleted: "Video deleted",
    media_url_copied: "Public URL copied",
    media_meta_saved: "Metadata saved",
    media_title: "My Media Library",
    media_intro: "Host your pitches, demos, and presentation videos. The generated URLs can be copied into your news, events, and Le Club offers.",
    media_upload_btn: "Upload a video",
    media_finalizing: "Finalizing…",
    media_uploading: "Uploading — {pct}%",
    media_formats_label: "Formats:",
    media_max_label: "Max size:",
    media_hosting_label: "Hosting:",
    media_hosting_value: "secure storage, mobile-optimized playback",
    media_no_transcode: "No transcoding",
    media_no_transcode_hint: "— export your videos in web format (MP4 H.264) before uploading.",
    media_empty_title: "Your media library is empty",
    media_empty_desc: "Upload your first video (2-min pitch, product demo, or presentation).",
    media_edit: "Edit",
    media_edit_title: "Edit video",
    media_field_title: "Title",
    media_field_desc: "Description",
    inv_status_paid: "Paid",
    inv_status_open: "Open",
    inv_status_pending: "Payment in progress",
    inv_status_draft: "Draft",
    inv_status_void: "Void",
    inv_status_uncollectible: "Uncollectible",
    inv_title: "Invoices",
    inv_my_title: "My Stripe Invoices",
    inv_empty: "No Stripe invoices yet.",
    inv_my_empty: "No Stripe invoices yet. Your future membership fees and event payments will appear here.",
    inv_load_error: "Unable to load invoices",
    inv_total_paid: "Total paid:",
    inv_refresh_title: "Refresh from Stripe",
    inv_refresh: "Refresh",
    inv_stripe_not_configured: "Stripe is not configured on the server side — only local checkout sessions are visible.",
    inv_col_date: "Date",
    inv_col_number: "Number",
    inv_col_description: "Description",
    inv_col_amount: "Amount",
    inv_col_status: "Status",
    inv_col_actions: "Actions",
    inv_checkout_session: "Checkout session",
    inv_open_payment: "Open payment page",
    inv_view_stripe: "View Stripe invoice",
    inv_pay: "Pay",
    inv_view: "View",
    inv_download_pdf: "Download PDF",
    proj_seo_title: "WineTech Projects — Collective initiatives for the wine industry",
    proj_seo_desc: "Discover the projects and programs led by La WineTech: agroecology, zero-carbon logistics, data sovereignty… The members building the future of wine.",
    proj_badge: "WineTech Programs",
    proj_h1_a: "Projects shaping",
    proj_h1_b: "the wine of tomorrow",
    proj_intro: "Each project brings together volunteer members around a strategic issue: innovation, sustainability, sovereignty, new uses. Explore, get inspired, join us.",
    proj_empty: "WineTech projects are coming soon. Check back soon!",
    proj_tag: "Project",
    proj_discover: "Discover",
    proj_not_found: "Project not found",
    proj_back: "Back to projects",
    proj_all: "All projects",
    proj_tag_full: "WineTech Project",
    proj_members_one: "{n} member involved",
    proj_members_many: "{n} members involved",
    proj_members_title: "Members leading the project",
    proj_members_empty: "Be the first member to join this project.",
    exh_no_company: "No company profile linked to your account.",
    exh_resynced: "Info resynced from your company profile",
    exh_resync_error: "Unable to resync",
    exh_name_required: "Company name required",
    exh_choose_role: "Choose a role",
    exh_validated: "Exhibitor validated",
    exh_submitted: "Application submitted — awaiting admin validation",
    exh_title: "Exhibitor Registration",
    exh_company_card: "Member company profile",
    exh_resync_title: "Reload info from your member company profile",
    exh_resync: "Resync",
    exh_company_name: "Company name *",
    exh_role: "Your role *",
    exh_select: "— Select —",
    exh_booth: "Booth No.",
    exh_booth_ph: "e.g.: B12",
    exh_logo: "Logo (URL)",
    exh_desc: "Short description",
    exh_desc_ph: "Introduce your company in a few words…",
    exh_fee_title: "Exhibitor registration fee",
    exh_secure_payment: "Secure payment via Stripe. Your registration will be automatically validated after payment.",
    exh_free_title: "Free registration",
    exh_auto_admin: "Automatic validation (admin).",
    exh_review_team: "Your application will be reviewed by the La WineTech team.",
    exh_pay: "Pay {price}",
    exh_confirm: "Confirm registration",
    sidebar_member_shared_services: "Shared services",
    sidebar_member_media: "Media Library",
    nav_formations: "Training",
    nav_support_us: "Support us",
    nav_opportunities: "Opportunities",
    nav_community: "The Community",
    newsletter_band_title: "Stay informed about WineTech news",
    newsletter_band_desc: "Upcoming events, opportunities, petitions, and innovations — 1 email per month, unsubscribe in 1 click.",
    newsletter_subscribe_aria: "Subscribe to the newsletter",
    newsletter_later: "Later",
    credit_dev_by: "Platform developed for free by",
    credit_for: "for La WineTech.",
    nav_home: "Home",
    nav_news: "News",
    nav_events: "Events",
    nav_members: "Members",
    nav_projects: "Projects",
    nav_about: "About",
    nav_contact: "Contact",
    nav_back_to_site: "Back to site",
    auto_translated: "Auto-translated",
    loading: "Loading...",
    news_title: "News Magazine",
    news_subtitle: "All the innovation from the WineTech ecosystem: interviews, deep-dives, fundraising rounds and product launches.",
    news_seo_title: "News & Insights",
    news_seo_desc: "Latest news, deep-dives and stories from the global wine innovation ecosystem — startups, technology, market trends and member announcements.",
    news_search_placeholder: "Search news...",
    back_to_news: "Back to news",
    related_articles: "Related articles",
    read_more: "Read more",
    filter_all: "All",
    cat_innovation: "Innovation",
    cat_technology: "Technology",
    cat_startup: "Startup",
    cat_market: "Market",
    cat_digital: "Digital",
    cat_announcement: "Announcement",
    events_title: "Events",
    events_subtitle: "Conferences, webinars, after-works, masterclasses: the WineTech community gatherings.",
    events_seo_title: "Events",
    events_seo_desc: "Discover upcoming WineTech events — conferences, 1:1 meetings, workshops and innovation gatherings across the global wine ecosystem.",
    events_upcoming: "Upcoming",
    events_past: "Past",
    events_all_formats: "All formats",
    events_format_physical: "In-person",
    events_format_digital: "Digital",
    events_format_hybrid: "Hybrid",
    events_registered: "registered",
    back_to_events: "Back to events",
    cta_join: "Join",
    cta_explore: "Explore the community",
    cta_see_events: "See events",
    cta_visit_website: "Visit website",
    hero_title_pre: "The global",
    hero_title_brand: "WineTech community",
    hero_subtitle: "Connect talents, share innovation, and shape the future of wine together.",
    innovate_together: "Innovate Together",
    actu: "News",
    upcoming_events: "Upcoming events",
    community_members: "Community members",
    see_all_news: "See all news",
    see_all_events: "See all events",
    see_all_members: "See all members",
    learn_more: "Learn more",
    apply_now: "Apply now",
    login: "Sign in",
    login_title: "Sign in",
    login_welcome_back: "Glad to see you again.",
    login_loading: "Signing in...",
    login_no_account: "Not a member yet?",
    login_create_account: "Create account",
    login_welcome_toast: "Welcome!",
    login_brand_title_pre: "Welcome to the",
    login_brand_title_brand: "WineTech community",
    login_brand_subtitle: "Sign in to access your dedicated space, your meetings and the private directory.",
    login_demo_accounts: "Demo accounts (click to fill):",
    login_demo_admin: "Admin",
    login_demo_member: "Member",
    login_demo_press: "Press",
    email: "Email",
    password: "Password",
    register: "Sign up",
    register_title: "Create account",
    register_loading: "Creating...",
    register_have_account: "Already registered?",
    register_first_name: "First name",
    register_last_name: "Last name",
    register_submit: "Sign up",
    logout: "Sign out",
    forgot_password: "Forgot password?",
    register_role_applicant: "Member candidate",
    register_role_event: "Event visitor",
    register_role_journalist: "Journalist / Press",
    register_company_or_media: "Company / Media",
    register_i_am: "I am",
    register_brand_title_pre: "Join the",
    register_brand_subtitle: "Create your account to apply, attend events or access the press portal.",
    dashboard: "Dashboard",
    my_profile: "My profile",
    portal_member: "Member portal",
    portal_press: "Press portal",
    portal_admin: "Admin CRM",
    apply_join: "Apply to La WineTech",
    join_intro: "Join the global WineTech ecosystem.",
    sidebar_member_dashboard: "Dashboard",
    sidebar_member_profile: "Company profile",
    sidebar_member_my_company: "My company",
    sidebar_member_score: "My score",
    sidebar_member_notifications: "Notifications",
    sidebar_member_matchmaking: "Matchmaking",
    sidebar_member_products: "Products & Services",
    sidebar_member_team: "Team",
    sidebar_member_news: "Posts",
    sidebar_member_events: "Events",
    sidebar_member_directory: "Directory",
    sidebar_member_meetings: "Meetings",
    sidebar_member_messages: "Messages",
    sidebar_member_resources: "Resources",
    sidebar_personal_profile: "Personal profile",
    sidebar_admin_dashboard: "Dashboard",
    sidebar_admin_pipeline: "CRM Pipeline",
    sidebar_admin_members: "Members",
    sidebar_admin_applications: "Applications",
    sidebar_admin_news: "News",
    sidebar_admin_events: "Events",
    sidebar_admin_meetings: "Meetings",
    sidebar_admin_analytics: "Analytics",
    sidebar_admin_settings: "Settings",
    sidebar_press_dashboard: "Dashboard",
    sidebar_press_releases: "Press releases",
    sidebar_press_events: "Events",
    sidebar_press_members: "Members",
    sidebar_press_resources: "Resources",
    sidebar_need_help: "Need help?",
    sidebar_help_text: "Our team is here to help.",
    sidebar_contact_us: "Contact us",
    search: "Search",
    search_placeholder: "Search a company, a technology...",
    category: "Category",
    country: "Country",
    all: "All",
    all_categories: "All categories",
    all_countries: "All countries",
    all_poles: "All sectors",
    no_results: "No results found.",
    no_members_found: "No members found. Try changing filters.",
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    close: "Close",
    confirm: "Confirm",
    publish: "Publish",
    download: "Download",
    open: "Open",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    draft: "Draft",
    active: "Active",
    published: "Published",
    archived: "Archived",
    paid: "Paid",
    pending_payment: "Pending payment",
    confirmed: "Confirmed",
    book_meeting: "Book meeting",
    exhibitors: "Exhibitors",
    matchmaking: "Matchmaking",
    register_for_event: "Register for event",
    visitor: "Visitor",
    exhibitor: "Exhibitor",
    media: "Media / Press",
    free: "Free",
    speakers: "Speakers",
    sponsors: "Sponsors",
    attendees: "Attendees",
    check_in: "Check-in",
    pricing: "Pricing",
    transactions: "Transactions",
    about: "About",
    expertise: "Expertise",
    products_services: "Products & Services",
    company_news: "News",
    technologies: "Technologies",
    activities: "Activities",
    founded_in: "Founded in",
    employees: "employees",
    active_member: "Active member",
    tags: "Tags",
    community_score: "Community score",
    points: "pts",
    back_to_members: "Back to members",
    resources: "Resources",
    press_releases: "Press releases",
    media_kit: "Media kit",
    welcome: "Welcome",
    success_saved: "Successfully saved",
    error_generic: "An error occurred",
    footer_intro: "La WineTech connects wine innovation talents across the world. A unique community to share, learn, collaborate.",
    footer_platform: "Platform",
    footer_spaces: "Spaces",
    footer_rights: "All rights reserved.",
    footer_made_with: "Made with ♥ for the wine industry.",
    members_directory_intro: "Discover all the players of WineTech innovation, their specialties and technologies.",
    portal_exhibitormatchmaking_01: "Available Slots",
    portal_exhibitormatchmaking_02: "No slots available for this contact.",
    portal_matchmaking_01: "Suggested:",
    portal_matchmaking_02: "and what you are looking for",
    portal_matchmaking_03: ". The platform automatically connects you with the best profiles.",
    portal_matchmaking_04: "Your expertise, services, technologies, markets you address.",
    portal_matchmaking_05: "Partnerships, technologies, resources, markets you wish to access.",
    portal_memberdashboard_01: "Here's an overview of your activity in the WineTech community.",
    portal_memberdashboard_02: "My Company",
    portal_memberdashboard_03: "No company associated.",
    portal_memberdashboard_04: "Complete my profile →",
    portal_memberdashboard_05: "Upcoming Events",
    portal_memberdashboard_06: "View All",
    portal_memberdashboard_07: "Increase your visibility within the community",
    portal_memberdashboard_08: "Publish news, participate in events, schedule meetings with other stakeholders.",
    portal_memberdashboard_09: "Publish News",
    portal_memberdirectory_01: "Discover and connect with other community members.",
    portal_memberdirectory_02: "Newest First",
    portal_memberevents_01: "Events",
    portal_memberevents_02: "Register for upcoming community events.",
    portal_memberevents_03: "Upcoming",
    portal_memberevents_04: "Past",
    portal_memberevents_05: "All Audiences",
    portal_memberevents_06: "Closest Date",
    portal_memberevents_07: "Furthest Date",
    portal_memberevents_08: "Recently Published",
    portal_memberevents_09: "Published Long Ago",
    portal_membermeetings_01: "My Meetings",
    portal_membermeetings_02: "Manage your meetings, availabilities, and 1:1 Meetings schedule.",
    portal_membermeetings_03: "My 1:1 Meetings Schedule",
    portal_membermeetings_04: "Discover events",
    portal_membermeetings_05: "and book your next meeting.",
    portal_membermeetings_06: "My Exhibitor Events",
    portal_membermeetings_07: "Select the slots during which you are available to meet visitors. Only checked slots will be offered for booking.",
    portal_membermeetings_08: "Validated",
    portal_membermeetings_09: "⚠️ No slots selected. Visitors cannot book until you have indicated your availabilities.",
    portal_membermeetings_10: "My Availabilities",
    portal_membermessages_01: "Private conversations with the community.",
    portal_membermessages_02: "Select a conversation.",
    portal_membernews_01: "My News",
    portal_membernews_02: "Submit your news, launches, fundraising.",
    portal_membernews_03: "Validation required by La WineTech team",
    portal_membernews_04: "Your news will be reviewed by an administrator. Validation period:",
    portal_membernews_05: "24 to 72 hours",
    portal_membernews_06: "Submit for validation",
    portal_membernews_07: "Category",
    portal_membernews_08: "No news published yet.",
    portal_memberproducts_01: "No associated company.",
    portal_memberproducts_02: "Showcase your offers within the WineTech ecosystem.",
    portal_memberproducts_03: "Video",
    portal_memberproducts_04: "Demo",
    portal_memberproducts_05: "No products or services published.",
    portal_memberprofile_01: "Enhance your profile to gain visibility within the ecosystem.",
    portal_memberprofile_02: "View my public profile",
    portal_memberprofile_03: "Publish news",
    portal_memberprofile_04: "Completeness",
    portal_memberprofile_05: "My events",
    portal_memberprofile_06: "View all →",
    portal_memberprofile_07: "No upcoming events.",
    portal_memberprofile_08: "Discover events →",
    portal_memberprofile_09: "My publications",
    portal_memberprofile_10: "Manage →",
    portal_memberprofile_11: "Share your updates with the WineTech community to increase your visibility.",
    portal_memberprofile_12: "Long description (Markdown)",
    portal_memberprofile_13: "Main sector",
    portal_memberprofile_14: "Special tags",
    portal_memberprofile_15: "Secondary activities",
    portal_memberprofile_16: "Target markets",
    portal_memberprofile_17: "Help the ecosystem find you — choose all tags that apply to your activity. Filterable in the directory and used on event pages.",
    portal_memberresources_01: "Download",
    portal_memberteam_01: "No associated company.",
    portal_memberteam_02: "Team",
    portal_memberteam_03: "Manage your company's collaborators and their roles.",
    portal_memberteam_04: "Invitation created ✓",
    portal_memberteam_05: "Temporary password",
    portal_memberteam_06: "(to be transmitted manually — the Brevo invitation email will be connected in a future iteration):",
    portal_memberteam_07: "Invite another collaborator",
    portal_memberteam_08: "Role",
    portal_mycompany_01: "My company",
    portal_mycompany_02: "Complete your company profile information and manage your collaborators.",
    portal_mycompany_03: "The",
    portal_mycompany_04: "is displayed everywhere (directory, events, visuals, badges). The",
    portal_mycompany_05: "legal entity",
    portal_mycompany_06: "is used solely for Stripe billing.",
    portal_mycompany_07: "Displayed on all public materials",
    portal_mycompany_08: "Legal Entity (Billing)",
    portal_mycompany_09: "Used for Stripe & invoices",
    portal_mycompany_10: "Only the main contact can modify this information",
    portal_mycompany_11: "Add a collaborator",
    portal_mycompany_12: "Set as main contact",
    portal_mycompany_13: "No collaborators. Add your team to fully benefit from La WineTech's advantages.",
    portal_myeventpage_01: "← My portal",
    portal_myeventpage_02: "Unsubscribe",
    portal_myeventpage_03: "View public page",
    portal_myeventpage_04: "You are not yet registered for this event.",
    portal_myeventpage_05: "Go to the",
    portal_myeventpage_06: "to register.",
    portal_myeventpage_07: "🎥 Online Event",
    portal_myeventpage_08: "Access code:",
    portal_myeventpage_09: "Join the video call →",
    portal_myeventpage_10: "Step 1",
    portal_myeventpage_11: "Download your badge",
    portal_myeventpage_12: "Present it at reception on the day of the event.",
    portal_myeventpage_13: "Download PDF",
    portal_myeventpage_14: "Step 2",
    portal_myeventpage_15: "See section ↓",
    portal_myeventpage_16: "On the day of the event",
    portal_myeventpage_17: "My 1:1 Meetings availabilities",
    portal_myeventpage_18: "You are registered as an exhibitor",
    portal_myeventpage_19: "Check the slots during which you will be available to meet visitors. Only checked slots will be offered for booking.",
    portal_myeventpage_20: "Validated",
    portal_myeventpage_21: "No slots selected — visitors cannot book you.",
    portal_myeventpage_22: "Full calendar view",
    portal_myeventpage_23: "No exhibitors validated yet. Come back later ⏳",
    portal_myeventpage_24: "My confirmed appointments",
    portal_myscore_01: "My community score",
    portal_myscore_02: "Your engagement in the WineTech community, calculated according to transparent criteria.",
    portal_myscore_03: "The more you contribute, the more your visibility grows",
    portal_myscore_04: "Points details",
    portal_myscore_05: "Complete your company profile (logo, description, website) — immediate gain.",
    portal_myscore_06: "Enter LinkedIn and a calendar link for each team member.",
    portal_myscore_07: "Publish your news via your member portal.",
    portal_myscore_08: "Register and participate in community events.",
    portal_myscore_09: "Add your team members from the \"My company\" page.",
    portal_notifications_01: "Everything happening in your community, at a glance.",
    portal_notifications_02: "Email preferences",
    portal_notifications_03: "For each category, choose whether you want to receive an email in addition to the in-app notification.",
    portal_notifications_04: "No notifications for now.",
    portal_notifications_05: "View →",
    portal_personalprofile_01: "My personal profile",
    portal_personalprofile_02: "Update your personal information, photo, and public calendar.",
    portal_personalprofile_03: "Identity",
    portal_personalprofile_04: "First name",
    portal_personalprofile_05: "Phone",
    portal_personalprofile_06: "Calendly, Cal.com, Google Calendar… this link will be used to book appointments with you.",
    press_pressdashboard_01: "Welcome to your WineTech press area. Access the latest community news.",
    press_pressdashboard_02: "Approved journalist access",
    press_pressdashboard_03: "You have full access to all platform news.",
    press_pressdashboard_04: "View my profile",
    press_pressdashboard_05: "Latest news",
    press_pressdashboard_06: "Categories",
    press_pressdashboard_07: "All categories",
    press_pressdashboard_08: "Our press team is available for any requests.",
    press_pressevents_01: "Events",
    press_pressevents_02: "Access all WineTech community events.",
    press_pressevents_03: "Upcoming",
    press_pressevents_04: "Past",
    press_pressevents_05: "Closest date",
    press_pressevents_06: "Farthest date",
    press_pressevents_07: "Recently published",
    press_pressevents_08: "Published a long time ago",
    press_pressmembers_01: "Discover the players in wine innovation.",
    press_pressmembers_02: "Newest first",
    press_pressreleases_01: "Press releases",
    press_pressreleases_02: "Newest first",
    press_pressreleases_03: "No press releases yet.",
    press_pressresources_01: "Media kit & resources",
    press_pressresources_02: "Logos, official photos, press releases and reports.",
    press_pressresources_03: "Download",
    layout_publiclayout_01: "📝 Submit my application",
    layout_publiclayout_02: "Need a CRM, client portal, extranet, business application, or custom SaaS platform to boost your development?",
    portal_mycompany_readonly: "You are viewing this profile in read-only mode. Only the primary contact (or an administrator) can modify this information. Ask your primary contact to enable the \"Allow other collaborators to edit\" option on this page.",
  
    portal_exhibitormatchmaking_90: "Loading...",
    portal_memberdashboard_90: "News Published",
    portal_memberdashboard_91: "Events Joined",
    portal_memberdashboard_92: "Profile Views",
    portal_memberdashboard_93: "Edit",
    portal_memberevents_90: "Search event, city...",
    portal_membermeetings_90: "Add",
    portal_membermessages_90: "New Message",
    portal_membermessages_91: "Your reply...",
    portal_membermessages_92: "Send",
    portal_membermessages_93: "Search member, admin, press...",
    portal_membermessages_94: "Your message...",
    portal_membernews_90: "Cover Image",
    portal_memberproducts_90: "Detailed Description",
    portal_memberproducts_91: "YouTube/Vimeo Video URL",
    portal_memberproducts_92: "Demo URL",
    portal_memberproducts_93: "Add",
    portal_memberproducts_94: "Delete",
    portal_memberprofile_90: "Identity",
    portal_memberprofile_91: "Banner (16:5 recommended)",
    portal_memberprofile_92: "Year Founded",
    portal_memberprofile_93: "Introduction",
    portal_memberprofile_94: "Social Networks",
    portal_memberteam_90: "First Name",
    portal_memberteam_91: "Send Invitation",
    portal_memberteam_92: "No collaborators.",
    portal_mycompany_90: "Loading...",
    portal_mycompany_91: "Contact Email",
    portal_mycompany_92: "Phone",
    portal_mycompany_93: "Description / Introduction",
    portal_mycompany_94: "Logo (square, 512×512 recommended)",
    portal_mycompany_95: "Banner (16:9, 1600×900 recommended)",
    portal_mycompany_96: "Save",
    portal_mycompany_97: "First Name *",
    portal_mycompany_98: "Add &amp; Send Invitation",
    portal_mycompany_99: "Cancel",
    portal_mycompany_100: "Resend",
    portal_mycompany_101: "Invite",
    portal_myeventpage_90: "Loading...",
    portal_myscore_90: "Loading...",
    portal_personalprofile_90: "Loading...",
    portal_personalprofile_91: "Upload photo (JPG/PNG, ≤ 5 MB)",
    portal_personalprofile_92: "A few lines to introduce yourself...",
    layout_portallayout_90: "Close Menu",
    layout_portallayout_91: "Open Menu",
    layout_publiclayout_90: "Discover La WineTech membership",
    layout_publiclayout_91: "Apply",
  
    sidebar_help_mode_emploi: "User Manual",
    sidebar_admin_prospects: "Prospects",
    sidebar_admin_contacts: "Contacts",
    sidebar_admin_formations: "Training Programs",
    sidebar_admin_checkin_qr: "Check-in (QR)",
    sidebar_admin_administrators: "Administrators",
    sidebar_admin_emails: "Emails",
    sidebar_admin_mailshot: "CRM Mailshot",
    sidebar_admin_scoring: "Scoring",
    sidebar_admin_renewals: "Renewals",
    sidebar_admin_activity_log: "Activity Log",
    sidebar_admin_ai_feedback: "AI Feedback",
    subtitle_admin: "Admin",
    subtitle_press: "Innovation & Sharing",
    subtitle_member: "Community & Innovation",
    user_label_default: "User",
    role_admin: "Administrator",
    role_member: "Member",
    role_press: "Press",
    role_applicant: "Applicant",
    role_event_visitor: "Event Visitor",
    role_journalist: "Journalist",
    title_admin_dashboard: "Admin Dashboard",
    title_press_portal: "Press Portal",
    title_member_portal: "Member Portal",
  
    portal_mycompany_section_title: "Company Profile",
    portal_mycompany_name_label: "Trade Name *",
    portal_mycompany_legal_label: "Legal Name",
    portal_mycompany_name_term: "trade name",
    portal_mycompany_legal_term: "legal name",
    portal_mycompany_name_placeholder: "Ex: VineaTech",
    portal_mycompany_legal_placeholder: "Ex: VineaTech SAS",
    portal_mycompany_vat_placeholder: "VAT Number",
    portal_mycompany_website_placeholder: "Website",
    portal_mycompany_city_placeholder: "City",
    portal_mycompany_collaborators_title: "Team Members",
    portal_mycompany_email_required_placeholder: "Email *",
    portal_mycompany_lastname_required_placeholder: "Last Name *",
    portal_mycompany_jobtitle_placeholder: "Job Title",
    portal_mycompany_linkedin_placeholder: "LinkedIn URL",
    portal_mycompany_calendar_placeholder: "Calendar Link (Calendly, Google...)",
    portal_mycompany_primary_badge: "Primary",
    image_upload_replace: "Replace",
    image_upload_loading: "Uploading...",
    search_button: "Search",
    common_required: "(required)",
  
    comp_aboutpage_90: "About La WineTech",
    comp_aboutpage_91: "About La WineTech",
    comp_aboutpage_92: "Our Mission",
    comp_aboutpage_93: "The Ecosystem",
    comp_activateaccount_90: "Activate My Account",
    comp_activateaccount_91: "Verifying link…",
    comp_activateaccount_92: "Request New Link",
    comp_activateaccount_93: "Account Activated!",
    comp_activateaccount_94: "Redirecting to login page…",
    comp_activateaccount_95: "Activate Your Account",
    comp_activateaccount_96: "Choose a password to complete activation.",
    comp_activateaccount_97: "Password (6+ characters)",
    comp_activateaccount_98: "Confirm Password",
    comp_applypage_90: "Apply | La WineTech",
    comp_applypage_91: "La WineTech",
    comp_applypage_92: "Join the Community",
    comp_applypage_93: "3 minutes to introduce us to your project. Our team will get back to you within 48 hours.",
    comp_applypage_94: "Your personal details. We process your data in compliance with GDPR.",
    comp_applypage_95: "First Name *",
    comp_applypage_96: "Phone",
    comp_applypage_97: "Your LinkedIn",
    comp_applypage_98: "I agree to receive communications from La WineTech (events, opportunities, newsletter). Unsubscribe possible at any time.",
    comp_applypage_99: "About Your Organization",
    comp_applypage_100: "This information allows us to evaluate your profile and the appropriate membership fee.",
    comp_applypage_101: "Company Name *",
    comp_applypage_102: "Your Role",
    comp_applypage_103: "We adjust the membership fee to the size of your organization.",
    comp_applypage_104: "Category *",
    comp_applypage_105: "Type(s) of Innovation / Interests",
    comp_applypage_106: "Present your organization in a few lines *",
    comp_applypage_107: "What is your activity? What are your main challenges?",
    comp_applypage_108: "Last Step",
    comp_applypage_109: "Help us understand what you expect from La WineTech.",
    comp_applypage_110: "What interests you most *",
    comp_applypage_111: "💡 Next Steps",
    comp_applypage_112: "We will review your application within 48 business hours",
    comp_applypage_113: "You will receive an email confirmation immediately",
    comp_applypage_114: "If eligible, a discussion slot will be offered to you",
    comp_applypage_115: "privacy policy",
    comp_applythankspage_90: "Application Sent | La WineTech",
    comp_applythankspage_91: "48 business hours",
    comp_applythankspage_92: "Book your Discovery Meeting",
    comp_applythankspage_93: "Follow La WineTech",
    comp_applythankspage_94: "Any questions?",
    comp_billingpage_90: "Billing Information Submitted",
    comp_billingpage_91: "Our team will now issue your invoice. You will soon receive an email with the secure Stripe payment link.",
    comp_billingpage_92: "! Your application for",
    comp_billingpage_93: "VAT Number",
    comp_billingsuccess_90: "Payment Confirmation…",
    comp_billingsuccess_91: "Welcome to",
    comp_billingsuccess_92: "the community",
    comp_billingsuccess_93: "Your payment of",
    comp_billingsuccess_94: "is confirmed. Our team will finalize your onboarding and contact you shortly for your welcome call.",
    comp_billingsuccess_95: "Access my space",
    comp_billingsuccess_96: "Stripe is processing your payment. You will receive an email upon confirmation.",
    comp_billingsuccess_97: "Error",
    comp_billingsuccess_98: "Unable to verify payment. Please contact the team.",
    comp_contactpage_90: "A question, a project, an application? Write to us and our team will get back to you within 48 hours.",
    comp_contactpage_91: "Message received!",
    comp_contactpage_92: "Our team has received your message and will get back to you very soon.",
    comp_contactpage_93: "Send another message",
    comp_contactpage_94: "First Name *",
    comp_contactpage_95: "Phone",
    comp_contactpage_96: "— Business Sector (optional) —",
    comp_contactpage_97: "Your message *",
    comp_contactpage_98: "I agree that my data may be stored by La WineTech to process my request (in accordance with GDPR). My data will never be resold.",
    comp_contactpage_99: "Or write to us directly at",
    comp_digestsubscribepage_90: "Noted!",
    comp_digestsubscribepage_91: "You will receive your first Weekly Digest next Thursday at 9 AM. You can modify your preferences or unsubscribe from each email.",
    comp_digestsubscribepage_92: "Every Thursday at 9 AM, receive the essentials of WineTech based on your interests — member news, innovations, science, regulatory updates, and upcoming events.",
    comp_digestsubscribepage_93: "First Name",
    comp_digestsubscribepage_94: "🇫🇷 French",
    comp_digestsubscribepage_95: "🇵🇹 Portuguese",
    comp_digestsubscribepage_96: "Interests",
    comp_digestsubscribepage_97: "— all checked by default",
    comp_eventdetail_90: "Loading...",
    comp_eventdetail_91: "You are logged in as",
    comp_eventdetail_92: "← Back to my space",
    comp_eventdetail_93: "📄 Event Catalog",
    comp_eventdetail_94: "Complete PDF with the list of exhibitors, visitors, and speakers — updated in real-time.",
    comp_eventdetail_95: "View Appointments",
    comp_eventdetail_96: "Who will be there?",
    comp_eventdetail_97: "Public list of confirmed registrants — come meet these WineTech community members and exhibitors.",
    comp_eventdetail_98: "Registration confirmed",
    comp_eventdetail_99: "Confirm unregistration?",
    comp_eventdetail_100: "Confirm",
    comp_eventdetail_101: "Cancel",
    comp_eventdetail_102: "Already a member?",
    comp_eventdetail_103: "Registration confirmed!",
    comp_eventdetail_104: "activate your account",
    comp_eventdetail_105: "Download my PDF badge",
    comp_eventdetail_106: "Event Registration",
    comp_eventdetail_107: "💳 After this form, you will be redirected to the secure Stripe payment page. Your badge will be issued upon payment.",
    comp_eventdetail_108: "— Free. Your badge will be issued immediately.",
    comp_eventdetail_109: "First Name *",
    comp_eventdetail_110: "Company",
    comp_eventdetail_111: "Phone",
    comp_eventdetail_112: "A personal account will be created automatically for you (activation email sent) so you can find your badge and participate in 1:1 meetings.",
    comp_eventdetail_113: "Search for a name, company, product…",
    comp_eventdetail_114: "Sort: First Name A→Z",
    comp_eventdetail_115: "Sort: Company A→Z",
    comp_eventdetail_116: "Sort: Richest Profiles",
    comp_eventpaymentsuccess_90: "Payment verification…",
    comp_eventpaymentsuccess_91: "Payment confirmed!",
    comp_eventpaymentsuccess_92: "Your registration is validated. Here is your badge.",
    comp_eventpaymentsuccess_93: "Payment is taking longer than expected. You will receive a confirmation email as soon as it is validated.",
    comp_eventpaymentsuccess_94: "Back to event",
    comp_eventpaymentsuccess_95: "Payment not confirmed",
    comp_eventpaymentsuccess_96: "An error occurred. If you have been charged, please contact us.",
    comp_eventslist_90: "Search for an event, city…",
    comp_eventslist_91: "Closest date",
    comp_eventslist_92: "Furthest date",
    comp_eventslist_93: "Recently published",
    comp_eventslist_94: "Published long ago",
    comp_exhibitorpaymentsuccess_90: "Payment verification…",
    comp_exhibitorpaymentsuccess_91: "Exhibitor registration confirmed!",
    comp_exhibitorpaymentsuccess_92: "Your payment has been successfully processed. You are now validated as an exhibitor for these 1:1 Meetings.",
    comp_exhibitorpaymentsuccess_93: "Next step:",
    comp_exhibitorpaymentsuccess_94: "go to your",
    comp_exhibitorpaymentsuccess_95: "event space",
    comp_exhibitorpaymentsuccess_96: "to",
    comp_exhibitorpaymentsuccess_97: "select your available slots",
    comp_exhibitorpaymentsuccess_98: "Manage my availabilities",
    comp_exhibitorpaymentsuccess_99: "Back to event",
    comp_exhibitorpaymentsuccess_100: "Payment not confirmed",
    comp_exhibitorpaymentsuccess_101: "Payment could not be verified. If you have paid, the Stripe webhook will finalize the registration in a few minutes.",
    comp_forgotpassword_90: "Forgot password?",
    comp_forgotpassword_91: "Enter your email. If an account exists, you will receive a reset link valid for 1 hour.",
    comp_forgotpassword_92: "Email sent",
    comp_formationdetail_90: "Loading…",
    comp_formationdetail_91: "Connection link (for registered attendees)",
    comp_formationdetail_92: "Password:",
    comp_formationdetail_93: "First Name *",
    comp_formationslist_90: "La WineTech Academy Trainings",
    comp_formationslist_91: "Sessions to enhance skills in the world of wine & associated technologies.",
    comp_formationslist_92: "Search for a training…",
    comp_formationslist_93: "No training available at the moment.",
    comp_home_90: "the WineTech community",
    comp_home_91: "Exchange, collaborate, and help build the future of wine.",
    comp_joinpage_90: "Join La WineTech | Membership & Fees",
    comp_joinpage_91: "Join the international ecosystem of",
    comp_joinpage_92: "innovation ecosystem",
    comp_joinpage_93: "The common foundation",
    comp_joinpage_94: "Regardless of your membership category, you benefit from these advantages.",
    comp_joinpage_95: "Choose your category",
    comp_joinpage_96: "Each profile benefits from additional advantages tailored to their profession.",
    comp_joinpage_97: "In addition to the common foundation",
    comp_joinpage_98: "Calculate your",
    comp_joinpage_99: "Indicate your category and annual turnover to discover your estimated membership fee. No account creation required.",
    comp_joinpage_100: "Category",
    comp_joinpage_101: "Indicative annual membership fee — subject to validation by our committee.",
    comp_joinpage_102: "Beyond membership",
    comp_joinpage_103: "Our committee will review your application and respond within 5 business days.",
    comp_joinpage_104: "Already applied? Log in",
    comp_leaderboard_90: "Top La WineTech members",
    comp_leaderboard_91: "The most engaged members in the community each month.",
    comp_leaderboard_92: "Ranking currently being established.",
    comp_leaderboard_93: "What our members say",
    comp_memberprofile_90: "You are logged in as",
    comp_memberprofile_91: "← Back to my space",
    comp_memberprofile_92: "Video",
    comp_memberprofile_93: "Demo",
    comp_memberprofile_94: "Connect directly with the team.",
    comp_memberprofile_95: "Phone",
    comp_memberprofile_96: "Book an appointment",
    comp_membersdirectory_90: "Newest first",
    comp_newslist_90: "Newest first",
    comp_publicmeetingrequest_90: "Request an appointment",
    comp_publicmeetingrequest_91: "Request sent!",
    comp_publicmeetingrequest_92: "Our team will respond very soon at",
    comp_publicmeetingrequest_93: ". See you soon 🍷",
    comp_publicmeetingrequest_94: "Your name *",
    comp_publicmeetingrequest_95: "Phone",
    comp_publicmeetingrequest_96: "Company",
    comp_publicmeetingrequest_97: "Appointment subject *",
    comp_publicmeetingrequest_98: "Preferred date (optional)",
    comp_publicmeetingrequest_99: "Briefly describe your request, activity, expectations…",
    comp_publicmeetingrequest_100: "By submitting this form, you agree that your information may be used by the La WineTech team to contact you. Consult our privacy policy.",
    comp_renewalform_90: "Payment cancelled. You can try again below.",
    comp_renewalform_91: "Loading…",
    comp_renewalform_92: "Invalid or expired link. Contact La WineTech.",
    comp_renewalform_93: "Your response has been recorded. We would be happy to continue engaging with you.",
    comp_renewalform_94: "Redirecting to payment…",
    comp_renewalform_95: "Overall rating (out of 5)",
    comp_renewalform_96: "Your comment",
    comp_renewalform_97: "Your feedback on the past year…",
    comp_renewalform_98: "Used to automatically calculate your membership fee according to La WineTech's scale.",
    comp_renewalform_99: "Loaded",
    comp_renewalform_100: "Payment method",
    comp_resetpassword_90: "The reset link is incomplete or expired.",
    comp_resetpassword_91: "Request a new link",
    comp_resetpassword_92: "New password",
    comp_resetpassword_93: "Choose a password of at least 8 characters.",
    comp_resetpassword_94: "Confirm password",
    comp_resetpassword_95: "Password updated",
    comp_resetpassword_96: "You will be redirected to the login page…",
    press_pressdashboard_90: "Upcoming events",
    press_pressdashboard_91: "Press releases",
    press_pressdashboard_92: "Search for news...",
    press_pressevents_90: "Search for an event, a city…",
    press_pressmembers_90: "Search a member, city, technology…",
  
    join_seg_startups_name: "Startups & Innovation",
    join_seg_startups_desc: "Innovative young companies developing solutions for the wine industry.",
    join_seg_startups_extra_1: "Visibility among producers, partners, and industry players",
    join_seg_startups_extra_2: "Access to investors and ecosystem partners",
    join_seg_startups_extra_3: "On-site experimentation opportunities",
    join_seg_startups_extra_4: "Possibility of integration into acceleration programs and collective initiatives",
    join_seg_startups_extra_5: "Participation in working groups and collaborative projects",
    join_seg_experts_name: "Experts & Consultants",
    join_seg_experts_desc: "Consulting firms, independent experts, and specialized advisors.",
    join_seg_experts_extra_1: "Referenced as an ecosystem expert",
    join_seg_experts_extra_2: "Showcasing expertise and sharing feedback",
    join_seg_experts_extra_3: "Participation in working groups and thematic projects",
    join_seg_experts_extra_4: "Collaboration opportunities with ecosystem members",
    join_seg_producteurs_name: "Producers",
    join_seg_producteurs_desc: "Wineries, cooperative cellars, trading houses, and producers committed to innovation.",
    join_seg_producteurs_extra_1: "Monitoring industry innovations",
    join_seg_producteurs_extra_2: "Discovering member startups and solutions",
    join_seg_producteurs_extra_3: "Experimentation and collaboration opportunities",
    join_seg_producteurs_extra_4: "Possibility of participating in thematic acceleration programs",
    join_seg_producteurs_extra_5: "Participation in collective projects led by WineTech",
    join_seg_fournisseurs_name: "Communication, Equipment & Distribution",
    join_seg_fournisseurs_desc: "Solution providers, equipment manufacturers, distributors, and service providers in the industry.",
    join_seg_fournisseurs_extra_1: "Showcasing proposed solutions and services",
    join_seg_fournisseurs_extra_2: "Visibility among producers and startups",
    join_seg_fournisseurs_extra_3: "Participation in collaborative projects",
    join_seg_fournisseurs_extra_4: "Integration into collective ecosystem initiatives",
    join_seg_ecoles_name: "Institutions & Schools",
    join_seg_ecoles_desc: "Educational institutions, research centers, laboratories, and training organizations.",
    join_seg_ecoles_extra_1: "Showcasing educational and scientific projects",
    join_seg_ecoles_extra_2: "Connection with industry companies and startups",
    join_seg_ecoles_extra_3: "Participation in collaborative projects",
    join_seg_ecoles_extra_4: "Contribution to ecosystem discussions and work",
    join_seg_partenaires_name: "Partners",
    join_seg_partenaires_desc: "Institutions, interprofessional organizations, professional bodies, and companies wishing to sustainably support the WineTech ecosystem.",
    join_seg_partenaires_extra_1: "Enhanced institutional visibility",
    join_seg_partenaires_extra_2: "Participation in the association's strategic orientations",
    join_seg_partenaires_extra_3: "Support for structuring industry programs",
    join_seg_partenaires_extra_4: "Privileged presence at WineTech events",
    join_seg_partenaires_extra_5: "Participation in collective initiatives led by WineTech",
    join_common_1: "Member profile on the WineTech platform",
    join_common_2: "Presence in the member directory",
    join_common_3: "Access to WineTech events",
    join_common_4: "Access to Wine Tech Coffee events",
    join_common_5: "Participation in Wine Tech Campus",
    join_common_6: "Access to monitoring and ecosystem news",
    join_common_7: "Access to the community group",
    join_common_8: "Identification within the WineTech ecosystem",
    join_common_9: "Referencing in WineTech communications",
    join_prog_accel_title: "Acceleration Programs",
    join_prog_accel_desc: "Collective support focused on innovation, business development, growth, field experimentation, and funding.",
    join_prog_export_title: "Export Missions",
    join_prog_export_desc: "Discovery of new markets, business meetings, and collective international operations.",
    join_prog_academy_title: "WineTech Academy",
    join_prog_academy_desc: "Training, workshops, masterclasses, and sharing of best practices among members and experts.",
    join_prog_press_title: "Visibility & Press",
    join_prog_press_desc: "Showcasing initiatives, communication, press relations, and ecosystem promotion activities.",
    join_prog_events_title: "Events & Collective Operations",
    join_prog_events_desc: "Wine Tech Tour, Wine Tech Coffee, Wine Tech Campus, trade shows, and thematic meetings.",
    apply_innovation_ai: "Artificial Intelligence",
    apply_innovation_robot: "Robotics / AgTech",
    apply_innovation_iot: "Sensors / IoT",
    apply_innovation_blockchain: "Traceability / Blockchain",
    apply_innovation_marketplace: "Marketplace / E-commerce",
    apply_innovation_tourism: "Tourism & Experience",
    apply_innovation_energy: "Energy & Sustainability",
    apply_innovation_oeno: "Oenology / Wine Data",
    apply_innovation_logistics: "Logistics & Supply Chain",
    apply_innovation_other: "Other",
    apply_interest_member: "Become a WineTech Member",
    apply_interest_partner: "Commercial Partnership",
    apply_interest_invest: "Investment / Fundraising",
    apply_interest_mentor: "Mentorship / Networking",
    apply_interest_event: "Participate in Events",
    apply_interest_visibility: "Press Visibility / Communication",
    apply_interest_export: "International Program",
  
    join_annual_fee: "Annual fee",
    apply_step_label: "Step",
    apply_step_you: "You",
    apply_step_you_short: "Identity",
    apply_step_company: "Your company",
    apply_step_company_short: "Company",
    apply_step_expectations: "Your expectations",
    apply_step_expectations_short: "Finalization",
    apply_btn_previous: "Previous",
    apply_btn_continue: "Continue",
    apply_btn_submit: "Submit my application",
    apply_btn_submitting: "Submitting...",
    apply_desc_min_chars: "Minimum 30 characters",
  
    portal_mycompany_collab_subtitle: "Invite your colleagues to join your company space — they'll enjoy your membership at no extra cost.",
    portal_mycompany_invite_cta_title: "Invite a colleague to join your company",
    portal_mycompany_invite_cta_subtitle: "Your membership covers the entire team: add them for access to events, matchmaking, and insights.",
  
    cta_apply: "Apply",
  
    join_calc_chip: "Instant Simulator",
    join_calc_word_fee: "Fee",
    join_calc_revenue_label: "Annual Revenue (€)",
    join_calc_revenue_placeholder: "e.g.: 1,500,000",
    join_calc_loading: "Calculating...",
    join_calc_submit: "Calculate my rate",
    join_calc_bracket: "Estimated Tier",
    apply_step0_title: "Let's Get to Know Each Other",
    apply_field_lastname: "Last Name *",
    apply_field_email: "Work Email *",
    apply_form_required_toast: "Please complete the required fields before continuing.",
    apply_form_privacy_before: "Your data is processed in accordance with our",
    apply_form_privacy_after: ". No spam, one-click unsubscribe.",
    not_found_title: "Page Not Found",
    not_found_message: "This page does not exist or is no longer accessible. Check the URL or return to the homepage.",
    not_found_back: "Back",
    not_found_home: "Home",
    portal_mycompany_collab_status_active: "Active",
    portal_mycompany_collab_status_pending: "Pending Invitation",
    portal_mycompany_collab_status_no_account: "No Account",
  
    join_beyond_membership_desc: "Membership is the gateway to the WineTech ecosystem. Members can then participate in initiatives and programs developed throughout the year.",
    apply_thanks_title: "Application sent",
    apply_thanks_intro: "Thank you! We've received your application and a confirmation email has just been sent.",
    apply_thanks_within: "Our team will get back to you within",
    apply_thanks_within_value: "48 business hours",
    apply_thanks_calendar_h: "Book your discovery meeting",
    apply_thanks_calendar_desc: "To speed things up, pick a <strong>30-min</strong> slot with our team directly in the calendar below.",
    apply_thanks_book_cta: "Pick a time slot",
    apply_thanks_no_calendar: "📅 We'll get back to you with a meeting slot proposal.",
    apply_thanks_back_home: "Back to home",
    apply_thanks_follow: "Follow La WineTech",
    apply_thanks_questions: "Any questions?",
    apply_field_website: "Website",
    apply_field_revenue: "Annual revenue (€)",
    apply_field_country: "Country *",
    apply_field_choose: "— Choose —",
    apply_toast_success: "Application sent!",
    apply_toast_error: "Submission error. Please retry or contact us.",
    apply_toast_error_short: "Submission error",
    apply_lang_label: "Language / Langue",
    application_validated_by: "Approved by {name} · on {date}",
    application_rejected_by: "Rejected by {name} · on {date}",
  },
  es: {
    res_dl_all: "Descargar todo ({n} archivos, ZIP)",
    res_dl_error: "Descarga imposible",
    res_dl_one: "Descargar",
    nl_invalid_email: "Email no válido",
    nl_success_toast: "¡Gracias! Te has suscrito al boletín",
    nl_confirmed: "Suscripción confirmada — ¡hasta muy pronto!",
    nl_card_title: "Mantente al tanto",
    nl_card_desc: "Recibe nuestro boletín mensual: próximos eventos, oportunidades, noticias de WineTech.",
    nl_email_ph: "tu@email.com",
    nl_subscribe: "Suscribirse",
    nl_gdpr: "Baja en 1 clic desde cada correo electrónico. Datos protegidos (RGPD).",
    media_copy_failed: "No se pudo copiar la URL — cópiala manualmente: {url}",
    unit_mb: "MB",
    unit_gb: "GB",
    media_load_error: "No se pudo cargar la mediateca",
    media_format_unsupported: "Formato no compatible. Aceptados: {formats}",
    media_too_large: "Archivo demasiado grande ({size}). Máximo: {max}.",
    media_published: "Vídeo publicado",
    media_upload_failed: "Fallo al subir",
    media_delete_confirm: "¿Eliminar el vídeo \"{title}\"?\n\nEsta acción es definitiva.",
    media_deleted: "Vídeo eliminado",
    media_url_copied: "URL pública copiada",
    media_meta_saved: "Metadatos guardados",
    media_title: "Mi mediateca",
    media_intro: "Aloje sus pitches, demos y vídeos de presentación. Las URL generadas pueden copiarse en sus noticias, eventos y ofertas de Le Club.",
    media_upload_btn: "Subir un vídeo",
    media_finalizing: "Finalizando…",
    media_uploading: "Subiendo — {pct}%",
    media_formats_label: "Formatos:",
    media_max_label: "Tamaño máximo:",
    media_hosting_label: "Alojamiento:",
    media_hosting_value: "almacenamiento seguro, reproducción optimizada para móvil",
    media_no_transcode: "Sin transcodificación",
    media_no_transcode_hint: "— exporte sus vídeos en formato web (MP4 H.264) antes de subirlos.",
    media_empty_title: "Su mediateca está vacía",
    media_empty_desc: "Suba su primer vídeo (pitch de 2 min, demo de producto o presentación).",
    media_edit: "Editar",
    media_edit_title: "Editar vídeo",
    media_field_title: "Título",
    media_field_desc: "Descripción",
    inv_status_paid: "Pagada",
    inv_status_open: "Pendiente",
    inv_status_pending: "Pago en curso",
    inv_status_draft: "Borrador",
    inv_status_void: "Anulada",
    inv_status_uncollectible: "Incobrable",
    inv_title: "Facturas",
    inv_my_title: "Mis facturas de Stripe",
    inv_empty: "Ninguna factura de Stripe por el momento.",
    inv_my_empty: "Ninguna factura de Stripe por el momento. Sus futuras cuotas y pagos de eventos aparecerán aquí.",
    inv_load_error: "No se pudieron cargar las facturas",
    inv_total_paid: "Total pagado:",
    inv_refresh_title: "Actualizar desde Stripe",
    inv_refresh: "Actualizar",
    inv_stripe_not_configured: "Stripe no está configurado en el servidor — solo las sesiones de pago locales son visibles.",
    inv_col_date: "Fecha",
    inv_col_number: "Número",
    inv_col_description: "Descripción",
    inv_col_amount: "Importe",
    inv_col_status: "Estado",
    inv_col_actions: "Acciones",
    inv_checkout_session: "Sesión de pago",
    inv_open_payment: "Abrir la página de pago",
    inv_view_stripe: "Ver factura de Stripe",
    inv_pay: "Pagar",
    inv_view: "Ver",
    inv_download_pdf: "Descargar PDF",
    proj_seo_title: "Proyectos WineTech — Iniciativas colectivas del sector vinícola",
    proj_seo_desc: "Descubra los proyectos y programas impulsados por La WineTech: agroecología, logística cero carbono, soberanía de datos… Los miembros que construyen el futuro del vino.",
    proj_badge: "Programas WineTech",
    proj_h1_a: "Los proyectos que dan forma",
    proj_h1_b: "al vino del mañana",
    proj_intro: "Cada proyecto reúne a miembros voluntarios en torno a un desafío estratégico: innovación, sostenibilidad, soberanía, nuevos usos. Explore, inspírese, únase a nosotros.",
    proj_empty: "Los proyectos WineTech llegarán pronto. ¡Vuelva pronto!",
    proj_tag: "Proyecto",
    proj_discover: "Descubrir",
    proj_not_found: "Proyecto no encontrado",
    proj_back: "Volver a los proyectos",
    proj_all: "Todos los proyectos",
    proj_tag_full: "Proyecto WineTech",
    proj_members_one: "{n} miembro implicado",
    proj_members_many: "{n} miembros implicados",
    proj_members_title: "Los miembros que impulsan el proyecto",
    proj_members_empty: "Sea el primer miembro en unirse a este proyecto.",
    exh_no_company: "Ninguna ficha de empresa vinculada a su cuenta.",
    exh_resynced: "Información resincronizada desde su ficha de empresa",
    exh_resync_error: "No se pudo resincronizar",
    exh_name_required: "Nombre de la empresa requerido",
    exh_choose_role: "Elija un rol",
    exh_validated: "Expositor validado",
    exh_submitted: "Solicitud enviada — pendiente de validación del administrador",
    exh_title: "Inscripción de Expositor",
    exh_company_card: "Ficha de empresa miembro",
    exh_resync_title: "Recargar la información desde su ficha de empresa miembro",
    exh_resync: "Resincronizar",
    exh_company_name: "Nombre de la empresa *",
    exh_role: "Su rol *",
    exh_select: "— Seleccionar —",
    exh_booth: "Nº de stand",
    exh_booth_ph: "ej: B12",
    exh_logo: "Logo (URL)",
    exh_desc: "Descripción corta",
    exh_desc_ph: "Presente su empresa en pocas palabras…",
    exh_fee_title: "Tarifa de inscripción de expositor",
    exh_secure_payment: "Pago seguro por Stripe. Su inscripción se validará automáticamente después del pago.",
    exh_free_title: "Inscripción gratuita",
    exh_auto_admin: "Validación automática (admin).",
    exh_review_team: "Su candidatura será revisada por el equipo de La WineTech.",
    exh_pay: "Pagar {price}",
    exh_confirm: "Confirmar inscripción",
    sidebar_member_shared_services: "Servicios compartidos",
    sidebar_member_media: "Mediateca",
    nav_formations: "Formaciones",
    nav_support_us: "Apóyenos",
    nav_opportunities: "Oportunidades",
    nav_community: "La Comunidad",
    newsletter_band_title: "Manténgase informado de las noticias de WineTech",
    newsletter_band_desc: "Próximos eventos, oportunidades, peticiones e innovaciones — 1 correo electrónico al mes, darse de baja en 1 clic.",
    newsletter_subscribe_aria: "Suscribirse a la newsletter",
    newsletter_later: "Más tarde",
    credit_dev_by: "Plataforma desarrollada gratuitamente por",
    credit_for: "para La WineTech.",
    nav_home: "Inicio",
    nav_news: "Noticias",
    nav_events: "Eventos",
    nav_members: "Miembros",
    nav_projects: "Proyectos",
    nav_about: "Acerca de",
    nav_contact: "Contacto",
    nav_back_to_site: "Volver al sitio",
    auto_translated: "Traducido automáticamente",
    loading: "Cargando...",
    news_title: "Revista de noticias",
    news_subtitle: "Toda la innovación del ecosistema WineTech: entrevistas, análisis, rondas de financiación y lanzamientos.",
    news_seo_title: "Noticias y análisis",
    news_seo_desc: "Últimas noticias, análisis e historias del ecosistema mundial de innovación vinícola — startups, tecnología, tendencias del mercado y anuncios de miembros.",
    news_search_placeholder: "Buscar noticias...",
    back_to_news: "Volver a noticias",
    related_articles: "Artículos relacionados",
    read_more: "Leer más",
    filter_all: "Todos",
    cat_innovation: "Innovación",
    cat_technology: "Tecnología",
    cat_startup: "Startup",
    cat_market: "Mercado",
    cat_digital: "Digital",
    cat_announcement: "Comunicado",
    events_title: "Eventos",
    events_subtitle: "Conferencias, webinars, afterworks, masterclasses: los encuentros de la comunidad WineTech.",
    events_seo_title: "Eventos",
    events_seo_desc: "Descubre los próximos eventos WineTech — conferencias, reuniones 1:1, talleres y encuentros de innovación a través del ecosistema vinícola global.",
    events_upcoming: "Próximos",
    events_past: "Pasados",
    events_all_formats: "Todos los formatos",
    events_format_physical: "Presencial",
    events_format_digital: "Digital",
    events_format_hybrid: "Híbrido",
    events_registered: "inscritos",
    back_to_events: "Volver a eventos",
    cta_join: "Unirse",
    cta_explore: "Explorar la comunidad",
    cta_see_events: "Ver eventos",
    cta_visit_website: "Visitar el sitio",
    hero_title_pre: "La comunidad",
    hero_title_brand: "WineTech",
    hero_subtitle: "Conectar talentos, compartir innovación y construir el futuro del vino.",
    innovate_together: "Innovemos juntos",
    actu: "Noticias",
    upcoming_events: "Próximos eventos",
    community_members: "Miembros de la comunidad",
    see_all_news: "Ver todas las noticias",
    see_all_events: "Ver todos los eventos",
    see_all_members: "Ver todos los miembros",
    learn_more: "Saber más",
    apply_now: "Postular",
    login: "Acceder",
    login_title: "Acceder",
    login_welcome_back: "Encantados de verte de nuevo.",
    login_loading: "Conectando...",
    login_no_account: "¿Aún no eres miembro?",
    login_create_account: "Crear cuenta",
    login_welcome_toast: "¡Bienvenido!",
    login_brand_title_pre: "Bienvenido a la",
    login_brand_title_brand: "comunidad WineTech",
    login_brand_subtitle: "Conéctate para acceder a tu espacio dedicado, tus reuniones y el directorio privado.",
    login_demo_accounts: "Cuentas demo (haz clic para rellenar):",
    login_demo_admin: "Admin",
    login_demo_member: "Miembro",
    login_demo_press: "Prensa",
    email: "Email",
    password: "Contraseña",
    register: "Registrarse",
    register_title: "Crear cuenta",
    register_loading: "Creando...",
    register_have_account: "¿Ya registrado?",
    register_first_name: "Nombre",
    register_last_name: "Apellido",
    register_submit: "Registrarse",
    logout: "Salir",
    forgot_password: "¿Olvidaste tu contraseña?",
    register_role_applicant: "Candidato (miembro)",
    register_role_event: "Visitante de evento",
    register_role_journalist: "Periodista / Prensa",
    register_company_or_media: "Empresa / Media",
    register_i_am: "Soy",
    register_brand_title_pre: "Únete a la",
    register_brand_subtitle: "Crea tu cuenta para postular, asistir a eventos o acceder al portal de prensa.",
    dashboard: "Panel",
    my_profile: "Mi perfil",
    portal_member: "Portal miembro",
    portal_press: "Portal prensa",
    portal_admin: "CRM Admin",
    apply_join: "Solicitar membresía",
    join_intro: "Únete al ecosistema WineTech global.",
    sidebar_member_dashboard: "Panel",
    sidebar_member_profile: "Perfil de empresa",
    sidebar_member_my_company: "Mi empresa",
    sidebar_member_score: "Mi puntuación",
    sidebar_member_notifications: "Notificaciones",
    sidebar_member_matchmaking: "Matchmaking",
    sidebar_member_products: "Productos y Servicios",
    sidebar_member_team: "Equipo",
    sidebar_member_news: "Publicaciones",
    sidebar_member_events: "Eventos",
    sidebar_member_directory: "Directorio",
    sidebar_member_meetings: "Reuniones",
    sidebar_member_messages: "Mensajes",
    sidebar_member_resources: "Recursos",
    sidebar_personal_profile: "Perfil personal",
    sidebar_admin_dashboard: "Panel",
    sidebar_admin_pipeline: "Pipeline CRM",
    sidebar_admin_members: "Miembros",
    sidebar_admin_applications: "Candidaturas",
    sidebar_admin_news: "Noticias",
    sidebar_admin_events: "Eventos",
    sidebar_admin_meetings: "Reuniones",
    sidebar_admin_analytics: "Analytics",
    sidebar_admin_settings: "Ajustes",
    sidebar_press_dashboard: "Panel",
    sidebar_press_releases: "Comunicados",
    sidebar_press_events: "Eventos",
    sidebar_press_members: "Miembros",
    sidebar_press_resources: "Recursos",
    sidebar_need_help: "¿Necesitas ayuda?",
    sidebar_help_text: "Nuestro equipo está aquí para ayudarte.",
    sidebar_contact_us: "Contáctanos",
    search: "Buscar",
    search_placeholder: "Buscar una empresa, una tecnología...",
    category: "Categoría",
    country: "País",
    all: "Todos",
    all_categories: "Todas las categorías",
    all_countries: "Todos los países",
    all_poles: "Todos los sectores",
    no_results: "Sin resultados.",
    no_members_found: "Ningún miembro encontrado. Modifica los filtros.",
    submit: "Enviar",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Añadir",
    close: "Cerrar",
    confirm: "Confirmar",
    publish: "Publicar",
    download: "Descargar",
    open: "Abrir",
    pending: "Pendiente",
    approved: "Aprobado",
    rejected: "Rechazado",
    draft: "Borrador",
    active: "Activo",
    published: "Publicado",
    archived: "Archivado",
    paid: "Pagado",
    pending_payment: "Pago pendiente",
    confirmed: "Confirmado",
    book_meeting: "Reservar reunión",
    exhibitors: "Expositores",
    matchmaking: "Matchmaking",
    register_for_event: "Inscribirse al evento",
    visitor: "Visitante",
    exhibitor: "Expositor",
    media: "Media / Prensa",
    free: "Gratis",
    speakers: "Ponentes",
    sponsors: "Patrocinadores",
    attendees: "Asistentes",
    check_in: "Check-in",
    pricing: "Tarifas",
    transactions: "Transacciones",
    about: "Sobre",
    expertise: "Experiencia",
    products_services: "Productos y Servicios",
    company_news: "Noticias",
    technologies: "Tecnologías",
    activities: "Actividades",
    founded_in: "Fundada en",
    employees: "empleados",
    active_member: "Miembro activo",
    tags: "Etiquetas",
    community_score: "Puntuación comunidad",
    points: "pts",
    back_to_members: "Volver a miembros",
    resources: "Recursos",
    press_releases: "Comunicados",
    media_kit: "Kit de prensa",
    welcome: "Bienvenido",
    success_saved: "Guardado con éxito",
    error_generic: "Ha ocurrido un error",
    footer_intro: "La WineTech conecta los talentos de la innovación vinícola en todo el mundo. Una comunidad única para compartir, aprender, colaborar.",
    footer_platform: "Plataforma",
    footer_spaces: "Espacios",
    footer_rights: "Todos los derechos reservados.",
    footer_made_with: "Hecho con ♥ para la industria del vino.",
    members_directory_intro: "Descubre todos los actores de la innovación WineTech, sus especialidades y tecnologías.",
    portal_exhibitormatchmaking_01: "Franjas disponibles",
    portal_exhibitormatchmaking_02: "Ninguna franja disponible para este contacto.",
    portal_matchmaking_01: "Sugeridos:",
    portal_matchmaking_02: "y lo que usted",
    portal_matchmaking_03: ". La plataforma le conecta automáticamente con los mejores perfiles.",
    portal_matchmaking_04: "Sus experticias, servicios, tecnologías, mercados a los que se dirige.",
    portal_matchmaking_05: "Asociaciones, tecnologías, recursos, mercados a los que desea acceder.",
    portal_memberdashboard_01: "Aquí tiene un resumen de su actividad en la comunidad WineTech.",
    portal_memberdashboard_02: "Mi empresa",
    portal_memberdashboard_03: "Ninguna empresa asociada.",
    portal_memberdashboard_04: "Completar mi perfil →",
    portal_memberdashboard_05: "Próximos eventos",
    portal_memberdashboard_06: "Ver todo",
    portal_memberdashboard_07: "Desarrolle su visibilidad en la comunidad",
    portal_memberdashboard_08: "Publique noticias, participe en eventos, concierte citas con otros actores.",
    portal_memberdashboard_09: "Publicar una noticia",
    portal_memberdirectory_01: "Descubra y conéctese con otros miembros de la comunidad.",
    portal_memberdirectory_02: "Más recientes primero",
    portal_memberevents_01: "Eventos",
    portal_memberevents_02: "Inscríbase en los próximos eventos de la comunidad.",
    portal_memberevents_03: "Próximos",
    portal_memberevents_04: "Pasados",
    portal_memberevents_05: "Todas las audiencias",
    portal_memberevents_06: "Fecha más próxima",
    portal_memberevents_07: "Fecha más lejana",
    portal_memberevents_08: "Publicado recientemente",
    portal_memberevents_09: "Publicado hace tiempo",
    portal_membermeetings_01: "Mis citas",
    portal_membermeetings_02: "Gestione sus citas, su disponibilidad y su agenda de Reuniones 1:1.",
    portal_membermeetings_03: "Mi agenda de Reuniones 1:1",
    portal_membermeetings_04: "Descubra los eventos",
    portal_membermeetings_05: "y reserve su próxima cita.",
    portal_membermeetings_06: "Mis eventos como expositor",
    portal_membermeetings_07: "Seleccione las franjas horarias en las que está disponible para reunirse con visitantes. Solo las franjas marcadas estarán disponibles para reserva.",
    portal_membermeetings_08: "Validado",
    portal_membermeetings_09: "⚠️ Ninguna franja seleccionada. Los visitantes no pueden reservar hasta que haya indicado su disponibilidad.",
    portal_membermeetings_10: "Mi disponibilidad",
    portal_membermessages_01: "Conversaciones privadas con la comunidad.",
    portal_membermessages_02: "Seleccione una conversación.",
    portal_membernews_01: "Mis noticias",
    portal_membernews_02: "Envíe sus noticias, lanzamientos, rondas de financiación.",
    portal_membernews_03: "Validación requerida por el equipo de La WineTech",
    portal_membernews_04: "Su noticia será revisada por un administrador. Plazo de validación:",
    portal_membernews_05: "24 a 72h",
    portal_membernews_06: "Enviar para validación",
    portal_membernews_07: "Categoría",
    portal_membernews_08: "Ninguna noticia publicada por el momento.",
    portal_memberproducts_01: "Ninguna empresa asociada.",
    portal_memberproducts_02: "Escaparate de sus ofertas en el ecosistema WineTech.",
    portal_memberproducts_03: "Video",
    portal_memberproducts_04: "Demo",
    portal_memberproducts_05: "Ningún producto ni servicio publicado.",
    portal_memberprofile_01: "Cuide su perfil para ganar visibilidad en el ecosistema.",
    portal_memberprofile_02: "Ver mi perfil público",
    portal_memberprofile_03: "Publicar una noticia",
    portal_memberprofile_04: "Completitud",
    portal_memberprofile_05: "Mis eventos",
    portal_memberprofile_06: "Ver todo →",
    portal_memberprofile_07: "Ningún evento próximo.",
    portal_memberprofile_08: "Descubrir los eventos →",
    portal_memberprofile_09: "Mis publicaciones",
    portal_memberprofile_10: "Gestionar →",
    portal_memberprofile_11: "Comparta sus novedades con la comunidad WineTech para aumentar su visibilidad.",
    portal_memberprofile_12: "Descripción larga (Markdown)",
    portal_memberprofile_13: "Sector principal",
    portal_memberprofile_14: "Etiquetas especiales",
    portal_memberprofile_15: "Actividades secundarias",
    portal_memberprofile_16: "Mercados objetivo",
    portal_memberprofile_17: "Ayude al ecosistema a encontrarle — elija todas las etiquetas que se apliquen a su actividad. Filtrables en el directorio y utilizadas en los perfiles de eventos.",
    portal_memberresources_01: "Descargar",
    portal_memberteam_01: "Ninguna empresa asociada.",
    portal_memberteam_02: "Equipo",
    portal_memberteam_03: "Gestione a los colaboradores de su empresa y sus roles.",
    portal_memberteam_04: "Invitación creada ✓",
    portal_memberteam_05: "Contraseña temporal",
    portal_memberteam_06: "(para transmitir manualmente — el correo de invitación de Brevo se conectará en una próxima iteración):",
    portal_memberteam_07: "Invitar a otro colaborador",
    portal_memberteam_08: "Rol",
    portal_mycompany_01: "Mi empresa",
    portal_mycompany_02: "Complete la información de su perfil de empresa y gestione a sus colaboradores.",
    portal_mycompany_03: "El",
    portal_mycompany_04: "se muestra en todas partes (directorio, eventos, visuales, credenciales). La",
    portal_mycompany_05: "entidad legal",
    portal_mycompany_06: "se utiliza únicamente para la facturación de Stripe.",
    portal_mycompany_07: "Mostrado en todos los soportes públicos",
    portal_mycompany_08: "Entidad legal (facturación)",
    portal_mycompany_09: "Utilizada para Stripe y facturas",
    portal_mycompany_10: "Solo el contacto principal puede modificar esta información",
    portal_mycompany_11: "Añadir un colaborador",
    portal_mycompany_12: "Definir como contacto principal",
    portal_mycompany_13: "Ningún colaborador. Añada a su equipo para aprovechar al máximo las ventajas de La WineTech.",
    portal_myeventpage_01: "← Mi portal",
    portal_myeventpage_02: "Darse de baja",
    portal_myeventpage_03: "Ver página pública",
    portal_myeventpage_04: "Aún no está inscrito/a en este evento.",
    portal_myeventpage_05: "Vaya a la",
    portal_myeventpage_06: "para inscribirse.",
    portal_myeventpage_07: "🎥 Evento en línea",
    portal_myeventpage_08: "Código de acceso:",
    portal_myeventpage_09: "Unirse a la videollamada →",
    portal_myeventpage_10: "Paso 1",
    portal_myeventpage_11: "Descargue su credencial",
    portal_myeventpage_12: "Preséntela en la recepción el día del evento.",
    portal_myeventpage_13: "Descargar PDF",
    portal_myeventpage_14: "Paso 2",
    portal_myeventpage_15: "Ver la sección ↓",
    portal_myeventpage_16: "El día del evento",
    portal_myeventpage_17: "Mis disponibilidades de Reuniones 1:1",
    portal_myeventpage_18: "Está inscrito/a como expositor/a",
    portal_myeventpage_19: "Marque las franjas horarias en las que estará disponible para reunirse con los visitantes. Solo las franjas marcadas estarán disponibles para reserva.",
    portal_myeventpage_20: "Validado",
    portal_myeventpage_21: "Ningún horario seleccionado — los visitantes no pueden reservarle.",
    portal_myeventpage_22: "Vista completa del calendario",
    portal_myeventpage_23: "Ningún expositor validado por el momento. Vuelva más tarde ⏳",
    portal_myeventpage_24: "Mis citas confirmadas",
    portal_myscore_01: "Mi puntuación de comunidad",
    portal_myscore_02: "Su compromiso con la comunidad WineTech, calculado según criterios transparentes.",
    portal_myscore_03: "Cuanto más contribuye, mayor es su visibilidad",
    portal_myscore_04: "Detalle de los puntos",
    portal_myscore_05: "Complete su ficha de empresa (logo, descripción, sitio web) — ganancia inmediata.",
    portal_myscore_06: "Indique LinkedIn y un enlace de calendario para cada colaborador.",
    portal_myscore_07: "Publique sus noticias a través de su portal de miembro.",
    portal_myscore_08: "Regístrese y participe en los eventos de la comunidad.",
    portal_myscore_09: "Añada a sus colaboradores desde la página «Mi empresa» (Mon entreprise).",
    portal_notifications_01: "Todo lo que sucede en su comunidad, de un vistazo.",
    portal_notifications_02: "Preferencias de correo electrónico",
    portal_notifications_03: "Para cada categoría, elija si desea recibir un correo electrónico además de la notificación en la aplicación.",
    portal_notifications_04: "Ninguna notificación por el momento.",
    portal_notifications_05: "Ver →",
    portal_personalprofile_01: "Mi perfil personal",
    portal_personalprofile_02: "Actualice su información personal, su foto y su agenda pública.",
    portal_personalprofile_03: "Identidad",
    portal_personalprofile_04: "Nombre",
    portal_personalprofile_05: "Teléfono",
    portal_personalprofile_06: "Calendly, Cal.com, Google Agenda… este enlace se propondrá para reservar citas con usted.",
    press_pressdashboard_01: "Bienvenido a su espacio de prensa WineTech. Acceda a las últimas noticias de la comunidad.",
    press_pressdashboard_02: "Acceso de periodista aprobado",
    press_pressdashboard_03: "Tiene acceso completo a todas las noticias de la plataforma.",
    press_pressdashboard_04: "Ver mi perfil",
    press_pressdashboard_05: "Últimas noticias",
    press_pressdashboard_06: "Categorías",
    press_pressdashboard_07: "Todas las categorías",
    press_pressdashboard_08: "Nuestro equipo de prensa está a su disposición para cualquier consulta.",
    press_pressevents_01: "Eventos",
    press_pressevents_02: "Acceda a todos los eventos de la comunidad WineTech.",
    press_pressevents_03: "Próximos",
    press_pressevents_04: "Pasados",
    press_pressevents_05: "Fecha más cercana",
    press_pressevents_06: "Fecha más lejana",
    press_pressevents_07: "Publicado recientemente",
    press_pressevents_08: "Publicado hace tiempo",
    press_pressmembers_01: "Descubra los actores de la innovación vinícola.",
    press_pressmembers_02: "Más recientes primero",
    press_pressreleases_01: "Comunicados de prensa",
    press_pressreleases_02: "Más recientes primero",
    press_pressreleases_03: "Ningún comunicado por el momento.",
    press_pressresources_01: "Kit de medios y recursos",
    press_pressresources_02: "Logotipos, fotos oficiales, comunicados y informes.",
    press_pressresources_03: "Descargar",
    layout_publiclayout_01: "📝 Enviar mi solicitud",
    layout_publiclayout_02: "¿Necesita un CRM, un portal de clientes, un extranet, una aplicación empresarial o una plataforma SaaS a medida para impulsar su desarrollo?",
    portal_mycompany_readonly: "Está viendo este perfil de solo lectura. Solo el contacto principal (o un administrador) puede modificar esta información. Pida a su contacto principal que active la opción «Permitir que otros colaboradores editen» en esta página.",
  
    portal_exhibitormatchmaking_90: "Cargando...",
    portal_memberdashboard_90: "Noticias publicadas",
    portal_memberdashboard_91: "Eventos unidos",
    portal_memberdashboard_92: "Vistas de tu perfil",
    portal_memberdashboard_93: "Editar",
    portal_memberevents_90: "Buscar un evento, una ciudad…",
    portal_membermeetings_90: "Añadir",
    portal_membermessages_90: "Nuevo mensaje",
    portal_membermessages_91: "Tu respuesta…",
    portal_membermessages_92: "Enviar",
    portal_membermessages_93: "Buscar un miembro, admin, prensa…",
    portal_membermessages_94: "Tu mensaje…",
    portal_membernews_90: "Imagen de portada",
    portal_memberproducts_90: "Descripción detallada",
    portal_memberproducts_91: "URL de vídeo de YouTube/Vimeo",
    portal_memberproducts_92: "URL de demostración",
    portal_memberproducts_93: "Añadir",
    portal_memberproducts_94: "Eliminar",
    portal_memberprofile_90: "Identidad",
    portal_memberprofile_91: "Banner (16:5 recomendado)",
    portal_memberprofile_92: "Año de creación",
    portal_memberprofile_93: "Presentación",
    portal_memberprofile_94: "Redes sociales",
    portal_memberteam_90: "Nombre",
    portal_memberteam_91: "Enviar invitación",
    portal_memberteam_92: "Ningún colaborador.",
    portal_mycompany_90: "Cargando…",
    portal_mycompany_91: "Email de contacto",
    portal_mycompany_92: "Teléfono",
    portal_mycompany_93: "Descripción / presentación",
    portal_mycompany_94: "Logotipo (cuadrado, 512×512 recomendado)",
    portal_mycompany_95: "Banner (16:9, 1600×900 recomendado)",
    portal_mycompany_96: "Guardar",
    portal_mycompany_97: "Nombre *",
    portal_mycompany_98: "Añadir y enviar invitación",
    portal_mycompany_99: "Cancelar",
    portal_mycompany_100: "Reenviar",
    portal_mycompany_101: "Invitar",
    portal_myeventpage_90: "Cargando…",
    portal_myscore_90: "Cargando…",
    portal_personalprofile_90: "Cargando...",
    portal_personalprofile_91: "Importar una foto (JPG/PNG, ≤ 5 MB)",
    portal_personalprofile_92: "Unas líneas para presentarte…",
    layout_portallayout_90: "Cerrar menú",
    layout_portallayout_91: "Abrir menú",
    layout_publiclayout_90: "Descubrir la adhesión a La WineTech",
    layout_publiclayout_91: "Presentar mi candidatura",
  
    sidebar_help_mode_emploi: "Modo de empleo",
    sidebar_admin_prospects: "Prospectos",
    sidebar_admin_contacts: "Contactos",
    sidebar_admin_formations: "Formaciones",
    sidebar_admin_checkin_qr: "Check-in (QR)",
    sidebar_admin_administrators: "Administradores",
    sidebar_admin_emails: "Correos electrónicos",
    sidebar_admin_mailshot: "Mailshot CRM",
    sidebar_admin_scoring: "Scoring",
    sidebar_admin_renewals: "Renovaciones",
    sidebar_admin_activity_log: "Registro de actividad",
    sidebar_admin_ai_feedback: "Feedback de IA",
    subtitle_admin: "Admin",
    subtitle_press: "Innovación y Compartir",
    subtitle_member: "Comunidad e Innovación",
    user_label_default: "Usuario",
    role_admin: "Administrador",
    role_member: "Miembro",
    role_press: "Prensa",
    role_applicant: "Candidato",
    role_event_visitor: "Visitante del evento",
    role_journalist: "Periodista",
    title_admin_dashboard: "Panel de administración",
    title_press_portal: "Portal de Prensa",
    title_member_portal: "Portal de Miembro",
  
    portal_mycompany_section_title: "Ficha de empresa",
    portal_mycompany_name_label: "Nombre comercial *",
    portal_mycompany_legal_label: "Razón social",
    portal_mycompany_name_term: "nombre comercial",
    portal_mycompany_legal_term: "razón social",
    portal_mycompany_name_placeholder: "Ej: VineaTech",
    portal_mycompany_legal_placeholder: "Ej: VineaTech SAS",
    portal_mycompany_vat_placeholder: "N.º IVA intracom.",
    portal_mycompany_website_placeholder: "Sitio web",
    portal_mycompany_city_placeholder: "Ciudad",
    portal_mycompany_collaborators_title: "Colaboradores",
    portal_mycompany_email_required_placeholder: "Email *",
    portal_mycompany_lastname_required_placeholder: "Apellido *",
    portal_mycompany_jobtitle_placeholder: "Puesto",
    portal_mycompany_linkedin_placeholder: "URL de LinkedIn",
    portal_mycompany_calendar_placeholder: "Enlace del calendario (Calendly, Google…)",
    portal_mycompany_primary_badge: "Principal",
    image_upload_replace: "Reemplazar",
    image_upload_loading: "Cargando…",
    search_button: "Buscar",
    common_required: "(obligatorio)",
  
    comp_aboutpage_90: "Acerca de La WineTech",
    comp_aboutpage_91: "Acerca de La WineTech",
    comp_aboutpage_92: "Nuestra misión",
    comp_aboutpage_93: "El ecosistema",
    comp_activateaccount_90: "Activar mi cuenta",
    comp_activateaccount_91: "Verificando el enlace…",
    comp_activateaccount_92: "Solicitar un nuevo enlace",
    comp_activateaccount_93: "¡Cuenta activada!",
    comp_activateaccount_94: "Redirigiendo a la página de inicio de sesión…",
    comp_activateaccount_95: "Activar su cuenta",
    comp_activateaccount_96: "Elija una contraseña para completar la activación.",
    comp_activateaccount_97: "Contraseña (6+ caracteres)",
    comp_activateaccount_98: "Confirmar contraseña",
    comp_applypage_90: "Solicitar | La WineTech",
    comp_applypage_91: "La WineTech",
    comp_applypage_92: "Unirse a la comunidad",
    comp_applypage_93: "3 minutos para presentarnos su proyecto. Nuestro equipo se pondrá en contacto con usted en un plazo de 48 h.",
    comp_applypage_94: "Sus datos personales. Tratamos sus datos de acuerdo con el RGPD.",
    comp_applypage_95: "Nombre *",
    comp_applypage_96: "Teléfono",
    comp_applypage_97: "Su LinkedIn",
    comp_applypage_98: "Acepto recibir comunicaciones de La WineTech (eventos, oportunidades, newsletter). Puedo darme de baja en cualquier momento.",
    comp_applypage_99: "Acerca de su estructura",
    comp_applypage_100: "Esta información nos permite evaluar su perfil y la cuota adecuada.",
    comp_applypage_101: "Nombre de la empresa *",
    comp_applypage_102: "Su cargo",
    comp_applypage_103: "Adaptamos la cuota al tamaño de su estructura.",
    comp_applypage_104: "Categoría *",
    comp_applypage_105: "Tipo(s) de innovación / intereses",
    comp_applypage_106: "Presente su estructura en pocas líneas *",
    comp_applypage_107: "¿Cuál es su actividad? ¿Cuáles son sus principales desafíos?",
    comp_applypage_108: "Último paso",
    comp_applypage_109: "Ayúdenos a entender lo que espera de La WineTech.",
    comp_applypage_110: "Lo que le interesa prioritariamente *",
    comp_applypage_111: "💡 Próximos pasos",
    comp_applypage_112: "Estudiaremos su candidatura en un plazo de 48 horas laborables",
    comp_applypage_113: "Recibirá una confirmación por correo electrónico de inmediato",
    comp_applypage_114: "Si es elegible, se le propondrá una franja horaria para una conversación",
    comp_applypage_115: "política de privacidad",
    comp_applythankspage_90: "Solicitud enviada | La WineTech",
    comp_applythankspage_91: "48 h laborables",
    comp_applythankspage_92: "Reserve su cita de descubrimiento",
    comp_applythankspage_93: "Siga a La WineTech",
    comp_applythankspage_94: "¿Alguna pregunta?",
    comp_billingpage_90: "Información de facturación enviada",
    comp_billingpage_91: "Nuestro equipo procederá ahora a emitir su factura. Próximamente recibirá un correo electrónico con el enlace de pago seguro de Stripe.",
    comp_billingpage_92: "¡Su solicitud para",
    comp_billingpage_93: "Número de IVA",
    comp_billingsuccess_90: "Confirmación del pago…",
    comp_billingsuccess_91: "Bienvenido a",
    comp_billingsuccess_92: "la comunidad",
    comp_billingsuccess_93: "Su pago de",
    comp_billingsuccess_94: "está confirmado. Nuestro equipo finalizará su incorporación y se pondrá en contacto con usted rápidamente para su llamada de bienvenida.",
    comp_billingsuccess_95: "Acceder a mi espacio",
    comp_billingsuccess_96: "Stripe está procesando su pago. Recibirá un email en cuanto se confirme.",
    comp_billingsuccess_97: "Error",
    comp_billingsuccess_98: "No se pudo verificar el pago. Contacte con el equipo.",
    comp_contactpage_90: "¿Una pregunta, un proyecto, una candidatura? Escríbanos y nuestro equipo le responderá en menos de 48 horas.",
    comp_contactpage_91: "¡Mensaje recibido!",
    comp_contactpage_92: "Nuestro equipo ha recibido su mensaje y se pondrá en contacto con usted muy pronto.",
    comp_contactpage_93: "Enviar otro mensaje",
    comp_contactpage_94: "Nombre *",
    comp_contactpage_95: "Teléfono",
    comp_contactpage_96: "— Sector de actividad (opcional) —",
    comp_contactpage_97: "Su mensaje *",
    comp_contactpage_98: "Acepto que mis datos sean registrados por La WineTech para procesar mi solicitud (de acuerdo con el RGPD). Mis datos nunca serán vendidos.",
    comp_contactpage_99: "O escríbanos directamente a",
    comp_digestsubscribepage_90: "¡Tomado nota!",
    comp_digestsubscribepage_91: "Recibirá su primer Weekly Digest el próximo jueves a las 9h. Podrá modificar sus preferencias o darse de baja desde cada email.",
    comp_digestsubscribepage_92: "Cada jueves a las 9h, reciba lo esencial de WineTech según sus intereses — noticias de los miembros, innovaciones, ciencia, normativa y próximos eventos.",
    comp_digestsubscribepage_93: "Nombre",
    comp_digestsubscribepage_94: "🇫🇷 Francés",
    comp_digestsubscribepage_95: "🇵🇹 Portugués",
    comp_digestsubscribepage_96: "Centros de interés",
    comp_digestsubscribepage_97: "— todo marcado por defecto",
    comp_eventdetail_90: "Cargando...",
    comp_eventdetail_91: "Ha iniciado sesión como",
    comp_eventdetail_92: "← Volver a mi espacio",
    comp_eventdetail_93: "📄 Catálogo del evento",
    comp_eventdetail_94: "PDF completo con la lista de expositores, visitantes y ponentes — actualizado en tiempo real.",
    comp_eventdetail_95: "Ver las citas",
    comp_eventdetail_96: "¿Quién estará?",
    comp_eventdetail_97: "Lista pública de inscritos confirmados — venga a conocer a estos miembros y expositores de la comunidad WineTech.",
    comp_eventdetail_98: "Inscripción confirmada",
    comp_eventdetail_99: "¿Confirmar la baja?",
    comp_eventdetail_100: "Confirmar",
    comp_eventdetail_101: "Cancelar",
    comp_eventdetail_102: "¿Ya es miembro?",
    comp_eventdetail_103: "¡Inscripción confirmada!",
    comp_eventdetail_104: "activar su cuenta",
    comp_eventdetail_105: "Descargar mi credencial PDF",
    comp_eventdetail_106: "Inscripción al evento",
    comp_eventdetail_107: "💳 Tras este formulario, será redirigido a la página de pago segura de Stripe. Su credencial se emitirá una vez finalizado el pago.",
    comp_eventdetail_108: "— Gratuito. Su credencial se emitirá inmediatamente.",
    comp_eventdetail_109: "Nombre *",
    comp_eventdetail_110: "Empresa",
    comp_eventdetail_111: "Teléfono",
    comp_eventdetail_112: "Se le creará automáticamente una cuenta personal (se enviará un email de activación) para que pueda acceder a su credencial y participar en las reuniones rápidas.",
    comp_eventdetail_113: "Buscar un nombre, empresa, producto…",
    comp_eventdetail_114: "Ordenar: Nombre A→Z",
    comp_eventdetail_115: "Ordenar: Empresa A→Z",
    comp_eventdetail_116: "Ordenar: Perfiles más ricos",
    comp_eventpaymentsuccess_90: "Verificando pago…",
    comp_eventpaymentsuccess_91: "¡Pago confirmado!",
    comp_eventpaymentsuccess_92: "Su inscripción ha sido validada. Aquí tiene su credencial.",
    comp_eventpaymentsuccess_93: "El pago está tardando más de lo esperado. Recibirá un email de confirmación tan pronto como se valide.",
    comp_eventpaymentsuccess_94: "Volver al evento",
    comp_eventpaymentsuccess_95: "Pago no confirmado",
    comp_eventpaymentsuccess_96: "Ha ocurrido un error. Si se le ha cobrado, contáctenos.",
    comp_eventslist_90: "Buscar un evento, una ciudad…",
    comp_eventslist_91: "Fecha más cercana",
    comp_eventslist_92: "Fecha más lejana",
    comp_eventslist_93: "Publicado recientemente",
    comp_eventslist_94: "Publicado hace mucho tiempo",
    comp_exhibitorpaymentsuccess_90: "Verificando pago…",
    comp_exhibitorpaymentsuccess_91: "¡Inscripción de expositor confirmada!",
    comp_exhibitorpaymentsuccess_92: "Su pago ha sido procesado correctamente. Ahora está validado(a) como expositor para estas Reuniones 1:1.",
    comp_exhibitorpaymentsuccess_93: "Siguiente paso:",
    comp_exhibitorpaymentsuccess_94: "diríjase a su",
    comp_exhibitorpaymentsuccess_95: "espacio del evento",
    comp_exhibitorpaymentsuccess_96: "para",
    comp_exhibitorpaymentsuccess_97: "seleccionar sus franjas horarias de disponibilidad",
    comp_exhibitorpaymentsuccess_98: "Gestionar mi disponibilidad",
    comp_exhibitorpaymentsuccess_99: "Volver al evento",
    comp_exhibitorpaymentsuccess_100: "Pago no confirmado",
    comp_exhibitorpaymentsuccess_101: "El pago no pudo ser verificado. Si ya ha pagado, el webhook de Stripe finalizará la inscripción en unos minutos.",
    comp_forgotpassword_90: "¿Ha olvidado su contraseña?",
    comp_forgotpassword_91: "Introduzca su email. Si existe una cuenta, recibirá un enlace de restablecimiento válido por 1 hora.",
    comp_forgotpassword_92: "Email enviado",
    comp_formationdetail_90: "Cargando…",
    comp_formationdetail_91: "Enlace de conexión (inscritos)",
    comp_formationdetail_92: "Contraseña:",
    comp_formationdetail_93: "Nombre *",
    comp_formationslist_90: "Formaciones La WineTech Academy",
    comp_formationslist_91: "Sesiones para mejorar sus habilidades en el mundo del vino y las tecnologías asociadas.",
    comp_formationslist_92: "Buscar una formación…",
    comp_formationslist_93: "Ninguna formación por el momento.",
    comp_home_90: "la comunidad WineTech",
    comp_home_91: "Intercambie, colabore y participe en la construcción del futuro del vino.",
    comp_joinpage_90: "Unirse a La WineTech | Adhesión y Cuotas",
    comp_joinpage_91: "Únase al ecosistema internacional de",
    comp_joinpage_92: "ecosistema de innovación",
    comp_joinpage_93: "La base común",
    comp_joinpage_94: "Sea cual sea su categoría de adhesión, usted se beneficia de estas ventajas.",
    comp_joinpage_95: "Elija su categoría",
    comp_joinpage_96: "Cada perfil se beneficia de ventajas complementarias diseñadas para su profesión.",
    comp_joinpage_97: "Como complemento a la base común",
    comp_joinpage_98: "Calcule su",
    comp_joinpage_99: "Indique su categoría y su facturación anual para descubrir su tarifa de adhesión estimada. No se requiere la creación de una cuenta.",
    comp_joinpage_100: "Categoría",
    comp_joinpage_101: "Cuota anual indicativa — sujeta a la validación de nuestro comité.",
    comp_joinpage_102: "Más allá de la membresía",
    comp_joinpage_103: "Nuestro comité estudiará su candidatura y le responderá en un plazo de 5 días hábiles.",
    comp_joinpage_104: "¿Ya es candidato/a? Iniciar sesión",
    comp_leaderboard_90: "Miembros destacados de La WineTech",
    comp_leaderboard_91: "Los actores más comprometidos con la comunidad cada mes.",
    comp_leaderboard_92: "Clasificación en curso.",
    comp_leaderboard_93: "Lo que dicen nuestros miembros",
    comp_memberprofile_90: "Ha iniciado sesión como",
    comp_memberprofile_91: "← Volver a mi espacio",
    comp_memberprofile_92: "Vídeo",
    comp_memberprofile_93: "Demo",
    comp_memberprofile_94: "Conecte directamente con el equipo.",
    comp_memberprofile_95: "Teléfono",
    comp_memberprofile_96: "Reservar una cita",
    comp_membersdirectory_90: "Más recientes primero",
    comp_newslist_90: "Más recientes primero",
    comp_publicmeetingrequest_90: "Solicitar una cita",
    comp_publicmeetingrequest_91: "¡Solicitud enviada!",
    comp_publicmeetingrequest_92: "Nuestro equipo le responderá muy pronto a",
    comp_publicmeetingrequest_93: ". ¡Hasta pronto! 🍷",
    comp_publicmeetingrequest_94: "Su nombre *",
    comp_publicmeetingrequest_95: "Teléfono",
    comp_publicmeetingrequest_96: "Empresa",
    comp_publicmeetingrequest_97: "Asunto de la cita *",
    comp_publicmeetingrequest_98: "Fecha deseada (opcional)",
    comp_publicmeetingrequest_99: "Presente brevemente su solicitud, su actividad, sus expectativas…",
    comp_publicmeetingrequest_100: "Al enviar este formulario, acepta que su información sea utilizada por el equipo de La WineTech para ponerse en contacto con usted. Consulte nuestra política de privacidad.",
    comp_renewalform_90: "Pago cancelado. Puede intentarlo de nuevo a continuación.",
    comp_renewalform_91: "Cargando…",
    comp_renewalform_92: "Enlace no válido o caducado. Contacte con La WineTech.",
    comp_renewalform_93: "Su respuesta ha sido registrada. Estaremos encantados de seguir conversando con usted.",
    comp_renewalform_94: "Redirigiendo al pago…",
    comp_renewalform_95: "Puntuación global (sobre 5)",
    comp_renewalform_96: "Su comentario",
    comp_renewalform_97: "Sus comentarios sobre el año transcurrido…",
    comp_renewalform_98: "Sirve para calcular automáticamente su cuota según la tabla de La WineTech.",
    comp_renewalform_99: "Cargado",
    comp_renewalform_100: "Método de pago",
    comp_resetpassword_90: "El enlace de restablecimiento está incompleto o ha caducado.",
    comp_resetpassword_91: "Solicitar un nuevo enlace",
    comp_resetpassword_92: "Nueva contraseña",
    comp_resetpassword_93: "Elija una contraseña de al menos 8 caracteres.",
    comp_resetpassword_94: "Confirmar contraseña",
    comp_resetpassword_95: "Contraseña actualizada",
    comp_resetpassword_96: "Será redirigido/a a la página de inicio de sesión…",
    press_pressdashboard_90: "Próximos eventos",
    press_pressdashboard_91: "Comunicados",
    press_pressdashboard_92: "Buscar noticias...",
    press_pressevents_90: "Buscar un evento, una ciudad…",
    press_pressmembers_90: "Buscar un miembro, ciudad, tecnología…",
  
    join_seg_startups_name: "Startups e Innovación",
    join_seg_startups_desc: "Jóvenes empresas innovadoras que desarrollan soluciones para el sector vitivinícola.",
    join_seg_startups_extra_1: "Visibilidad ante productores, socios y actores del sector",
    join_seg_startups_extra_2: "Acceso a inversores y socios del ecosistema",
    join_seg_startups_extra_3: "Oportunidades de experimentación sobre el terreno",
    join_seg_startups_extra_4: "Posibilidad de integrarse en programas de aceleración e iniciativas colectivas",
    join_seg_startups_extra_5: "Participación en grupos de trabajo y proyectos colaborativos",
    join_seg_experts_name: "Expertos y Consultores",
    join_seg_experts_desc: "Consultoras, expertos independientes y asesores especializados.",
    join_seg_experts_extra_1: "Inclusión como experto del ecosistema",
    join_seg_experts_extra_2: "Valoración de conocimientos y experiencias",
    join_seg_experts_extra_3: "Participación en grupos de trabajo y proyectos temáticos",
    join_seg_experts_extra_4: "Oportunidades de colaboración con los miembros del ecosistema",
    join_seg_producteurs_name: "Productores",
    join_seg_producteurs_desc: "Bodegas, cooperativas, casas de comercio y productores comprometidos con la innovación.",
    join_seg_producteurs_extra_1: "Seguimiento de las innovaciones del sector",
    join_seg_producteurs_extra_2: "Descubrimiento de startups y soluciones miembros",
    join_seg_producteurs_extra_3: "Oportunidades de experimentación y colaboración",
    join_seg_producteurs_extra_4: "Posibilidad de participar en programas de aceleración temáticos",
    join_seg_producteurs_extra_5: "Participación en proyectos colectivos impulsados por WineTech",
    join_seg_fournisseurs_name: "Comunicación, Equipamiento y Distribución",
    join_seg_fournisseurs_desc: "Proveedores de soluciones, fabricantes de equipos, distribuidores y prestadores de servicios del sector.",
    join_seg_fournisseurs_extra_1: "Valoración de las soluciones y servicios ofrecidos",
    join_seg_fournisseurs_extra_2: "Visibilidad ante productores y startups",
    join_seg_fournisseurs_extra_3: "Participación en proyectos colaborativos",
    join_seg_fournisseurs_extra_4: "Integración en las iniciativas colectivas del ecosistema",
    join_seg_ecoles_name: "Institutos y Escuelas",
    join_seg_ecoles_desc: "Centros educativos, centros de investigación, laboratorios y organismos de formación.",
    join_seg_ecoles_extra_1: "Valoración de proyectos pedagógicos y científicos",
    join_seg_ecoles_extra_2: "Conexión con empresas y startups del sector",
    join_seg_ecoles_extra_3: "Participación en proyectos colaborativos",
    join_seg_ecoles_extra_4: "Contribución a las reflexiones y trabajos del ecosistema",
    join_seg_partenaires_name: "Socios",
    join_seg_partenaires_desc: "Instituciones, interprofesionales, organizaciones profesionales y empresas que desean apoyar de forma sostenible el ecosistema WineTech.",
    join_seg_partenaires_extra_1: "Visibilidad institucional reforzada",
    join_seg_partenaires_extra_2: "Participación en las orientaciones estratégicas de la asociación",
    join_seg_partenaires_extra_3: "Apoyo a los programas estructurantes del sector",
    join_seg_partenaires_extra_4: "Presencia privilegiada en los eventos WineTech",
    join_seg_partenaires_extra_5: "Participación en las iniciativas colectivas impulsadas por WineTech",
    join_common_1: "Perfil de miembro en la plataforma WineTech",
    join_common_2: "Presencia en el directorio de miembros",
    join_common_3: "Acceso a los eventos WineTech",
    join_common_4: "Acceso a los Wine Tech Coffee",
    join_common_5: "Participación en el Wine Tech Campus",
    join_common_6: "Acceso al seguimiento y a las noticias del ecosistema",
    join_common_7: "Acceso al grupo comunitario",
    join_common_8: "Identificación dentro del ecosistema WineTech",
    join_common_9: "Mención en las comunicaciones de WineTech",
    join_prog_accel_title: "Programas de aceleración",
    join_prog_accel_desc: "Acompañamiento colectivo en torno a la innovación, el desarrollo comercial, el crecimiento, la experimentación sobre el terreno y la financiación.",
    join_prog_export_title: "Misiones de exportación",
    join_prog_export_desc: "Descubrimiento de nuevos mercados, encuentros de negocios y operaciones colectivas a nivel internacional.",
    join_prog_academy_title: "WineTech Academy",
    join_prog_academy_desc: "Formaciones, talleres, masterclass y intercambio de buenas prácticas entre miembros y expertos.",
    join_prog_press_title: "Visibilidad y Prensa",
    join_prog_press_desc: "Valoración de iniciativas, comunicación, relaciones con la prensa y acciones de promoción del ecosistema.",
    join_prog_events_title: "Eventos y operaciones colectivas",
    join_prog_events_desc: "Wine Tech Tour, Wine Tech Coffee, Wine Tech Campus, ferias profesionales y encuentros temáticos.",
    apply_innovation_ai: "Inteligencia artificial",
    apply_innovation_robot: "Robótica / agtech",
    apply_innovation_iot: "Sensores / IoT",
    apply_innovation_blockchain: "Trazabilidad / blockchain",
    apply_innovation_marketplace: "Marketplace / e-commerce",
    apply_innovation_tourism: "Turismo y experiencia",
    apply_innovation_energy: "Energía y sostenibilidad",
    apply_innovation_oeno: "Enología / datos del vino",
    apply_innovation_logistics: "Logística y cadena de suministro",
    apply_innovation_other: "Otro",
    apply_interest_member: "Hacerse miembro de La WineTech",
    apply_interest_partner: "Asociación comercial",
    apply_interest_invest: "Inversión / captación de fondos",
    apply_interest_mentor: "Mentoría / red",
    apply_interest_event: "Participar en los eventos",
    apply_interest_visibility: "Visibilidad en prensa / comunicación",
    apply_interest_export: "Programa internacional",
  
    join_annual_fee: "Cuota anual",
    apply_step_label: "Paso",
    apply_step_you: "Tú",
    apply_step_you_short: "Identidad",
    apply_step_company: "Tu empresa",
    apply_step_company_short: "Empresa",
    apply_step_expectations: "Tus expectativas",
    apply_step_expectations_short: "Finalización",
    apply_btn_previous: "Anterior",
    apply_btn_continue: "Continuar",
    apply_btn_submit: "Enviar mi solicitud",
    apply_btn_submitting: "Enviando…",
    apply_desc_min_chars: "Mínimo 30 caracteres",
  
    portal_mycompany_collab_subtitle: "Invite a sus colegas a unirse a su espacio de miembro — disfrutarán de su membresía sin costes adicionales.",
    portal_mycompany_invite_cta_title: "Invite a un colega a unirse a su empresa",
    portal_mycompany_invite_cta_subtitle: "Su membresía cubre a todo el equipo: añádalos para que accedan a los eventos, al matchmaking y a la información relevante.",
  
    cta_apply: "Aplicar",
  
    join_calc_chip: "Simulador instantáneo",
    join_calc_word_fee: "cuota",
    join_calc_revenue_label: "Facturación anual (€)",
    join_calc_revenue_placeholder: "ej: 1 500 000",
    join_calc_loading: "Calculando...",
    join_calc_submit: "Calcular mi tarifa",
    join_calc_bracket: "Tramo estimado",
    apply_step0_title: "Conozcámonos",
    apply_field_lastname: "Apellido *",
    apply_field_email: "Email profesional *",
    apply_form_required_toast: "Por favor, complete los campos obligatorios antes de continuar.",
    apply_form_privacy_before: "Sus datos son tratados de acuerdo con nuestra",
    apply_form_privacy_after: ". Sin spam, baja en 1 clic.",
    not_found_title: "Página no encontrada",
    not_found_message: "Esta página no existe o ya no es accesible. Verifique la URL o vuelva a la página de inicio.",
    not_found_back: "Volver",
    not_found_home: "Inicio",
    portal_mycompany_collab_status_active: "Activo",
    portal_mycompany_collab_status_pending: "Invitación pendiente",
    portal_mycompany_collab_status_no_account: "Sin cuenta",
  
    join_beyond_membership_desc: "La membresía constituye la puerta de entrada al ecosistema WineTech. Los miembros pueden luego participar en las iniciativas y programas desarrollados a lo largo del año.",
    apply_thanks_title: "Solicitud enviada",
    apply_thanks_intro: "¡Gracias! Hemos recibido su solicitud y se acaba de enviar un correo electrónico de confirmación.",
    apply_thanks_within: "Nuestro equipo se pondrá en contacto con usted en",
    apply_thanks_within_value: "48 h laborables",
    apply_thanks_calendar_h: "Reserve su reunión de descubrimiento",
    apply_thanks_calendar_desc: "Para ir más rápido, elija una franja de <strong>30 min</strong> con nuestro equipo directamente en el calendario.",
    apply_thanks_book_cta: "Elegir un horario",
    apply_thanks_no_calendar: "📅 Nos pondremos en contacto con una propuesta de horario.",
    apply_thanks_back_home: "Volver al inicio",
    apply_thanks_follow: "Siga a La WineTech",
    apply_thanks_questions: "¿Alguna pregunta?",
    apply_field_website: "Sitio web",
    apply_field_revenue: "Facturación anual (€)",
    apply_field_country: "País *",
    apply_field_choose: "— Elegir —",
    apply_toast_success: "¡Solicitud enviada!",
    apply_toast_error: "Error al enviar. Reintente o contáctenos.",
    apply_toast_error_short: "Error de envío",
    apply_lang_label: "Idioma / Language",
    application_validated_by: "Aprobada por {name} · el {date}",
    application_rejected_by: "Rechazada por {name} · el {date}",
  },
  it: {
    res_dl_all: "Scarica tutto ({n} file, ZIP)",
    res_dl_error: "Impossibile scaricare",
    res_dl_one: "Scarica",
    nl_invalid_email: "Email non valida",
    nl_success_toast: "Grazie! Ti sei iscritto/a alla newsletter",
    nl_confirmed: "Iscrizione confermata — a presto!",
    nl_card_title: "Resta aggiornato/a",
    nl_card_desc: "Ricevi la nostra newsletter mensile: eventi futuri, opportunità, novità dal mondo WineTech.",
    nl_email_ph: "tua@email.com",
    nl_subscribe: "Iscriviti",
    nl_gdpr: "Annulla l'iscrizione con 1 clic da ogni email. Dati protetti (RGPD).",
    media_copy_failed: "Impossibile copiare l'URL — copialo manualmente: {url}",
    unit_mb: "MB",
    unit_gb: "GB",
    media_load_error: "Impossibile caricare la libreria multimediale",
    media_format_unsupported: "Formato non supportato. Accettati: {formats}",
    media_too_large: "File troppo grande ({size}). Max: {max}.",
    media_published: "Video pubblicato",
    media_upload_failed: "Caricamento fallito",
    media_delete_confirm: "Eliminare il video \"{title}\"?\n\nQuesta azione è definitiva.",
    media_deleted: "Video eliminato",
    media_url_copied: "URL pubblico copiato",
    media_meta_saved: "Metadati salvati",
    media_title: "La mia libreria multimediale",
    media_intro: "Ospita i tuoi pitch, demo e video di presentazione. Gli URL generati possono essere copiati nelle tue notizie, eventi e offerte del Club.",
    media_upload_btn: "Carica un video",
    media_finalizing: "Finalizzazione…",
    media_uploading: "Caricamento in corso — {pct}%",
    media_formats_label: "Formati:",
    media_max_label: "Dimensione massima:",
    media_hosting_label: "Hosting:",
    media_hosting_value: "archiviazione sicura, riproduzione ottimizzata per mobile",
    media_no_transcode: "Nessuna transcodifica",
    media_no_transcode_hint: "— esporta i tuoi video in formato web (MP4 H.264) prima di caricarli.",
    media_empty_title: "La tua libreria multimediale è vuota",
    media_empty_desc: "Carica il tuo primo video (pitch di 2 min, demo prodotto o presentazione).",
    media_edit: "Modifica",
    media_edit_title: "Modifica il video",
    media_field_title: "Titolo",
    media_field_desc: "Descrizione",
    inv_status_paid: "Pagata",
    inv_status_open: "In attesa",
    inv_status_pending: "Pagamento in corso",
    inv_status_draft: "Bozza",
    inv_status_void: "Annullata",
    inv_status_uncollectible: "Inesigibile",
    inv_title: "Fatture",
    inv_my_title: "Le mie fatture Stripe",
    inv_empty: "Nessuna fattura Stripe per il momento.",
    inv_my_empty: "Nessuna fattura Stripe per il momento. Le tue future quote associative e i pagamenti degli eventi appariranno qui.",
    inv_load_error: "Impossibile caricare le fatture",
    inv_total_paid: "Totale pagato:",
    inv_refresh_title: "Aggiorna da Stripe",
    inv_refresh: "Aggiorna",
    inv_stripe_not_configured: "Stripe non è configurato lato server — sono visibili solo le sessioni di checkout locali.",
    inv_col_date: "Data",
    inv_col_number: "Numero",
    inv_col_description: "Descrizione",
    inv_col_amount: "Importo",
    inv_col_status: "Stato",
    inv_col_actions: "Azioni",
    inv_checkout_session: "Sessione di pagamento",
    inv_open_payment: "Apri la pagina di pagamento",
    inv_view_stripe: "Visualizza la fattura Stripe",
    inv_pay: "Paga",
    inv_view: "Visualizza",
    inv_download_pdf: "Scarica il PDF",
    proj_seo_title: "Progetti WineTech — Iniziative collettive della filiera vinicola",
    proj_seo_desc: "Scopri i progetti e i programmi promossi da La WineTech: agroecologia, logistica a zero emissioni di carbonio, sovranità dei dati… I membri che costruiscono il futuro del vino.",
    proj_badge: "Programmi WineTech",
    proj_h1_a: "I progetti che plasmano",
    proj_h1_b: "il vino di domani",
    proj_intro: "Ogni progetto riunisce membri volontari attorno a una sfida strategica: innovazione, sostenibilità, sovranità, nuovi usi. Esplora, lasciati ispirare, unisciti a noi.",
    proj_empty: "I progetti WineTech arriveranno presto. Torna presto!",
    proj_tag: "Progetto",
    proj_discover: "Scopri",
    proj_not_found: "Progetto non trovato",
    proj_back: "Torna ai progetti",
    proj_all: "Tutti i progetti",
    proj_tag_full: "Progetto WineTech",
    proj_members_one: "{n} membro coinvolto",
    proj_members_many: "{n} membri coinvolti",
    proj_members_title: "I membri che portano avanti il progetto",
    proj_members_empty: "Sii il primo membro a unirti a questo progetto.",
    exh_no_company: "Nessuna scheda aziendale collegata al tuo account.",
    exh_resynced: "Informazioni risincronizzate dalla tua scheda aziendale",
    exh_resync_error: "Impossibile risincronizzare",
    exh_name_required: "Nome dell'azienda richiesto",
    exh_choose_role: "Scegli un ruolo",
    exh_validated: "Espositore convalidato",
    exh_submitted: "Candidatura inviata — in attesa di convalida amministrativa",
    exh_title: "Iscrizione Espositore",
    exh_company_card: "Scheda aziendale membro",
    exh_resync_title: "Ricarica le informazioni dalla tua scheda aziendale membro",
    exh_resync: "Risincronizza",
    exh_company_name: "Nome dell'azienda *",
    exh_role: "Il tuo ruolo *",
    exh_select: "— Seleziona —",
    exh_booth: "N. stand",
    exh_booth_ph: "es: B12",
    exh_logo: "Logo (URL)",
    exh_desc: "Breve descrizione",
    exh_desc_ph: "Presenta la tua azienda in poche parole…",
    exh_fee_title: "Costo di iscrizione espositore",
    exh_secure_payment: "Pagamento sicuro tramite Stripe. La tua iscrizione sarà convalidata automaticamente dopo il pagamento.",
    exh_free_title: "Iscrizione gratuita",
    exh_auto_admin: "Convalida automatica (admin).",
    exh_review_team: "La tua candidatura sarà esaminata dal team di La WineTech.",
    exh_pay: "Paga {price}",
    exh_confirm: "Conferma iscrizione",
    sidebar_member_shared_services: "Servizi condivisi",
    sidebar_member_media: "Libreria multimediale",
    nav_formations: "Formazioni",
    nav_support_us: "Sostienici",
    nav_opportunities: "Opportunità",
    nav_community: "La Community",
    newsletter_band_title: "Rimani aggiornato/a sulle novità WineTech",
    newsletter_band_desc: "Eventi futuri, opportunità, petizioni e innovazioni — 1 email al mese, disiscrizione in 1 clic.",
    newsletter_subscribe_aria: "Iscriviti alla newsletter",
    newsletter_later: "Più tardi",
    credit_dev_by: "Piattaforma sviluppata gratuitamente da",
    credit_for: "per La WineTech.",
    nav_home: "Home",
    nav_news: "Notizie",
    nav_events: "Eventi",
    nav_members: "Membri",
    nav_projects: "Progetti",
    nav_about: "Chi siamo",
    nav_contact: "Contatto",
    nav_back_to_site: "Torna al sito",
    auto_translated: "Tradotto automaticamente",
    loading: "Caricamento...",
    news_title: "News Magazine",
    news_subtitle: "Tutta l'innovazione dell'ecosistema WineTech: interviste, analisi, raccolte fondi e lanci.",
    news_seo_title: "News & Approfondimenti",
    news_seo_desc: "Ultime notizie, approfondimenti e storie dall'ecosistema globale dell'innovazione enologica — startup, tecnologia, tendenze di mercato e annunci dei soci.",
    news_search_placeholder: "Cerca notizie...",
    back_to_news: "Torna alle news",
    related_articles: "Articoli correlati",
    read_more: "Leggi di più",
    filter_all: "Tutti",
    cat_innovation: "Innovazione",
    cat_technology: "Tecnologia",
    cat_startup: "Startup",
    cat_market: "Mercato",
    cat_digital: "Digitale",
    cat_announcement: "Comunicato",
    events_title: "Eventi",
    events_subtitle: "Conferenze, webinar, afterwork, masterclass: gli appuntamenti della comunità WineTech.",
    events_seo_title: "Eventi",
    events_seo_desc: "Scopri i prossimi eventi WineTech — conferenze, incontri 1:1, workshop e incontri sull'innovazione attraverso l'ecosistema vinicolo globale.",
    events_upcoming: "Prossimi",
    events_past: "Passati",
    events_all_formats: "Tutti i formati",
    events_format_physical: "In presenza",
    events_format_digital: "Digitale",
    events_format_hybrid: "Ibrido",
    events_registered: "iscritti",
    back_to_events: "Torna agli eventi",
    cta_join: "Unisciti",
    cta_explore: "Esplora la comunità",
    cta_see_events: "Vedi eventi",
    cta_visit_website: "Visita il sito",
    hero_title_pre: "La comunità",
    hero_title_brand: "WineTech",
    hero_subtitle: "Collegare i talenti, condividere l'innovazione e costruire insieme il futuro del vino.",
    innovate_together: "Innoviamo insieme",
    actu: "Notizie",
    upcoming_events: "Eventi in arrivo",
    community_members: "Membri della comunità",
    see_all_news: "Vedi tutte le notizie",
    see_all_events: "Vedi tutti gli eventi",
    see_all_members: "Vedi tutti i membri",
    learn_more: "Scopri",
    apply_now: "Candidati",
    login: "Accedi",
    login_title: "Accedi",
    login_welcome_back: "Felici di rivederti.",
    login_loading: "Accesso...",
    login_no_account: "Non sei ancora membro?",
    login_create_account: "Crea account",
    login_welcome_toast: "Benvenuto!",
    login_brand_title_pre: "Benvenuto nella",
    login_brand_title_brand: "comunità WineTech",
    login_brand_subtitle: "Accedi al tuo spazio dedicato, ai tuoi appuntamenti e all'elenco privato.",
    login_demo_accounts: "Account demo (clicca per riempire):",
    login_demo_admin: "Admin",
    login_demo_member: "Membro",
    login_demo_press: "Stampa",
    email: "Email",
    password: "Password",
    register: "Registrati",
    register_title: "Crea account",
    register_loading: "Creazione...",
    register_have_account: "Già registrato?",
    register_first_name: "Nome",
    register_last_name: "Cognome",
    register_submit: "Registrati",
    logout: "Esci",
    forgot_password: "Password dimenticata?",
    register_role_applicant: "Candidato (membro)",
    register_role_event: "Visitatore evento",
    register_role_journalist: "Giornalista / Stampa",
    register_company_or_media: "Azienda / Media",
    register_i_am: "Sono",
    register_brand_title_pre: "Unisciti a",
    register_brand_subtitle: "Crea il tuo account per candidarti, partecipare agli eventi o accedere al portale stampa.",
    dashboard: "Dashboard",
    my_profile: "Profilo",
    portal_member: "Portale membro",
    portal_press: "Portale stampa",
    portal_admin: "CRM Admin",
    apply_join: "Candidati a La WineTech",
    join_intro: "Unisciti all'ecosistema WineTech globale.",
    sidebar_member_dashboard: "Dashboard",
    sidebar_member_profile: "Profilo azienda",
    sidebar_member_my_company: "La mia azienda",
    sidebar_member_score: "Il mio punteggio",
    sidebar_member_notifications: "Notifiche",
    sidebar_member_matchmaking: "Matchmaking",
    sidebar_member_products: "Prodotti e Servizi",
    sidebar_member_team: "Team",
    sidebar_member_news: "Pubblicazioni",
    sidebar_member_events: "Eventi",
    sidebar_member_directory: "Elenco",
    sidebar_member_meetings: "Appuntamenti",
    sidebar_member_messages: "Messaggi",
    sidebar_member_resources: "Risorse",
    sidebar_personal_profile: "Profilo personale",
    sidebar_admin_dashboard: "Dashboard",
    sidebar_admin_pipeline: "Pipeline CRM",
    sidebar_admin_members: "Membri",
    sidebar_admin_applications: "Candidature",
    sidebar_admin_news: "Notizie",
    sidebar_admin_events: "Eventi",
    sidebar_admin_meetings: "Appuntamenti",
    sidebar_admin_analytics: "Analytics",
    sidebar_admin_settings: "Impostazioni",
    sidebar_press_dashboard: "Dashboard",
    sidebar_press_releases: "Comunicati",
    sidebar_press_events: "Eventi",
    sidebar_press_members: "Membri",
    sidebar_press_resources: "Risorse",
    sidebar_need_help: "Hai bisogno di aiuto?",
    sidebar_help_text: "Il nostro team è qui per aiutarti.",
    sidebar_contact_us: "Contattaci",
    search: "Cerca",
    search_placeholder: "Cerca un'azienda, una tecnologia...",
    category: "Categoria",
    country: "Paese",
    all: "Tutti",
    all_categories: "Tutte le categorie",
    all_countries: "Tutti i paesi",
    all_poles: "Tutti i settori",
    no_results: "Nessun risultato.",
    no_members_found: "Nessun membro trovato. Modifica i filtri.",
    submit: "Invia",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    edit: "Modifica",
    add: "Aggiungi",
    close: "Chiudi",
    confirm: "Conferma",
    publish: "Pubblica",
    download: "Scarica",
    open: "Apri",
    pending: "In attesa",
    approved: "Approvato",
    rejected: "Respinto",
    draft: "Bozza",
    active: "Attivo",
    published: "Pubblicato",
    archived: "Archiviato",
    paid: "Pagato",
    pending_payment: "Pagamento in attesa",
    confirmed: "Confermato",
    book_meeting: "Prenota incontro",
    exhibitors: "Espositori",
    matchmaking: "Matchmaking",
    register_for_event: "Iscriviti all'evento",
    visitor: "Visitatore",
    exhibitor: "Espositore",
    media: "Media / Stampa",
    free: "Gratuito",
    speakers: "Relatori",
    sponsors: "Sponsor",
    attendees: "Partecipanti",
    check_in: "Check-in",
    pricing: "Tariffe",
    transactions: "Transazioni",
    about: "Chi siamo",
    expertise: "Competenze",
    products_services: "Prodotti e Servizi",
    company_news: "Notizie",
    technologies: "Tecnologie",
    activities: "Attività",
    founded_in: "Fondata nel",
    employees: "dipendenti",
    active_member: "Membro attivo",
    tags: "Tag",
    community_score: "Punteggio comunità",
    points: "pt",
    back_to_members: "Torna ai membri",
    resources: "Risorse",
    press_releases: "Comunicati",
    media_kit: "Media kit",
    welcome: "Benvenuto",
    success_saved: "Salvato con successo",
    error_generic: "Si è verificato un errore",
    footer_intro: "La WineTech connette i talenti dell'innovazione vitivinicola in tutto il mondo. Una comunità unica per condividere, imparare, collaborare.",
    footer_platform: "Piattaforma",
    footer_spaces: "Spazi",
    footer_rights: "Tutti i diritti riservati.",
    footer_made_with: "Fatto con ♥ per l'industria del vino.",
    members_directory_intro: "Scopri tutti gli attori dell'innovazione WineTech, le loro specialità e tecnologie.",
    portal_exhibitormatchmaking_01: "Slot disponibili",
    portal_exhibitormatchmaking_02: "Nessuno slot disponibile per questo contatto.",
    portal_matchmaking_01: "Suggeriti:",
    portal_matchmaking_02: "e ciò che voi",
    portal_matchmaking_03: ". La piattaforma vi mette automaticamente in contatto con i migliori profili.",
    portal_matchmaking_04: "Le vostre competenze, servizi, tecnologie, mercati a cui vi rivolgete.",
    portal_matchmaking_05: "Partnership, tecnologie, risorse, mercati a cui desiderate accedere.",
    portal_memberdashboard_01: "Ecco una panoramica della vostra attività nella comunità WineTech.",
    portal_memberdashboard_02: "La mia azienda",
    portal_memberdashboard_03: "Nessuna azienda associata.",
    portal_memberdashboard_04: "Completa il mio profilo →",
    portal_memberdashboard_05: "Prossimi eventi",
    portal_memberdashboard_06: "Vedi tutto",
    portal_memberdashboard_07: "Sviluppate la vostra visibilità nella comunità",
    portal_memberdashboard_08: "Pubblicate notizie, partecipate agli eventi, fissate appuntamenti con gli altri attori.",
    portal_memberdashboard_09: "Pubblica una notizia",
    portal_memberdirectory_01: "Scoprite e connettetevi con gli altri membri della comunità.",
    portal_memberdirectory_02: "Più recenti prima",
    portal_memberevents_01: "Eventi",
    portal_memberevents_02: "Iscrivetevi ai prossimi eventi della comunità.",
    portal_memberevents_03: "Prossimi",
    portal_memberevents_04: "Passati",
    portal_memberevents_05: "Tutti i pubblici",
    portal_memberevents_06: "Data più vicina",
    portal_memberevents_07: "Data più lontana",
    portal_memberevents_08: "Pubblicato di recente",
    portal_memberevents_09: "Pubblicato molto tempo fa",
    portal_membermeetings_01: "I miei appuntamenti",
    portal_membermeetings_02: "Gestite i vostri appuntamenti, le vostre disponibilità e il vostro programma Incontri 1:1.",
    portal_membermeetings_03: "Il mio programma Incontri 1:1",
    portal_membermeetings_04: "Scoprite gli eventi",
    portal_membermeetings_05: "e prenotate il vostro prossimo appuntamento.",
    portal_membermeetings_06: "I miei eventi come espositore",
    portal_membermeetings_07: "Selezionate gli slot in cui siete disponibili per incontrare i visitatori. Solo gli slot selezionati saranno proposti per la prenotazione.",
    portal_membermeetings_08: "Confermato",
    portal_membermeetings_09: "⚠️ Nessuno slot selezionato. I visitatori non possono prenotare finché non avete indicato le vostre disponibilità.",
    portal_membermeetings_10: "Le mie disponibilità",
    portal_membermessages_01: "Conversazioni private con la comunità.",
    portal_membermessages_02: "Selezionate una conversazione.",
    portal_membernews_01: "Le mie notizie",
    portal_membernews_02: "Inviate le vostre notizie, lanci, raccolte fondi.",
    portal_membernews_03: "Validazione richiesta dal team La WineTech",
    portal_membernews_04: "La vostra notizia sarà revisionata da un amministratore. Tempo di validazione:",
    portal_membernews_05: "24-72h",
    portal_membernews_06: "Invia per validazione",
    portal_membernews_07: "Categoria",
    portal_membernews_08: "Nessuna notizia pubblicata per il momento.",
    portal_memberproducts_01: "Nessuna azienda associata.",
    portal_memberproducts_02: "Vetrina delle vostre offerte nell'ecosistema WineTech.",
    portal_memberproducts_03: "Video",
    portal_memberproducts_04: "Demo",
    portal_memberproducts_05: "Nessun prodotto o servizio pubblicato.",
    portal_memberprofile_01: "Curate il vostro profilo per aumentare la visibilità nell'ecosistema.",
    portal_memberprofile_02: "Vedi il mio profilo pubblico",
    portal_memberprofile_03: "Pubblica una notizia",
    portal_memberprofile_04: "Completezza",
    portal_memberprofile_05: "I miei eventi",
    portal_memberprofile_06: "Vedi tutto →",
    portal_memberprofile_07: "Nessun evento in programma.",
    portal_memberprofile_08: "Scopri gli eventi →",
    portal_memberprofile_09: "Le mie pubblicazioni",
    portal_memberprofile_10: "Gestisci →",
    portal_memberprofile_11: "Condividete le vostre novità con la community WineTech per aumentare la vostra visibilità.",
    portal_memberprofile_12: "Descrizione estesa (Markdown)",
    portal_memberprofile_13: "Settore principale",
    portal_memberprofile_14: "Tag speciali",
    portal_memberprofile_15: "Attività secondarie",
    portal_memberprofile_16: "Mercati di riferimento",
    portal_memberprofile_17: "Aiutate l'ecosistema a trovarvi — scegliete tutti i tag che si applicano alla vostra attività. Filtrabili sull'annuario e utilizzati nelle schede evento.",
    portal_memberresources_01: "Scarica",
    portal_memberteam_01: "Nessuna azienda associata.",
    portal_memberteam_02: "Team",
    portal_memberteam_03: "Gestite i collaboratori della vostra azienda e i loro ruoli.",
    portal_memberteam_04: "Invito creato ✓",
    portal_memberteam_05: "Password temporanea",
    portal_memberteam_06: "(da trasmettere manualmente — l'email di invito Brevo sarà collegata in una prossima iterazione):",
    portal_memberteam_07: "Invita un altro collaboratore",
    portal_memberteam_08: "Ruolo",
    portal_mycompany_01: "La mia azienda",
    portal_mycompany_02: "Completate le informazioni del vostro profilo aziendale e gestite i vostri collaboratori.",
    portal_mycompany_03: "Il",
    portal_mycompany_04: "è visualizzato ovunque (annuario, eventi, elementi visivi, badge). L'",
    portal_mycompany_05: "entità legale",
    portal_mycompany_06: "è utilizzata solo per la fatturazione Stripe.",
    portal_mycompany_07: "Visualizzato su tutti i supporti pubblici",
    portal_mycompany_08: "Entità legale (fatturazione)",
    portal_mycompany_09: "Utilizzata per Stripe e fatture",
    portal_mycompany_10: "Solo il contatto principale può modificare queste informazioni",
    portal_mycompany_11: "Aggiungi un collaboratore",
    portal_mycompany_12: "Imposta come contatto principale",
    portal_mycompany_13: "Nessun collaboratore. Aggiungi il tuo team per sfruttare appieno i vantaggi di La WineTech.",
    portal_myeventpage_01: "← Il mio portale",
    portal_myeventpage_02: "Annulla iscrizione",
    portal_myeventpage_03: "Vedi la pagina pubblica",
    portal_myeventpage_04: "Non sei ancora iscritto/a a questo evento.",
    portal_myeventpage_05: "Vai alla",
    portal_myeventpage_06: "per iscriverti.",
    portal_myeventpage_07: "🎥 Evento online",
    portal_myeventpage_08: "Codice d'accesso:",
    portal_myeventpage_09: "Partecipa alla videochiamata →",
    portal_myeventpage_10: "Passo 1",
    portal_myeventpage_11: "Scarica il tuo badge",
    portal_myeventpage_12: "Presentalo alla reception il giorno dell'evento.",
    portal_myeventpage_13: "Scarica il PDF",
    portal_myeventpage_14: "Passo 2",
    portal_myeventpage_15: "Vedi la sezione ↓",
    portal_myeventpage_16: "Il giorno dell'evento",
    portal_myeventpage_17: "Le mie disponibilità per Incontri 1:1",
    portal_myeventpage_18: "Sei iscritto/a come espositore.",
    portal_myeventpage_19: "Spunta le fasce orarie in cui sarai disponibile per incontrare i visitatori. Solo le fasce orarie spuntate saranno disponibili per la prenotazione.",
    portal_myeventpage_20: "Validato",
    portal_myeventpage_21: "Nessuna fascia oraria selezionata — i visitatori non possono prenotarti.",
    portal_myeventpage_22: "Vista calendario completa",
    portal_myeventpage_23: "Nessun espositore convalidato al momento. Torna più tardi ⏳",
    portal_myeventpage_24: "I miei appuntamenti confermati",
    portal_myscore_01: "Il mio punteggio comunità",
    portal_myscore_02: "Il tuo coinvolgimento nella comunità WineTech, calcolato secondo criteri trasparenti.",
    portal_myscore_03: "Più contribuisci, più la tua visibilità cresce",
    portal_myscore_04: "Dettaglio punti",
    portal_myscore_05: "Completa la tua scheda azienda (logo, descrizione, sito web) — guadagno immediato.",
    portal_myscore_06: "Inserisci LinkedIn e un link al calendario per ogni collaboratore.",
    portal_myscore_07: "Pubblica le tue notizie tramite il tuo portale membri.",
    portal_myscore_08: "Iscriviti e partecipa agli eventi della comunità.",
    portal_myscore_09: "Aggiungi i tuoi collaboratori dalla pagina «La mia azienda».",
    portal_notifications_01: "Tutto ciò che accade nella tua comunità, a colpo d'occhio.",
    portal_notifications_02: "Preferenze email",
    portal_notifications_03: "Per ogni categoria, scegli se desideri ricevere un'email oltre alla notifica nell'app.",
    portal_notifications_04: "Nessuna notifica per il momento.",
    portal_notifications_05: "Vedi →",
    portal_personalprofile_01: "Il mio profilo personale",
    portal_personalprofile_02: "Aggiorna le tue informazioni personali, la tua foto e la tua agenda pubblica.",
    portal_personalprofile_03: "Identità",
    portal_personalprofile_04: "Nome",
    portal_personalprofile_05: "Telefono",
    portal_personalprofile_06: "Calendly, Cal.com, Google Calendar… questo link sarà proposto per prenotare appuntamenti con te.",
    press_pressdashboard_01: "Benvenuto/a nella tua area stampa WineTech. Accedi alle ultime notizie della comunità.",
    press_pressdashboard_02: "Accesso giornalista approvato",
    press_pressdashboard_03: "Hai accesso completo a tutte le notizie della piattaforma.",
    press_pressdashboard_04: "Vedi il mio profilo",
    press_pressdashboard_05: "Ultime notizie",
    press_pressdashboard_06: "Categorie",
    press_pressdashboard_07: "Tutte le categorie",
    press_pressdashboard_08: "Il nostro team stampa è a tua disposizione per qualsiasi richiesta.",
    press_pressevents_01: "Eventi",
    press_pressevents_02: "Accedi a tutti gli eventi della comunità WineTech.",
    press_pressevents_03: "Prossimi",
    press_pressevents_04: "Passati",
    press_pressevents_05: "Data più vicina",
    press_pressevents_06: "Data più lontana",
    press_pressevents_07: "Pubblicato di recente",
    press_pressevents_08: "Pubblicato molto tempo fa",
    press_pressmembers_01: "Scopri gli attori dell'innovazione vinicola.",
    press_pressmembers_02: "Più recenti prima",
    press_pressreleases_01: "Comunicati stampa",
    press_pressreleases_02: "Più recenti prima",
    press_pressreleases_03: "Nessun comunicato per il momento.",
    press_pressresources_01: "Kit media & risorse",
    press_pressresources_02: "Loghi, foto ufficiali, comunicati e rapporti.",
    press_pressresources_03: "Scarica",
    layout_publiclayout_01: "📝 Invia la mia candidatura",
    layout_publiclayout_02: "Avete bisogno di un CRM, un portale clienti, un extranet, un'applicazione aziendale o una piattaforma SaaS su misura per potenziare il vostro sviluppo?",
    portal_mycompany_readonly: "Stai visualizzando questo profilo in sola lettura. Solo il contatto principale (o un amministratore) può modificare queste informazioni. Chiedi al tuo contatto principale di attivare l'opzione «Consenti agli altri collaboratori di modificare» in questa pagina.",
  
    portal_exhibitormatchmaking_90: "Caricamento...",
    portal_memberdashboard_90: "Notizie pubblicate",
    portal_memberdashboard_91: "Eventi a cui hai partecipato",
    portal_memberdashboard_92: "Visualizzazioni del tuo profilo",
    portal_memberdashboard_93: "Modifica",
    portal_memberevents_90: "Cerca un evento, una città…",
    portal_membermeetings_90: "Aggiungi",
    portal_membermessages_90: "Nuovo messaggio",
    portal_membermessages_91: "La tua risposta…",
    portal_membermessages_92: "Invia",
    portal_membermessages_93: "Cerca un membro, admin, stampa…",
    portal_membermessages_94: "Il tuo messaggio…",
    portal_membernews_90: "Immagine di copertina",
    portal_memberproducts_90: "Descrizione dettagliata",
    portal_memberproducts_91: "URL video YouTube/Vimeo",
    portal_memberproducts_92: "URL demo",
    portal_memberproducts_93: "Aggiungi",
    portal_memberproducts_94: "Elimina",
    portal_memberprofile_90: "Identità",
    portal_memberprofile_91: "Banner (16:5 consigliato)",
    portal_memberprofile_92: "Anno di creazione",
    portal_memberprofile_93: "Presentazione",
    portal_memberprofile_94: "Social media",
    portal_memberteam_90: "Nome",
    portal_memberteam_91: "Invia l&apos;invito",
    portal_memberteam_92: "Nessun collaboratore.",
    portal_mycompany_90: "Caricamento…",
    portal_mycompany_91: "Email di contatto",
    portal_mycompany_92: "Telefono",
    portal_mycompany_93: "Descrizione / presentazione",
    portal_mycompany_94: "Logo (quadrato, 512×512 consigliato)",
    portal_mycompany_95: "Banner (16:9, 1600×900 consigliato)",
    portal_mycompany_96: "Salva",
    portal_mycompany_97: "Nome *",
    portal_mycompany_98: "Aggiungi &amp; invia l&apos;invito",
    portal_mycompany_99: "Annulla",
    portal_mycompany_100: "Invia di nuovo",
    portal_mycompany_101: "Invita",
    portal_myeventpage_90: "Caricamento…",
    portal_myscore_90: "Caricamento…",
    portal_personalprofile_90: "Caricamento...",
    portal_personalprofile_91: "Importa una foto (JPG/PNG, ≤ 5 MB)",
    portal_personalprofile_92: "Qualche riga per presentarti…",
    layout_portallayout_90: "Chiudi menu",
    layout_portallayout_91: "Apri menu",
    layout_publiclayout_90: "Scoprire l'adesione a La WineTech",
    layout_publiclayout_91: "Invia la mia candidatura",
  
    sidebar_help_mode_emploi: "Istruzioni",
    sidebar_admin_prospects: "Prospect",
    sidebar_admin_contacts: "Contatti",
    sidebar_admin_formations: "Formazioni",
    sidebar_admin_checkin_qr: "Check-in (QR)",
    sidebar_admin_administrators: "Amministratori",
    sidebar_admin_emails: "Email",
    sidebar_admin_mailshot: "Mailshot CRM",
    sidebar_admin_scoring: "Scoring",
    sidebar_admin_renewals: "Rinnovi",
    sidebar_admin_activity_log: "Registro attività",
    sidebar_admin_ai_feedback: "Feedback AI",
    subtitle_admin: "Amministrazione",
    subtitle_press: "Innovazione & Condivisione",
    subtitle_member: "Comunità & Innovazione",
    user_label_default: "Utente",
    role_admin: "Amministratore",
    role_member: "Membro",
    role_press: "Stampa",
    role_applicant: "Candidato",
    role_event_visitor: "Visitatore evento",
    role_journalist: "Giornalista",
    title_admin_dashboard: "Dashboard Amministratore",
    title_press_portal: "Portale Stampa",
    title_member_portal: "Portale Membri",
  
    portal_mycompany_section_title: "Scheda Aziendale",
    portal_mycompany_name_label: "Nome commerciale *",
    portal_mycompany_legal_label: "Ragione sociale",
    portal_mycompany_name_term: "nome commerciale",
    portal_mycompany_legal_term: "ragione sociale",
    portal_mycompany_name_placeholder: "Es: VineaTech",
    portal_mycompany_legal_placeholder: "Es: VineaTech SAS",
    portal_mycompany_vat_placeholder: "P. IVA intracom.",
    portal_mycompany_website_placeholder: "Sito web",
    portal_mycompany_city_placeholder: "Città",
    portal_mycompany_collaborators_title: "Collaboratori",
    portal_mycompany_email_required_placeholder: "Email *",
    portal_mycompany_lastname_required_placeholder: "Cognome *",
    portal_mycompany_jobtitle_placeholder: "Funzione",
    portal_mycompany_linkedin_placeholder: "URL LinkedIn",
    portal_mycompany_calendar_placeholder: "Link calendario (Calendly, Google…)",
    portal_mycompany_primary_badge: "Principale",
    image_upload_replace: "Sostituisci",
    image_upload_loading: "Caricamento…",
    search_button: "Cerca",
    common_required: "(obbligatorio)",
  
    comp_aboutpage_90: "Informazioni su La WineTech",
    comp_aboutpage_91: "A proposito di La WineTech",
    comp_aboutpage_92: "La nostra missione",
    comp_aboutpage_93: "L'ecosistema",
    comp_activateaccount_90: "Attiva il mio account",
    comp_activateaccount_91: "Verifica del link…",
    comp_activateaccount_92: "Richiedi un nuovo link",
    comp_activateaccount_93: "Account attivato!",
    comp_activateaccount_94: "Reindirizzamento alla pagina di accesso…",
    comp_activateaccount_95: "Attiva il tuo account",
    comp_activateaccount_96: "Scegli una password per completare l'attivazione.",
    comp_activateaccount_97: "Password (6+ caratteri)",
    comp_activateaccount_98: "Conferma password",
    comp_applypage_90: "Candidati | La WineTech",
    comp_applypage_91: "La WineTech",
    comp_applypage_92: "Unisciti alla community",
    comp_applypage_93: "3 minuti per presentarci il tuo progetto. Il nostro team ti contatterà entro 48 ore.",
    comp_applypage_94: "I tuoi dati personali. Trattiamo i tuoi dati in conformità al GDPR.",
    comp_applypage_95: "Nome *",
    comp_applypage_96: "Telefono",
    comp_applypage_97: "Il tuo LinkedIn",
    comp_applypage_98: "Accetto di ricevere comunicazioni da La WineTech (eventi, opportunità, newsletter). Disiscrizione possibile in qualsiasi momento.",
    comp_applypage_99: "Informazioni sulla tua struttura",
    comp_applypage_100: "Queste informazioni ci permettono di valutare il tuo profilo e la quota associativa più adatta.",
    comp_applypage_101: "Nome della società *",
    comp_applypage_102: "La tua funzione",
    comp_applypage_103: "Adattiamo la quota associativa alle dimensioni della tua struttura.",
    comp_applypage_104: "Categoria *",
    comp_applypage_105: "Tipo/i di innovazione / interessi",
    comp_applypage_106: "Presenta la tua struttura in poche righe *",
    comp_applypage_107: "Qual è la tua attività? Quali sono le tue principali sfide?",
    comp_applypage_108: "Ultimo passaggio",
    comp_applypage_109: "Aiutaci a capire cosa ti aspetti da La WineTech.",
    comp_applypage_110: "Ciò che ti interessa prioritariamente *",
    comp_applypage_111: "💡 Prossimi passi",
    comp_applypage_112: "Esamineremo la tua candidatura entro 48 ore lavorative",
    comp_applypage_113: "Riceverai immediatamente una conferma via email",
    comp_applypage_114: "Se idoneo, ti verrà proposto un colloquio",
    comp_applypage_115: "politica sulla privacy",
    comp_applythankspage_90: "Candidatura inviata | La WineTech",
    comp_applythankspage_91: "48 ore lavorative",
    comp_applythankspage_92: "Prenota il tuo appuntamento di scoperta",
    comp_applythankspage_93: "Segui La WineTech",
    comp_applythankspage_94: "Hai una domanda?",
    comp_billingpage_90: "Informazioni di fatturazione trasmesse",
    comp_billingpage_91: "Il nostro team emetterà ora la tua fattura. Riceverai presto un'email con il link di pagamento sicuro Stripe.",
    comp_billingpage_92: "! La tua candidatura per",
    comp_billingpage_93: "Numero IVA",
    comp_billingsuccess_90: "Conferma del pagamento…",
    comp_billingsuccess_91: "Benvenuto in",
    comp_billingsuccess_92: "la community",
    comp_billingsuccess_93: "Il tuo pagamento di",
    comp_billingsuccess_94: "è confermato. Il nostro team finalizzerà il tuo onboarding e ti contatterà a breve per la tua chiamata di benvenuto.",
    comp_billingsuccess_95: "Accedi al mio spazio",
    comp_billingsuccess_96: "Stripe sta elaborando il tuo pagamento. Riceverai un'email non appena sarà confermato.",
    comp_billingsuccess_97: "Errore",
    comp_billingsuccess_98: "Impossibile verificare il pagamento. Contatta il team.",
    comp_contactpage_90: "Una domanda, un progetto, una candidatura? Scrivici e il nostro team ti risponderà entro 48 ore.",
    comp_contactpage_91: "Messaggio ricevuto!",
    comp_contactpage_92: "Il nostro team ha ricevuto il tuo messaggio e ti ricontatterà molto presto.",
    comp_contactpage_93: "Invia un altro messaggio",
    comp_contactpage_94: "Nome *",
    comp_contactpage_95: "Telefono",
    comp_contactpage_96: "— Settore di attività (opzionale) —",
    comp_contactpage_97: "Il tuo messaggio *",
    comp_contactpage_98: "Accetto che i miei dati siano registrati da La WineTech per elaborare la mia richiesta (conformemente al GDPR). I miei dati non saranno mai rivenduti.",
    comp_contactpage_99: "Oppure scrivici direttamente a",
    comp_digestsubscribepage_90: "Preso nota!",
    comp_digestsubscribepage_91: "Riceverai il tuo primo Weekly Digest giovedì prossimo alle 9. Potrai modificare le tue preferenze o disiscriverti da ogni email.",
    comp_digestsubscribepage_92: "Ogni giovedì alle 9, ricevi l&apos;essenziale di La WineTech in base ai tuoi interessi — novità sui membri, innovazioni, scienza, normativa ed eventi futuri.",
    comp_digestsubscribepage_93: "Nome",
    comp_digestsubscribepage_94: "🇫🇷 Francese",
    comp_digestsubscribepage_95: "🇵🇹 Portoghese",
    comp_digestsubscribepage_96: "Interessi",
    comp_digestsubscribepage_97: "— tutto selezionato per impostazione predefinita",
    comp_eventdetail_90: "Caricamento...",
    comp_eventdetail_91: "Sei connesso come",
    comp_eventdetail_92: "← Torna al mio spazio",
    comp_eventdetail_93: "📄 Catalogo dell&apos;evento",
    comp_eventdetail_94: "PDF completo con l'elenco degli espositori, visitatori e relatori — aggiornato in tempo reale.",
    comp_eventdetail_95: "Vedi gli appuntamenti",
    comp_eventdetail_96: "Chi ci sarà?",
    comp_eventdetail_97: "Elenco pubblico degli iscritti confermati — vieni a incontrare questi membri ed espositori della community WineTech.",
    comp_eventdetail_98: "Iscrizione confermata",
    comp_eventdetail_99: "Confermare la disiscrizione?",
    comp_eventdetail_100: "Conferma",
    comp_eventdetail_101: "Annulla",
    comp_eventdetail_102: "Sei già membro?",
    comp_eventdetail_103: "Iscrizione confermata!",
    comp_eventdetail_104: "attiva il tuo account",
    comp_eventdetail_105: "Scarica il mio badge PDF",
    comp_eventdetail_106: "Iscrizione all'evento",
    comp_eventdetail_107: "💳 Dopo questo modulo, sarai reindirizzato alla pagina di pagamento sicura di Stripe. Il tuo badge verrà emesso al termine del pagamento.",
    comp_eventdetail_108: "— Gratuito. Il tuo badge verrà emesso immediatamente.",
    comp_eventdetail_109: "Nome *",
    comp_eventdetail_110: "Azienda",
    comp_eventdetail_111: "Telefono",
    comp_eventdetail_112: "Un account personale ti verrà creato automaticamente (email di attivazione inviata) per ritrovare il tuo badge e partecipare agli incontri 1:1.",
    comp_eventdetail_113: "Cerca un nome, azienda, prodotto…",
    comp_eventdetail_114: "Ordina: Nome A→Z",
    comp_eventdetail_115: "Ordina: Società A→Z",
    comp_eventdetail_116: "Ordina: Profili più ricchi",
    comp_eventpaymentsuccess_90: "Verifica pagamento…",
    comp_eventpaymentsuccess_91: "Pagamento confermato!",
    comp_eventpaymentsuccess_92: "La tua iscrizione è stata convalidata. Ecco il tuo badge.",
    comp_eventpaymentsuccess_93: "Il pagamento sta impiegando più tempo del previsto. Riceverai un'email di conferma non appena sarà convalidato.",
    comp_eventpaymentsuccess_94: "Torna all'evento",
    comp_eventpaymentsuccess_95: "Pagamento non confermato",
    comp_eventpaymentsuccess_96: "Si è verificato un errore. Se ti è stato addebitato, contattaci.",
    comp_eventslist_90: "Cerca un evento, una città…",
    comp_eventslist_91: "Data più vicina",
    comp_eventslist_92: "Data più lontana",
    comp_eventslist_93: "Pubblicato di recente",
    comp_eventslist_94: "Pubblicato molto tempo fa",
    comp_exhibitorpaymentsuccess_90: "Verifica pagamento…",
    comp_exhibitorpaymentsuccess_91: "Iscrizione espositore confermata!",
    comp_exhibitorpaymentsuccess_92: "Il tuo pagamento è stato ricevuto con successo. Ora sei registrato/a come espositore per questi Incontri 1:1.",
    comp_exhibitorpaymentsuccess_93: "Prossimo passo:",
    comp_exhibitorpaymentsuccess_94: "vai al tuo",
    comp_exhibitorpaymentsuccess_95: "spazio evento",
    comp_exhibitorpaymentsuccess_96: "per",
    comp_exhibitorpaymentsuccess_97: "selezionare le tue fasce di disponibilità",
    comp_exhibitorpaymentsuccess_98: "Gestisci la mia disponibilità",
    comp_exhibitorpaymentsuccess_99: "Torna all'evento",
    comp_exhibitorpaymentsuccess_100: "Pagamento non confermato",
    comp_exhibitorpaymentsuccess_101: "Il pagamento non ha potuto essere verificato. Se hai già pagato, il webhook di Stripe finalizzerà l'iscrizione tra pochi minuti.",
    comp_forgotpassword_90: "Password dimenticata?",
    comp_forgotpassword_91: "Inserisci la tua email. Se esiste un account, riceverai un link di reimpostazione valido per 1 ora.",
    comp_forgotpassword_92: "Email inviata",
    comp_formationdetail_90: "Caricamento…",
    comp_formationdetail_91: "Link di connessione (iscritti)",
    comp_formationdetail_92: "Password:",
    comp_formationdetail_93: "Nome *",
    comp_formationslist_90: "Formazioni La WineTech Academy",
    comp_formationslist_91: "Sessioni per migliorare le competenze nel mondo del vino e delle tecnologie associate.",
    comp_formationslist_92: "Cerca una formazione…",
    comp_formationslist_93: "Nessuna formazione al momento.",
    comp_home_90: "la comunità WineTech",
    comp_home_91: "Scambia, collabora e partecipa a costruire il futuro del vino.",
    comp_joinpage_90: "Unisciti a La WineTech | Adesione & Quote",
    comp_joinpage_91: "Unisciti all'ecosistema internazionale de",
    comp_joinpage_92: "ecosistema di innovazione",
    comp_joinpage_93: "La base comune",
    comp_joinpage_94: "Indipendentemente dalla tua categoria di adesione, beneficerai di questi vantaggi.",
    comp_joinpage_95: "Scegli la tua categoria",
    comp_joinpage_96: "Ogni profilo beneficia di vantaggi aggiuntivi pensati per la propria professione.",
    comp_joinpage_97: "In aggiunta alla base comune",
    comp_joinpage_98: "Calcola la tua",
    comp_joinpage_99: "Indica la tua categoria e il tuo fatturato annuale per scoprire la tua quota di adesione stimata. Nessuna creazione di account richiesta.",
    comp_joinpage_100: "Categoria",
    comp_joinpage_101: "Quota associativa annuale indicativa — soggetta a convalida da parte del nostro comitato.",
    comp_joinpage_102: "Oltre l'adesione",
    comp_joinpage_103: "Il nostro comitato esamina la tua candidatura e ti risponde entro 5 giorni lavorativi.",
    comp_joinpage_104: "Già candidato/a? Accedi",
    comp_leaderboard_90: "Membri Top La WineTech",
    comp_leaderboard_91: "Gli attori più impegnati nella community ogni mese.",
    comp_leaderboard_92: "Classifica in fase di costituzione.",
    comp_leaderboard_93: "Cosa dicono i nostri membri",
    comp_memberprofile_90: "Sei connesso come",
    comp_memberprofile_91: "← Torna al mio spazio",
    comp_memberprofile_92: "Video",
    comp_memberprofile_93: "Demo",
    comp_memberprofile_94: "Connettiti direttamente con il team.",
    comp_memberprofile_95: "Telefono",
    comp_memberprofile_96: "Prenota un appuntamento",
    comp_membersdirectory_90: "Più recenti d&apos;prima",
    comp_newslist_90: "Più recenti d&apos;prima",
    comp_publicmeetingrequest_90: "Richiedi un appuntamento",
    comp_publicmeetingrequest_91: "Richiesta inviata!",
    comp_publicmeetingrequest_92: "Il nostro team ti risponderà molto presto a",
    comp_publicmeetingrequest_93: ". A presto 🍷",
    comp_publicmeetingrequest_94: "Il tuo nome *",
    comp_publicmeetingrequest_95: "Telefono",
    comp_publicmeetingrequest_96: "Azienda",
    comp_publicmeetingrequest_97: "Oggetto dell'appuntamento *",
    comp_publicmeetingrequest_98: "Data desiderata (opzionale)",
    comp_publicmeetingrequest_99: "Presenta brevemente la tua richiesta, la tua attività, le tue aspettative…",
    comp_publicmeetingrequest_100: "Inviando questo modulo, accetti che le tue informazioni vengano utilizzate dal team La WineTech per ricontattarti. Consulta la nostra politica sulla privacy.",
    comp_renewalform_90: "Pagamento annullato. Puoi riprovare qui sotto.",
    comp_renewalform_91: "Caricamento…",
    comp_renewalform_92: "Link non valido o scaduto. Contatta La WineTech.",
    comp_renewalform_93: "La tua risposta è stata registrata. Saremo lieti di continuare a confrontarci con te.",
    comp_renewalform_94: "Reindirizzamento al pagamento…",
    comp_renewalform_95: "Valutazione complessiva (su 5)",
    comp_renewalform_96: "Il tuo commento",
    comp_renewalform_97: "Il tuo feedback sull'anno trascorso…",
    comp_renewalform_98: "Serve a calcolare automaticamente la tua quota associativa in base alla griglia La WineTech.",
    comp_renewalform_99: "Caricato",
    comp_renewalform_100: "Metodo di pagamento",
    comp_resetpassword_90: "Il link per la reimpostazione è incompleto o scaduto.",
    comp_resetpassword_91: "Richiedi un nuovo link",
    comp_resetpassword_92: "Nuova password",
    comp_resetpassword_93: "Scegli una password di almeno 8 caratteri.",
    comp_resetpassword_94: "Conferma password",
    comp_resetpassword_95: "Password aggiornata",
    comp_resetpassword_96: "Verrai reindirizzato/a alla pagina di accesso…",
    press_pressdashboard_90: "Prossimi eventi",
    press_pressdashboard_91: "Comunicati stampa",
    press_pressdashboard_92: "Cerca una notizia...",
    press_pressevents_90: "Cerca un evento, una città…",
    press_pressmembers_90: "Cerca un membro, città, tecnologia…",
  
    join_seg_startups_name: "Startup & Innovazione",
    join_seg_startups_desc: "Giovani aziende innovative che sviluppano soluzioni per il settore vitivinicolo.",
    join_seg_startups_extra_1: "Visibilità per produttori, partner e attori del settore",
    join_seg_startups_extra_2: "Accesso a investitori e partner dell'ecosistema",
    join_seg_startups_extra_3: "Opportunità di sperimentazione sul campo",
    join_seg_startups_extra_4: "Possibilità di essere integrate nei programmi di accelerazione e nelle iniziative collettive",
    join_seg_startups_extra_5: "Partecipazione a gruppi di lavoro e progetti collaborativi",
    join_seg_experts_name: "Esperti & Consulenti",
    join_seg_experts_desc: "Studi di consulenza, esperti indipendenti e accompagnatori specializzati.",
    join_seg_experts_extra_1: "Riferimento come esperto dell'ecosistema",
    join_seg_experts_extra_2: "Valorizzazione delle competenze e delle esperienze",
    join_seg_experts_extra_3: "Partecipazione a gruppi di lavoro e progetti tematici",
    join_seg_experts_extra_4: "Opportunità di collaborazione con i membri dell'ecosistema",
    join_seg_producteurs_name: "Produttori",
    join_seg_producteurs_desc: "Tenute, cantine cooperative, case di commercio e produttori impegnati nell'innovazione.",
    join_seg_producteurs_extra_1: "Monitoraggio delle innovazioni del settore",
    join_seg_producteurs_extra_2: "Scoperta di startup e soluzioni membri",
    join_seg_producteurs_extra_3: "Opportunità di sperimentazione e collaborazione",
    join_seg_producteurs_extra_4: "Possibilità di partecipare a programmi di accelerazione tematici",
    join_seg_producteurs_extra_5: "Partecipazione ai progetti collettivi promossi da WineTech",
    join_seg_fournisseurs_name: "Comunicazione, Attrezzature & Distribuzione",
    join_seg_fournisseurs_desc: "Fornitori di soluzioni, produttori di attrezzature, distributori e fornitori di servizi del settore.",
    join_seg_fournisseurs_extra_1: "Valorizzazione delle soluzioni e dei servizi offerti",
    join_seg_fournisseurs_extra_2: "Visibilità per produttori e startup",
    join_seg_fournisseurs_extra_3: "Partecipazione a progetti collaborativi",
    join_seg_fournisseurs_extra_4: "Integrazione nelle iniziative collettive dell'ecosistema",
    join_seg_ecoles_name: "Istituti & Scuole",
    join_seg_ecoles_desc: "Istituti di insegnamento, centri di ricerca, laboratori e organismi di formazione.",
    join_seg_ecoles_extra_1: "Valorizzazione dei progetti pedagogici e scientifici",
    join_seg_ecoles_extra_2: "Connessione con aziende e startup del settore",
    join_seg_ecoles_extra_3: "Partecipazione a progetti collaborativi",
    join_seg_ecoles_extra_4: "Contributo alle riflessioni e ai lavori dell'ecosistema",
    join_seg_partenaires_name: "Partner",
    join_seg_partenaires_desc: "Istituzioni, associazioni interprofessionali, organizzazioni professionali e aziende che desiderano sostenere in modo duraturo l'ecosistema WineTech.",
    join_seg_partenaires_extra_1: "Visibilità istituzionale rafforzata",
    join_seg_partenaires_extra_2: "Partecipazione agli orientamenti strategici dell'associazione",
    join_seg_partenaires_extra_3: "Supporto ai programmi strutturali del settore",
    join_seg_partenaires_extra_4: "Presenza privilegiata agli eventi WineTech",
    join_seg_partenaires_extra_5: "Partecipazione alle iniziative collettive promosse da WineTech",
    join_common_1: "Profilo membro sulla piattaforma WineTech",
    join_common_2: "Presenza nell'elenco dei membri",
    join_common_3: "Accesso agli eventi WineTech",
    join_common_4: "Accesso ai Wine Tech Coffee",
    join_common_5: "Partecipazione al Wine Tech Campus",
    join_common_6: "Accesso al monitoraggio e alle notizie dell'ecosistema",
    join_common_7: "Accesso al gruppo della community",
    join_common_8: "Identificazione all'interno dell'ecosistema WineTech",
    join_common_9: "Menzione nelle comunicazioni WineTech",
    join_prog_accel_title: "Programmi di accelerazione",
    join_prog_accel_desc: "Supporto collettivo su innovazione, sviluppo commerciale, crescita, sperimentazione sul campo e finanziamenti.",
    join_prog_export_title: "Missioni export",
    join_prog_export_desc: "Scoperta di nuovi mercati, incontri d'affari e operazioni collettive internazionali.",
    join_prog_academy_title: "WineTech Academy",
    join_prog_academy_desc: "Corsi di formazione, workshop, masterclass e condivisione di buone pratiche tra membri ed esperti.",
    join_prog_press_title: "Visibilità & Stampa",
    join_prog_press_desc: "Valorizzazione delle iniziative, comunicazione, relazioni con la stampa e azioni di promozione dell'ecosistema.",
    join_prog_events_title: "Eventi & operazioni collettive",
    join_prog_events_desc: "Wine Tech Tour, Wine Tech Coffee, Wine Tech Campus, fiere professionali e incontri tematici.",
    apply_innovation_ai: "Intelligenza artificiale",
    apply_innovation_robot: "Robotica / agritech",
    apply_innovation_iot: "Sensori / IoT",
    apply_innovation_blockchain: "Tracciabilità / blockchain",
    apply_innovation_marketplace: "Marketplace / e-commerce",
    apply_innovation_tourism: "Turismo & esperienza",
    apply_innovation_energy: "Energia & sostenibilità",
    apply_innovation_oeno: "Enologia / dati sul vino",
    apply_innovation_logistics: "Logistica & supply chain",
    apply_innovation_other: "Altro",
    apply_interest_member: "Diventare membro La WineTech",
    apply_interest_partner: "Partnership commerciale",
    apply_interest_invest: "Investimento / raccolta fondi",
    apply_interest_mentor: "Mentoring / rete",
    apply_interest_event: "Partecipare agli eventi",
    apply_interest_visibility: "Visibilità stampa / comunicazione",
    apply_interest_export: "Programma internazionale",
  
    join_annual_fee: "Quota annuale",
    apply_step_label: "Passaggio",
    apply_step_you: "Dati personali",
    apply_step_you_short: "Identità",
    apply_step_company: "La tua azienda",
    apply_step_company_short: "Azienda",
    apply_step_expectations: "Le tue aspettative",
    apply_step_expectations_short: "Finalizzazione",
    apply_btn_previous: "Precedente",
    apply_btn_continue: "Continua",
    apply_btn_submit: "Invia candidatura",
    apply_btn_submitting: "Invio…",
    apply_desc_min_chars: "Minimo 30 caratteri",
  
    portal_mycompany_collab_subtitle: "Invita i tuoi colleghi a unirsi al tuo spazio membri — potranno usufruire del tuo abbonamento senza costi aggiuntivi.",
    portal_mycompany_invite_cta_title: "Invita un collega a unirsi alla tua azienda",
    portal_mycompany_invite_cta_subtitle: "Il tuo abbonamento copre tutto il team: aggiungili affinché accedano agli eventi, al matchmaking e al monitoraggio.",
  
    cta_apply: "Candidati",
  
    join_calc_chip: "Simulatore istantaneo",
    join_calc_word_fee: "quota",
    join_calc_revenue_label: "Fatturato annuo (€)",
    join_calc_revenue_placeholder: "es: 1 500 000",
    join_calc_loading: "Calcolo...",
    join_calc_submit: "Calcola la mia tariffa",
    join_calc_bracket: "Fascia stimata",
    apply_step0_title: "Conosciamoci",
    apply_field_lastname: "Cognome *",
    apply_field_email: "Email professionale *",
    apply_form_required_toast: "Completa i campi richiesti prima di continuare.",
    apply_form_privacy_before: "I tuoi dati sono trattati in conformità con la nostra",
    apply_form_privacy_after: ". Nessuno spam, disiscrizione con 1 clic.",
    not_found_title: "Pagina non trovata",
    not_found_message: "Questa pagina non esiste o non è più accessibile. Controlla l'URL o torna alla homepage.",
    not_found_back: "Indietro",
    not_found_home: "Homepage",
    portal_mycompany_collab_status_active: "Attivo",
    portal_mycompany_collab_status_pending: "Invito in sospeso",
    portal_mycompany_collab_status_no_account: "Senza account",
  
    join_beyond_membership_desc: "L'adesione costituisce la porta d'ingresso all'ecosistema WineTech. I membri possono quindi partecipare alle iniziative e ai programmi sviluppati durante tutto l'anno.",
    apply_thanks_title: "Candidatura inviata",
    apply_thanks_intro: "Grazie! Abbiamo ricevuto la sua candidatura e le è appena stata inviata un'email di conferma.",
    apply_thanks_within: "Il nostro team la ricontatterà entro",
    apply_thanks_within_value: "48 ore lavorative",
    apply_thanks_calendar_h: "Prenoti il suo incontro di scoperta",
    apply_thanks_calendar_desc: "Per fare prima, scelga una fascia di <strong>30 min</strong> con il nostro team direttamente nel calendario.",
    apply_thanks_book_cta: "Scegliere un orario",
    apply_thanks_no_calendar: "📅 La ricontatteremo con una proposta di orario.",
    apply_thanks_back_home: "Torna alla home",
    apply_thanks_follow: "Segui La WineTech",
    apply_thanks_questions: "Hai una domanda?",
    apply_field_website: "Sito web",
    apply_field_revenue: "Fatturato annuo (€)",
    apply_field_country: "Paese *",
    apply_field_choose: "— Scegliere —",
    apply_toast_success: "Candidatura inviata!",
    apply_toast_error: "Errore di invio. Riprovi o ci contatti.",
    apply_toast_error_short: "Errore di invio",
    apply_lang_label: "Lingua / Language",
    application_validated_by: "Approvata da {name} · il {date}",
    application_rejected_by: "Rifiutata da {name} · il {date}",
  },
  pt: {
    res_dl_all: "Descarregar tudo ({n} ficheiros, ZIP)",
    res_dl_error: "Impossível descarregar",
    res_dl_one: "Descarregar",
    nl_invalid_email: "Email inválido",
    nl_success_toast: "Obrigado! Subscreveu a newsletter",
    nl_confirmed: "Subscrição confirmada — até breve!",
    nl_card_title: "Mantenha-se a par",
    nl_card_desc: "Receba a nossa newsletter mensal: eventos futuros, oportunidades, notícias da WineTech.",
    nl_email_ph: "o_seu@email.com",
    nl_subscribe: "Subscrever",
    nl_gdpr: "Anule a subscrição com 1 clique a partir de cada email. Dados protegidos (RGPD).",
    media_copy_failed: "Não foi possível copiar o URL — copie-o manualmente: {url}",
    unit_mb: "MB",
    unit_gb: "GB",
    media_load_error: "Não foi possível carregar a mediateca",
    media_format_unsupported: "Formato não suportado. Aceites: {formats}",
    media_too_large: "Ficheiro demasiado grande ({size}). Máx: {max}.",
    media_published: "Vídeo publicado",
    media_upload_failed: "Falha no upload",
    media_delete_confirm: "Eliminar o vídeo \"{title}\"?\n\nEsta ação é definitiva.",
    media_deleted: "Vídeo eliminado",
    media_url_copied: "URL pública copiada",
    media_meta_saved: "Metadados guardados",
    media_title: "A minha mediateca",
    media_intro: "Alojamentos para os seus pitchs, demos e vídeos de apresentação. Os URLs gerados podem ser copiados para as suas notícias, eventos e ofertas do Clube.",
    media_upload_btn: "Fazer upload de um vídeo",
    media_finalizing: "A finalizar…",
    media_uploading: "Upload em curso — {pct}%",
    media_formats_label: "Formatos:",
    media_max_label: "Tamanho máx:",
    media_hosting_label: "Alojamento:",
    media_hosting_value: "armazenamento seguro, reprodução otimizada para dispositivos móveis",
    media_no_transcode: "Sem transcodificação",
    media_no_transcode_hint: "— exporte os seus vídeos em formato web (MP4 H.264) antes de fazer o upload.",
    media_empty_title: "A sua mediateca está vazia",
    media_empty_desc: "Faça upload do seu primeiro vídeo (pitch de 2 min, demo de produto ou apresentação).",
    media_edit: "Editar",
    media_edit_title: "Editar vídeo",
    media_field_title: "Título",
    media_field_desc: "Descrição",
    inv_status_paid: "Paga",
    inv_status_open: "Em aberto",
    inv_status_pending: "Pagamento em curso",
    inv_status_draft: "Rascunho",
    inv_status_void: "Anulada",
    inv_status_uncollectible: "Não cobrável",
    inv_title: "Faturas",
    inv_my_title: "As minhas faturas Stripe",
    inv_empty: "Nenhuma fatura Stripe por enquanto.",
    inv_my_empty: "Nenhuma fatura Stripe por enquanto. As suas futuras quotas e pagamentos de eventos aparecerão aqui.",
    inv_load_error: "Não foi possível carregar as faturas",
    inv_total_paid: "Total pago:",
    inv_refresh_title: "Atualizar a partir do Stripe",
    inv_refresh: "Atualizar",
    inv_stripe_not_configured: "Stripe não está configurado no servidor — apenas as sessões de checkout locais são visíveis.",
    inv_col_date: "Data",
    inv_col_number: "Número",
    inv_col_description: "Descrição",
    inv_col_amount: "Valor",
    inv_col_status: "Estado",
    inv_col_actions: "Ações",
    inv_checkout_session: "Sessão de pagamento",
    inv_open_payment: "Abrir a página de pagamento",
    inv_view_stripe: "Ver a fatura Stripe",
    inv_pay: "Pagar",
    inv_view: "Ver",
    inv_download_pdf: "Descarregar o PDF",
    proj_seo_title: "Projetos WineTech — Iniciativas coletivas da indústria do vinho",
    proj_seo_desc: "Descubra os projetos e programas impulsionados pela La WineTech: agroecologia, logística de carbono zero, soberania de dados… Os membros que constroem o futuro do vinho.",
    proj_badge: "Programas WineTech",
    proj_h1_a: "Os projetos que moldam",
    proj_h1_b: "o vinho de amanhã",
    proj_intro: "Cada projeto reúne membros voluntários em torno de um desafio estratégico: inovação, sustentabilidade, soberania, novas utilizações. Explore, inspire-se, junte-se a nós.",
    proj_empty: "Os projetos WineTech chegarão em breve. Volte rapidamente!",
    proj_tag: "Projeto",
    proj_discover: "Descobrir",
    proj_not_found: "Projeto não encontrado",
    proj_back: "Voltar aos projetos",
    proj_all: "Todos os projetos",
    proj_tag_full: "Projeto WineTech",
    proj_members_one: "{n} membro envolvido",
    proj_members_many: "{n} membros envolvidos",
    proj_members_title: "Os membros que impulsionam o projeto",
    proj_members_empty: "Seja o primeiro membro a juntar-se a este projeto.",
    exh_no_company: "Nenhuma ficha de empresa associada à sua conta.",
    exh_resynced: "Informações ressincronizadas a partir da sua ficha de empresa",
    exh_resync_error: "Não foi possível ressincronizar",
    exh_name_required: "Nome da empresa obrigatório",
    exh_choose_role: "Escolha uma função",
    exh_validated: "Expositor validado",
    exh_submitted: "Candidatura enviada — aguarda validação do administrador",
    exh_title: "Inscrição de Expositor",
    exh_company_card: "Ficha da empresa membro",
    exh_resync_title: "Recarregar as informações da sua ficha de empresa membro",
    exh_resync: "Ressincronizar",
    exh_company_name: "Nome da empresa *",
    exh_role: "A sua função *",
    exh_select: "— Selecionar —",
    exh_booth: "N.º de stand",
    exh_booth_ph: "ex: B12",
    exh_logo: "Logótipo (URL)",
    exh_desc: "Breve descrição",
    exh_desc_ph: "Apresente a sua empresa em poucas palavras…",
    exh_fee_title: "Taxa de inscrição de expositor",
    exh_secure_payment: "Pagamento seguro via Stripe. A sua inscrição será validada automaticamente após o pagamento.",
    exh_free_title: "Inscrição gratuita",
    exh_auto_admin: "Validação automática (administrador).",
    exh_review_team: "A sua candidatura será analisada pela equipa La WineTech.",
    exh_pay: "Pagar {price}",
    exh_confirm: "Confirmar inscrição",
    sidebar_member_shared_services: "Serviços partilhados",
    sidebar_member_media: "Mediateca",
    nav_formations: "Formações",
    nav_support_us: "Apoie-nos",
    nav_opportunities: "Oportunidades",
    nav_community: "A Comunidade",
    newsletter_band_title: "Mantenha-se informado(a) sobre as notícias da WineTech",
    newsletter_band_desc: "Próximos eventos, oportunidades, petições e inovações — 1 email por mês, anule a subscrição com 1 clique.",
    newsletter_subscribe_aria: "Subscrever a newsletter",
    newsletter_later: "Mais tarde",
    credit_dev_by: "Plataforma desenvolvida gratuitamente por",
    credit_for: "para La WineTech.",
    nav_home: "Início",
    nav_news: "Notícias",
    nav_events: "Eventos",
    nav_members: "Membros",
    nav_projects: "Projetos",
    nav_about: "Sobre",
    nav_contact: "Contato",
    nav_back_to_site: "Voltar ao site",
    auto_translated: "Traduzido automaticamente",
    loading: "A carregar...",
    news_title: "Revista de notícias",
    news_subtitle: "Toda a inovação do ecossistema WineTech: entrevistas, análises, rondas de financiamento e lançamentos.",
    news_seo_title: "Notícias e análises",
    news_seo_desc: "Últimas notícias, análises e histórias do ecossistema global de inovação vínica — startups, tecnologia, tendências de mercado e anúncios dos membros.",
    news_search_placeholder: "Pesquisar notícias...",
    back_to_news: "Voltar às notícias",
    related_articles: "Artigos relacionados",
    read_more: "Ler mais",
    filter_all: "Todos",
    cat_innovation: "Inovação",
    cat_technology: "Tecnologia",
    cat_startup: "Startup",
    cat_market: "Mercado",
    cat_digital: "Digital",
    cat_announcement: "Comunicado",
    events_title: "Eventos",
    events_subtitle: "Conferências, webinars, afterworks, masterclasses: os encontros da comunidade WineTech.",
    events_seo_title: "Eventos",
    events_seo_desc: "Descubra os próximos eventos WineTech — conferências, reuniões 1:1, workshops e encontros de inovação no ecossistema vínico global.",
    events_upcoming: "Próximos",
    events_past: "Passados",
    events_all_formats: "Todos os formatos",
    events_format_physical: "Presencial",
    events_format_digital: "Digital",
    events_format_hybrid: "Híbrido",
    events_registered: "inscritos",
    back_to_events: "Voltar aos eventos",
    cta_join: "Juntar-se",
    cta_explore: "Explorar a comunidade",
    cta_see_events: "Ver eventos",
    cta_visit_website: "Visitar o site",
    hero_title_pre: "A comunidade",
    hero_title_brand: "WineTech",
    hero_subtitle: "Conectar talentos, partilhar inovação e construir o futuro do vinho.",
    innovate_together: "Inovamos juntos",
    actu: "Notícias",
    upcoming_events: "Próximos eventos",
    community_members: "Membros da comunidade",
    see_all_news: "Ver todas as notícias",
    see_all_events: "Ver todos os eventos",
    see_all_members: "Ver todos os membros",
    learn_more: "Saber mais",
    apply_now: "Candidatar-se",
    login: "Entrar",
    login_title: "Entrar",
    login_welcome_back: "Felizes em vê-lo de novo.",
    login_loading: "A entrar...",
    login_no_account: "Ainda não é membro?",
    login_create_account: "Criar conta",
    login_welcome_toast: "Bem-vindo!",
    login_brand_title_pre: "Bem-vindo à",
    login_brand_title_brand: "comunidade WineTech",
    login_brand_subtitle: "Entre para aceder ao seu espaço dedicado, reuniões e diretório privado.",
    login_demo_accounts: "Contas demo (clique para preencher):",
    login_demo_admin: "Admin",
    login_demo_member: "Membro",
    login_demo_press: "Imprensa",
    email: "Email",
    password: "Palavra-passe",
    register: "Registar",
    register_title: "Criar conta",
    register_loading: "A criar...",
    register_have_account: "Já registado?",
    register_first_name: "Nome",
    register_last_name: "Apelido",
    register_submit: "Registar",
    logout: "Sair",
    forgot_password: "Esqueceu a palavra-passe?",
    register_role_applicant: "Candidato (membro)",
    register_role_event: "Visitante de evento",
    register_role_journalist: "Jornalista / Imprensa",
    register_company_or_media: "Empresa / Media",
    register_i_am: "Eu sou",
    register_brand_title_pre: "Junte-se à",
    register_brand_subtitle: "Crie a sua conta para se candidatar, participar em eventos ou aceder ao portal imprensa.",
    dashboard: "Painel",
    my_profile: "Meu perfil",
    portal_member: "Portal membro",
    portal_press: "Portal imprensa",
    portal_admin: "CRM Admin",
    apply_join: "Candidatar a La WineTech",
    join_intro: "Junte-se ao ecossistema WineTech global.",
    sidebar_member_dashboard: "Painel",
    sidebar_member_profile: "Perfil de membro",
    sidebar_member_my_company: "Minha empresa",
    sidebar_member_score: "Minha pontuação",
    sidebar_member_notifications: "Notificações",
    sidebar_member_matchmaking: "Matchmaking",
    sidebar_member_products: "Produtos e Serviços",
    sidebar_member_team: "Equipa",
    sidebar_member_news: "Publicações",
    sidebar_member_events: "Eventos",
    sidebar_member_directory: "Diretório",
    sidebar_member_meetings: "Reuniões",
    sidebar_member_messages: "Mensagens",
    sidebar_member_resources: "Recursos",
    sidebar_personal_profile: "Perfil pessoal",
    sidebar_admin_dashboard: "Painel",
    sidebar_admin_pipeline: "Pipeline CRM",
    sidebar_admin_members: "Membros",
    sidebar_admin_applications: "Candidaturas",
    sidebar_admin_news: "Notícias",
    sidebar_admin_events: "Eventos",
    sidebar_admin_meetings: "Reuniões",
    sidebar_admin_analytics: "Analytics",
    sidebar_admin_settings: "Definições",
    sidebar_press_dashboard: "Painel",
    sidebar_press_releases: "Comunicados",
    sidebar_press_events: "Eventos",
    sidebar_press_members: "Membros",
    sidebar_press_resources: "Recursos",
    sidebar_need_help: "Precisa de ajuda?",
    sidebar_help_text: "A nossa equipa está aqui para ajudar.",
    sidebar_contact_us: "Contacte-nos",
    search: "Procurar",
    search_placeholder: "Procurar uma empresa, uma tecnologia...",
    category: "Categoria",
    country: "País",
    all: "Todos",
    all_categories: "Todas as categorias",
    all_countries: "Todos os países",
    all_poles: "Todos os setores",
    no_results: "Sem resultados.",
    no_members_found: "Nenhum membro encontrado. Altere os filtros.",
    submit: "Enviar",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Adicionar",
    close: "Fechar",
    confirm: "Confirmar",
    publish: "Publicar",
    download: "Baixar",
    open: "Abrir",
    pending: "Pendente",
    approved: "Aprovado",
    rejected: "Rejeitado",
    draft: "Rascunho",
    active: "Ativo",
    published: "Publicado",
    archived: "Arquivado",
    paid: "Pago",
    pending_payment: "Pagamento pendente",
    confirmed: "Confirmado",
    book_meeting: "Marcar reunião",
    exhibitors: "Expositores",
    matchmaking: "Matchmaking",
    register_for_event: "Inscrever-se no evento",
    visitor: "Visitante",
    exhibitor: "Expositor",
    media: "Media / Imprensa",
    free: "Grátis",
    speakers: "Oradores",
    sponsors: "Patrocinadores",
    attendees: "Participantes",
    check_in: "Check-in",
    pricing: "Tarifas",
    transactions: "Transações",
    about: "Sobre",
    expertise: "Competências",
    products_services: "Produtos e Serviços",
    company_news: "Notícias",
    technologies: "Tecnologias",
    activities: "Atividades",
    founded_in: "Fundada em",
    employees: "colaboradores",
    active_member: "Membro ativo",
    tags: "Etiquetas",
    community_score: "Pontuação comunidade",
    points: "pts",
    back_to_members: "Voltar aos membros",
    resources: "Recursos",
    press_releases: "Comunicados",
    media_kit: "Kit de imprensa",
    welcome: "Bem-vindo",
    success_saved: "Guardado com sucesso",
    error_generic: "Ocorreu um erro",
    footer_intro: "A La WineTech conecta os talentos da inovação vitivinícola em todo o mundo. Uma comunidade única para partilhar, aprender, colaborar.",
    footer_platform: "Plataforma",
    footer_spaces: "Espaços",
    footer_rights: "Todos os direitos reservados.",
    footer_made_with: "Feito com ♥ para a indústria do vinho.",
    members_directory_intro: "Descubra todos os atores da inovação WineTech, as suas especialidades e tecnologias.",
    portal_exhibitormatchmaking_01: "Slots disponíveis",
    portal_exhibitormatchmaking_02: "Nenhum slot disponível para este contacto.",
    portal_matchmaking_01: "Sugeridos:",
    portal_matchmaking_02: "e o que pretende",
    portal_matchmaking_03: ". A plataforma conecta-o(a) automaticamente com os melhores perfis.",
    portal_matchmaking_04: "As suas especializações, serviços, tecnologias, mercados a que se dirige.",
    portal_matchmaking_05: "Parcerias, tecnologias, recursos, mercados a que deseja aceder.",
    portal_memberdashboard_01: "Aqui está um resumo da sua atividade na comunidade WineTech.",
    portal_memberdashboard_02: "A minha empresa",
    portal_memberdashboard_03: "Nenhuma empresa associada.",
    portal_memberdashboard_04: "Completar o meu perfil →",
    portal_memberdashboard_05: "Próximos eventos",
    portal_memberdashboard_06: "Ver tudo",
    portal_memberdashboard_07: "Desenvolva a sua visibilidade na comunidade",
    portal_memberdashboard_08: "Publique notícias, participe em eventos, marque reuniões com outros intervenientes.",
    portal_memberdashboard_09: "Publicar uma notícia",
    portal_memberdirectory_01: "Descubra e conecte-se com os outros membros da comunidade.",
    portal_memberdirectory_02: "Mais recentes primeiro",
    portal_memberevents_01: "Eventos",
    portal_memberevents_02: "Inscreva-se nos próximos eventos da comunidade.",
    portal_memberevents_03: "A vir",
    portal_memberevents_04: "Passados",
    portal_memberevents_05: "Todos os públicos",
    portal_memberevents_06: "Data mais próxima",
    portal_memberevents_07: "Data mais distante",
    portal_memberevents_08: "Publicado recentemente",
    portal_memberevents_09: "Publicado há muito tempo",
    portal_membermeetings_01: "As minhas reuniões",
    portal_membermeetings_02: "Gerencie as suas reuniões, a sua disponibilidade e o seu planeamento Reuniões 1:1.",
    portal_membermeetings_03: "O meu planeamento Reuniões 1:1",
    portal_membermeetings_04: "Descubra os eventos",
    portal_membermeetings_05: "e reserve a sua próxima reunião.",
    portal_membermeetings_06: "Os meus eventos como expositor",
    portal_membermeetings_07: "Selecione os slots durante os quais está disponível para encontrar visitantes. Apenas os slots marcados serão propostos para reserva.",
    portal_membermeetings_08: "Validado",
    portal_membermeetings_09: "⚠️ Nenhum slot selecionado. Os visitantes não podem reservar enquanto não indicar a sua disponibilidade.",
    portal_membermeetings_10: "A minha disponibilidade",
    portal_membermessages_01: "Conversas privadas com a comunidade.",
    portal_membermessages_02: "Selecione uma conversa.",
    portal_membernews_01: "As minhas notícias",
    portal_membernews_02: "Submeta as suas notícias, lançamentos, angariações de fundos.",
    portal_membernews_03: "Validação necessária pela equipa La WineTech",
    portal_membernews_04: "A sua notícia será revista por um administrador. Prazo de validação:",
    portal_membernews_05: "24 a 72h",
    portal_membernews_06: "Submeter para validação",
    portal_membernews_07: "Categoria",
    portal_membernews_08: "Nenhuma notícia publicada por enquanto.",
    portal_memberproducts_01: "Nenhuma empresa associada.",
    portal_memberproducts_02: "Destaque das suas ofertas no ecossistema WineTech.",
    portal_memberproducts_03: "Vídeo",
    portal_memberproducts_04: "Demonstração",
    portal_memberproducts_05: "Nenhum produto nem serviço publicado.",
    portal_memberprofile_01: "Cuide da sua ficha para ganhar visibilidade no ecossistema.",
    portal_memberprofile_02: "Ver a minha ficha pública",
    portal_memberprofile_03: "Publicar uma notícia",
    portal_memberprofile_04: "Preenchimento",
    portal_memberprofile_05: "Os meus eventos",
    portal_memberprofile_06: "Ver tudo →",
    portal_memberprofile_07: "Nenhum evento futuro.",
    portal_memberprofile_08: "Descobrir os eventos →",
    portal_memberprofile_09: "As minhas publicações",
    portal_memberprofile_10: "Gerir →",
    portal_memberprofile_11: "Partilhe as suas novidades com a comunidade WineTech para aumentar a sua visibilidade.",
    portal_memberprofile_12: "Apresentação longa (Markdown)",
    portal_memberprofile_13: "Setor principal",
    portal_memberprofile_14: "Tags especiais",
    portal_memberprofile_15: "Atividades secundárias",
    portal_memberprofile_16: "Mercados-alvo",
    portal_memberprofile_17: "Ajude o ecossistema a encontrá-lo — escolha todos os tags que se aplicam à sua atividade. Filtráveis no diretório e usados nas fichas de evento.",
    portal_memberresources_01: "Descarregar",
    portal_memberteam_01: "Nenhuma empresa associada.",
    portal_memberteam_02: "Equipa",
    portal_memberteam_03: "Gira os colaboradores da sua empresa e os respetivos papéis.",
    portal_memberteam_04: "Convite criado ✓",
    portal_memberteam_05: "Palavra-passe temporária",
    portal_memberteam_06: "(a transmitir manualmente — o email de convite Brevo será ligado numa próxima iteração):",
    portal_memberteam_07: "Convidar outro colaborador",
    portal_memberteam_08: "Papel",
    portal_mycompany_01: "A minha empresa",
    portal_mycompany_02: "Complete as informações da sua ficha de empresa e gira os seus colaboradores.",
    portal_mycompany_03: "O",
    portal_mycompany_04: "é exibido em todo o lado (diretório, eventos, visuais, crachás). A",
    portal_mycompany_05: "entidade legal",
    portal_mycompany_06: "é utilizada apenas para faturação Stripe.",
    portal_mycompany_07: "Exibido em todos os suportes públicos",
    portal_mycompany_08: "Entidade legal (faturação)",
    portal_mycompany_09: "Utilizada para Stripe e faturas",
    portal_mycompany_10: "Apenas o contacto principal pode alterar estas informações",
    portal_mycompany_11: "Adicionar um colaborador",
    portal_mycompany_12: "Definir como contacto principal",
    portal_mycompany_13: "Nenhum colaborador. Adicione a sua equipa para desfrutar plenamente dos benefícios da La WineTech.",
    portal_myeventpage_01: "← O Meu Portal",
    portal_myeventpage_02: "Remover inscrição",
    portal_myeventpage_03: "Ver a página pública",
    portal_myeventpage_04: "Ainda não está inscrito(a) neste evento.",
    portal_myeventpage_05: "Visite a",
    portal_myeventpage_06: "para se inscrever.",
    portal_myeventpage_07: "🎥 Evento online",
    portal_myeventpage_08: "Código de acesso:",
    portal_myeventpage_09: "Aderir à videochamada →",
    portal_myeventpage_10: "Passo 1",
    portal_myeventpage_11: "Descarregue o seu crachá",
    portal_myeventpage_12: "Apresente-o na receção no dia do evento.",
    portal_myeventpage_13: "Descarregar PDF",
    portal_myeventpage_14: "Passo 2",
    portal_myeventpage_15: "Ver a secção ↓",
    portal_myeventpage_16: "No Dia do Evento",
    portal_myeventpage_17: "As Minhas Disponibilidades Reuniões 1:1",
    portal_myeventpage_18: "Está inscrito(a) como expositor(a)",
    portal_myeventpage_19: "Marque os períodos em que estará disponível para se encontrar com visitantes. Apenas os períodos marcados serão propostos para reserva.",
    portal_myeventpage_20: "Validado",
    portal_myeventpage_21: "Nenhum período selecionado — os visitantes não podem reservar consigo.",
    portal_myeventpage_22: "Vista de calendário completa",
    portal_myeventpage_23: "Nenhum expositor validado de momento. Volte mais tarde ⏳",
    portal_myeventpage_24: "Os Meus Encontros Confirmados",
    portal_myscore_01: "A Minha Pontuação da Comunidade",
    portal_myscore_02: "O seu envolvimento na comunidade WineTech, calculado de acordo com critérios transparentes.",
    portal_myscore_03: "Quanto mais contribuir, maior será a sua visibilidade",
    portal_myscore_04: "Detalhe dos pontos",
    portal_myscore_05: "Preencha a ficha da sua empresa (logótipo, descrição, website) — ganho imediato.",
    portal_myscore_06: "Adicione o LinkedIn e um link de calendário para cada colaborador.",
    portal_myscore_07: "Publique as suas notícias através do seu portal de membro.",
    portal_myscore_08: "Inscreva-se e participe nos eventos da comunidade.",
    portal_myscore_09: "Adicione os seus colaboradores a partir da página «A Minha Empresa».",
    portal_notifications_01: "Tudo o que acontece na sua comunidade, num piscar de olhos.",
    portal_notifications_02: "Preferências de e-mail",
    portal_notifications_03: "Para cada categoria, escolha se pretende receber um e-mail para além da notificação na aplicação.",
    portal_notifications_04: "Nenhuma notificação de momento.",
    portal_notifications_05: "Ver →",
    portal_personalprofile_01: "O Meu Perfil Pessoal",
    portal_personalprofile_02: "Atualize as suas informações pessoais, a sua foto e o seu calendário público.",
    portal_personalprofile_03: "Identidade",
    portal_personalprofile_04: "Primeiro Nome",
    portal_personalprofile_05: "Telefone",
    portal_personalprofile_06: "Calendly, Cal.com, Google Agenda… este link será sugerido para agendar reuniões consigo.",
    press_pressdashboard_01: "Bem-vindo(a) ao seu espaço de imprensa WineTech. Aceda às últimas notícias da comunidade.",
    press_pressdashboard_02: "Acesso de jornalista aprovado",
    press_pressdashboard_03: "Tem acesso completo a todas as notícias da plataforma.",
    press_pressdashboard_04: "Ver o meu perfil",
    press_pressdashboard_05: "Últimas notícias",
    press_pressdashboard_06: "Categorias",
    press_pressdashboard_07: "Todas as categorias",
    press_pressdashboard_08: "A nossa equipa de imprensa está à sua disposição para qualquer questão.",
    press_pressevents_01: "Eventos",
    press_pressevents_02: "Aceda a todos os eventos da comunidade WineTech.",
    press_pressevents_03: "Próximos",
    press_pressevents_04: "Passados",
    press_pressevents_05: "Data mais próxima",
    press_pressevents_06: "Data mais distante",
    press_pressevents_07: "Publicado recentemente",
    press_pressevents_08: "Publicado há muito tempo",
    press_pressmembers_01: "Descubra os intervenientes na inovação do vinho.",
    press_pressmembers_02: "Mais recentes primeiro",
    press_pressreleases_01: "Comunicados de imprensa",
    press_pressreleases_02: "Mais recentes primeiro",
    press_pressreleases_03: "Nenhum comunicado de momento.",
    press_pressresources_01: "Kit de imprensa e recursos",
    press_pressresources_02: "Logotipos, fotos oficiais, comunicados e relatórios.",
    press_pressresources_03: "Descarregar",
    layout_publiclayout_01: "📝 Submeter a minha candidatura",
    layout_publiclayout_02: "Necessita de um CRM, portal de cliente, extranet, aplicação de negócio ou plataforma SaaS personalizada para impulsionar o seu desenvolvimento?",
    portal_mycompany_readonly: "Está a consultar este perfil apenas de leitura. Apenas o contacto principal (ou um administrador) pode modificar estas informações. Peça ao seu contacto principal para ativar a opção «Permitir que outros colaboradores modifiquem» nesta página.",
  
    portal_exhibitormatchmaking_90: "A carregar...",
    portal_memberdashboard_90: "Notícias publicadas",
    portal_memberdashboard_91: "Eventos aderidos",
    portal_memberdashboard_92: "Visualizações do seu perfil",
    portal_memberdashboard_93: "Editar",
    portal_memberevents_90: "Procurar evento, cidade…",
    portal_membermeetings_90: "Adicionar",
    portal_membermessages_90: "Nova mensagem",
    portal_membermessages_91: "A sua resposta…",
    portal_membermessages_92: "Enviar",
    portal_membermessages_93: "Procurar membro, admin, imprensa…",
    portal_membermessages_94: "A sua mensagem…",
    portal_membernews_90: "Imagem de capa",
    portal_memberproducts_90: "Descrição detalhada",
    portal_memberproducts_91: "URL de vídeo do YouTube/Vimeo",
    portal_memberproducts_92: "URL de demonstração",
    portal_memberproducts_93: "Adicionar",
    portal_memberproducts_94: "Eliminar",
    portal_memberprofile_90: "Identidade",
    portal_memberprofile_91: "Faixa (16:5 recomendado)",
    portal_memberprofile_92: "Ano de criação",
    portal_memberprofile_93: "Apresentação",
    portal_memberprofile_94: "Redes sociais",
    portal_memberteam_90: "Nome próprio",
    portal_memberteam_91: "Enviar o convite",
    portal_memberteam_92: "Nenhum colaborador.",
    portal_mycompany_90: "A carregar…",
    portal_mycompany_91: "E-mail de contacto",
    portal_mycompany_92: "Telefone",
    portal_mycompany_93: "Descrição / apresentação",
    portal_mycompany_94: "Logótipo (quadrado, 512×512 recomendado)",
    portal_mycompany_95: "Faixa (16:9, 1600×900 recomendado)",
    portal_mycompany_96: "Guardar",
    portal_mycompany_97: "Nome próprio *",
    portal_mycompany_98: "Adicionar e enviar o convite",
    portal_mycompany_99: "Cancelar",
    portal_mycompany_100: "Reenviar",
    portal_mycompany_101: "Convidar",
    portal_myeventpage_90: "A carregar…",
    portal_myscore_90: "A carregar…",
    portal_personalprofile_90: "A carregar...",
    portal_personalprofile_91: "Importar foto (JPG/PNG, ≤ 5 MB)",
    portal_personalprofile_92: "Algumas linhas para se apresentar…",
    layout_portallayout_90: "Fechar o menu",
    layout_portallayout_91: "Abrir o menu",
    layout_publiclayout_90: "Descobrir a adesão à La WineTech",
    layout_publiclayout_91: "Candidatar-me",
  
    sidebar_help_mode_emploi: "Guia de Utilização",
    sidebar_admin_prospects: "Prospectos",
    sidebar_admin_contacts: "Contactos",
    sidebar_admin_formations: "Formações",
    sidebar_admin_checkin_qr: "Check-in (QR)",
    sidebar_admin_administrators: "Administradores",
    sidebar_admin_emails: "Emails",
    sidebar_admin_mailshot: "Mailshot CRM",
    sidebar_admin_scoring: "Scoring",
    sidebar_admin_renewals: "Renovações",
    sidebar_admin_activity_log: "Registo de Atividade",
    sidebar_admin_ai_feedback: "Feedback da IA",
    subtitle_admin: "Admin",
    subtitle_press: "Inovação e Partilha",
    subtitle_member: "Comunidade e Inovação",
    user_label_default: "Utilizador",
    role_admin: "Administrador",
    role_member: "Membro",
    role_press: "Imprensa",
    role_applicant: "Candidato",
    role_event_visitor: "Visitante do Evento",
    role_journalist: "Jornalista",
    title_admin_dashboard: "Painel de Administração",
    title_press_portal: "Portal da Imprensa",
    title_member_portal: "Portal do Membro",
  
    portal_mycompany_section_title: "Ficha da empresa",
    portal_mycompany_name_label: "Nome comercial *",
    portal_mycompany_legal_label: "Designação social",
    portal_mycompany_name_term: "nome comercial",
    portal_mycompany_legal_term: "designação social",
    portal_mycompany_name_placeholder: "Ex: VineaTech",
    portal_mycompany_legal_placeholder: "Ex: VineaTech SAS",
    portal_mycompany_vat_placeholder: "N.º IVA intracomunitário",
    portal_mycompany_website_placeholder: "Site web",
    portal_mycompany_city_placeholder: "Cidade",
    portal_mycompany_collaborators_title: "Colaboradores",
    portal_mycompany_email_required_placeholder: "E-mail *",
    portal_mycompany_lastname_required_placeholder: "Apelido *",
    portal_mycompany_jobtitle_placeholder: "Função",
    portal_mycompany_linkedin_placeholder: "URL LinkedIn",
    portal_mycompany_calendar_placeholder: "Link do calendário (Calendly, Google…)",
    portal_mycompany_primary_badge: "Principal",
    image_upload_replace: "Substituir",
    image_upload_loading: "A carregar…",
    search_button: "Pesquisar",
    common_required: "(obrigatório)",
  
    comp_aboutpage_90: "Sobre a La WineTech",
    comp_aboutpage_91: "Sobre a La WineTech",
    comp_aboutpage_92: "A nossa missão",
    comp_aboutpage_93: "O ecossistema",
    comp_activateaccount_90: "Ativar a minha conta",
    comp_activateaccount_91: "A verificar o link…",
    comp_activateaccount_92: "Pedir um novo link",
    comp_activateaccount_93: "Conta ativada!",
    comp_activateaccount_94: "A redirecionar para a página de início de sessão…",
    comp_activateaccount_95: "Ativar a sua conta",
    comp_activateaccount_96: "Escolha uma palavra-passe para concluir a ativação.",
    comp_activateaccount_97: "Palavra-passe (6+ caracteres)",
    comp_activateaccount_98: "Confirmar palavra-passe",
    comp_applypage_90: "Candidatar-se | La WineTech",
    comp_applypage_91: "La WineTech",
    comp_applypage_92: "Juntar-se à comunidade",
    comp_applypage_93: "3 minutos para nos apresentar o seu projeto. A nossa equipa entrará em contacto consigo em 48h.",
    comp_applypage_94: "Os seus dados pessoais. Tratamos os seus dados em conformidade com o RGPD.",
    comp_applypage_95: "Primeiro nome *",
    comp_applypage_96: "Telefone",
    comp_applypage_97: "O seu LinkedIn",
    comp_applypage_98: "Aceito receber comunicações da La WineTech (eventos, oportunidades, newsletter). É possível anular a subscrição a qualquer momento.",
    comp_applypage_99: "Sobre a sua estrutura",
    comp_applypage_100: "Esta informação permite-nos avaliar o seu perfil e a contribuição adequada.",
    comp_applypage_101: "Nome da empresa *",
    comp_applypage_102: "A sua função",
    comp_applypage_103: "Adaptamos a contribuição ao tamanho da sua estrutura.",
    comp_applypage_104: "Categoria *",
    comp_applypage_105: "Tipo(s) de inovação / de interesses",
    comp_applypage_106: "Apresente a sua estrutura em poucas linhas *",
    comp_applypage_107: "Qual é a sua atividade? Quais são os seus principais desafios?",
    comp_applypage_108: "Último passo",
    comp_applypage_109: "Ajude-nos a perceber o que espera da La WineTech.",
    comp_applypage_110: "O que mais lhe interessa *",
    comp_applypage_111: "💡 Próximos passos",
    comp_applypage_112: "Analisaremos a sua candidatura em 48 horas úteis",
    comp_applypage_113: "Receberá uma confirmação por e-mail imediatamente",
    comp_applypage_114: "Se elegível, ser-lhe-á proposto um horário para uma conversa",
    comp_applypage_115: "política de privacidade",
    comp_applythankspage_90: "Candidatura enviada | La WineTech",
    comp_applythankspage_91: "48 horas úteis",
    comp_applythankspage_92: "Reserve a sua reunião de descoberta",
    comp_applythankspage_93: "Siga a La WineTech",
    comp_applythankspage_94: "Alguma questão?",
    comp_billingpage_90: "Informação de faturação enviada",
    comp_billingpage_91: "A nossa equipa irá agora emitir a sua fatura. Receberá em breve um e-mail com o link de pagamento seguro Stripe.",
    comp_billingpage_92: "! A sua candidatura para",
    comp_billingpage_93: "Número de IVA",
    comp_billingsuccess_90: "A confirmar o pagamento…",
    comp_billingsuccess_91: "Bem-vindo(a) a",
    comp_billingsuccess_92: "a comunidade",
    comp_billingsuccess_93: "O seu pagamento de",
    comp_billingsuccess_94: "está confirmado. A nossa equipa irá finalizar o seu onboarding e irá contactá-lo(a) em breve para a sua chamada de boas-vindas.",
    comp_billingsuccess_95: "Aceder ao meu espaço",
    comp_billingsuccess_96: "O Stripe está a processar o seu pagamento. Receberá um e-mail assim que for confirmado.",
    comp_billingsuccess_97: "Erro",
    comp_billingsuccess_98: "Não foi possível verificar o pagamento. Contacte a equipa.",
    comp_contactpage_90: "Tem uma pergunta, um projeto, uma candidatura? Escreva-nos e a nossa equipa responderá em 48 horas.",
    comp_contactpage_91: "Mensagem recebida!",
    comp_contactpage_92: "A nossa equipa recebeu a sua mensagem e entrará em contacto muito em breve.",
    comp_contactpage_93: "Enviar outra mensagem",
    comp_contactpage_94: "Primeiro nome *",
    comp_contactpage_95: "Telefone",
    comp_contactpage_96: "— Área de atividade (opcional) —",
    comp_contactpage_97: "A sua mensagem *",
    comp_contactpage_98: "Aceito que os meus dados sejam registados pela La WineTech para processar o meu pedido (em conformidade com o RGPD). Os meus dados nunca serão revendidos.",
    comp_contactpage_99: "Ou escreva-nos diretamente para",
    comp_digestsubscribepage_90: "Registado!",
    comp_digestsubscribepage_91: "Receberá o seu primeiro Weekly Digest na próxima quinta-feira às 9h. Poderá alterar as suas preferências ou cancelar a subscrição a partir de cada e-mail.",
    comp_digestsubscribepage_92: "Todas as quintas-feiras às 9h, receba o essencial da WineTech de acordo com os seus interesses — notícias dos membros, inovações, ciência, regulamentação e eventos futuros.",
    comp_digestsubscribepage_93: "Primeiro nome",
    comp_digestsubscribepage_94: "🇫🇷 Francês",
    comp_digestsubscribepage_95: "🇵🇹 Português",
    comp_digestsubscribepage_96: "Interesses",
    comp_digestsubscribepage_97: "— tudo selecionado por predefinição",
    comp_eventdetail_90: "A carregar...",
    comp_eventdetail_91: "Está ligado como",
    comp_eventdetail_92: "← Voltar ao meu espaço",
    comp_eventdetail_93: "📄 Catálogo do evento",
    comp_eventdetail_94: "PDF completo com a lista de expositores, visitantes e oradores — atualizado em tempo real.",
    comp_eventdetail_95: "Ver as reuniões",
    comp_eventdetail_96: "Quem estará presente?",
    comp_eventdetail_97: "Lista pública de inscritos confirmados — venha conhecer estes membros e expositores da comunidade WineTech.",
    comp_eventdetail_98: "Inscrição confirmada",
    comp_eventdetail_99: "Confirmar o cancelamento da inscrição?",
    comp_eventdetail_100: "Confirmar",
    comp_eventdetail_101: "Cancelar",
    comp_eventdetail_102: "Já é membro?",
    comp_eventdetail_103: "Inscrição confirmada!",
    comp_eventdetail_104: "ativar a sua conta",
    comp_eventdetail_105: "Descarregar o meu crachá em PDF",
    comp_eventdetail_106: "Inscrição no evento",
    comp_eventdetail_107: "💳 Após este formulário, será redirecionado para a página de pagamento seguro Stripe. O seu crachá será emitido após o pagamento.",
    comp_eventdetail_108: "— Gratuito. O seu crachá será emitido imediatamente.",
    comp_eventdetail_109: "Primeiro nome *",
    comp_eventdetail_110: "Empresa",
    comp_eventdetail_111: "Telefone",
    comp_eventdetail_112: "Será criada uma conta pessoal automaticamente (e-mail de ativação enviado) para que possa encontrar o seu crachá e participar nas reuniões rápidas.",
    comp_eventdetail_113: "Pesquisar um nome, empresa, produto...",
    comp_eventdetail_114: "Ordenar: Primeiro nome A→Z",
    comp_eventdetail_115: "Ordenar: Empresa A→Z",
    comp_eventdetail_116: "Ordenar: Perfis mais ricos",
    comp_eventpaymentsuccess_90: "A verificar o pagamento…",
    comp_eventpaymentsuccess_91: "Pagamento confirmado!",
    comp_eventpaymentsuccess_92: "A sua inscrição foi validada. Aqui está o seu crachá.",
    comp_eventpaymentsuccess_93: "O pagamento está a demorar mais do que o esperado. Receberá um e-mail de confirmação assim que for validado.",
    comp_eventpaymentsuccess_94: "Voltar ao evento",
    comp_eventpaymentsuccess_95: "Pagamento não confirmado",
    comp_eventpaymentsuccess_96: "Ocorreu um erro. Se foi cobrado, entre em contacto connosco.",
    comp_eventslist_90: "Pesquisar um evento, cidade…",
    comp_eventslist_91: "Data mais próxima",
    comp_eventslist_92: "Data mais distante",
    comp_eventslist_93: "Publicado recentemente",
    comp_eventslist_94: "Publicado há muito tempo",
    comp_exhibitorpaymentsuccess_90: "A verificar o pagamento…",
    comp_exhibitorpaymentsuccess_91: "Inscrição de expositor confirmada!",
    comp_exhibitorpaymentsuccess_92: "O seu pagamento foi efetuado com sucesso. Está agora validado(a) como expositor(a) para estas Reuniões 1:1.",
    comp_exhibitorpaymentsuccess_93: "Próximo passo:",
    comp_exhibitorpaymentsuccess_94: "vá para o seu",
    comp_exhibitorpaymentsuccess_95: "espaço do evento",
    comp_exhibitorpaymentsuccess_96: "para",
    comp_exhibitorpaymentsuccess_97: "selecionar os seus horários de disponibilidade",
    comp_exhibitorpaymentsuccess_98: "Gerir a minha disponibilidade",
    comp_exhibitorpaymentsuccess_99: "Voltar ao evento",
    comp_exhibitorpaymentsuccess_100: "Pagamento não confirmado",
    comp_exhibitorpaymentsuccess_101: "O pagamento não pôde ser verificado. Se pagou, o webhook do Stripe finalizará a inscrição em alguns minutos.",
    comp_forgotpassword_90: "Palavra-passe esquecida?",
    comp_forgotpassword_91: "Introduza o seu e-mail. Se existir uma conta, receberá um link de redefinição válido por 1 hora.",
    comp_forgotpassword_92: "E-mail enviado",
    comp_formationdetail_90: "A carregar…",
    comp_formationdetail_91: "Link de acesso (inscritos)",
    comp_formationdetail_92: "Palavra-passe:",
    comp_formationdetail_93: "Nome *",
    comp_formationslist_90: "Formações La WineTech Academy",
    comp_formationslist_91: "Sessões para desenvolver competências no universo do vinho e tecnologias associadas.",
    comp_formationslist_92: "Pesquisar uma formação…",
    comp_formationslist_93: "Nenhuma formação para o momento.",
    comp_home_90: "a comunidade WineTech",
    comp_home_91: "Troque ideias, colabore e participe na construção do futuro do vinho.",
    comp_joinpage_90: "Junte-se a La WineTech | Adesão e Quotas",
    comp_joinpage_91: "Junte-se ao ecossistema internacional de",
    comp_joinpage_92: "ecossistema de inovação",
    comp_joinpage_93: "A base comum",
    comp_joinpage_94: "Independentemente da sua categoria de adesão, beneficia destas vantagens.",
    comp_joinpage_95: "Escolha a sua categoria",
    comp_joinpage_96: "Cada perfil beneficia de vantagens complementares pensadas para a sua profissão.",
    comp_joinpage_97: "Em complemento à base comum",
    comp_joinpage_98: "Calcule o seu",
    comp_joinpage_99: "Indique a sua categoria e o seu volume de negócios anual para descobrir o seu preço de adesão estimado. Não é necessário criar uma conta.",
    comp_joinpage_100: "Categoria",
    comp_joinpage_101: "Quota anual indicativo — sujeito a validação pelo nosso comité.",
    comp_joinpage_102: "Para além da adesão",
    comp_joinpage_103: "O nosso comité irá analisar a sua candidatura e responder-lhe-á no prazo de 5 dias úteis.",
    comp_joinpage_104: "Já é candidato/a? Iniciar sessão",
    comp_leaderboard_90: "Melhores membros La WineTech",
    comp_leaderboard_91: "Os membros mais empenhados na comunidade a cada mês.",
    comp_leaderboard_92: "Classificação em processo de constituição.",
    comp_leaderboard_93: "O que dizem os nossos membros",
    comp_memberprofile_90: "Iniciou sessão como",
    comp_memberprofile_91: "← Voltar ao meu espaço",
    comp_memberprofile_92: "Vídeo",
    comp_memberprofile_93: "Demonstração",
    comp_memberprofile_94: "Contacte diretamente a equipa.",
    comp_memberprofile_95: "Telefone",
    comp_memberprofile_96: "Agendar uma reunião",
    comp_membersdirectory_90: "Mais recentes primeiro",
    comp_newslist_90: "Mais recentes primeiro",
    comp_publicmeetingrequest_90: "Pedir uma reunião",
    comp_publicmeetingrequest_91: "Pedido enviado!",
    comp_publicmeetingrequest_92: "A nossa equipa responder-lhe-á muito em breve para",
    comp_publicmeetingrequest_93: ". Até breve 🍷",
    comp_publicmeetingrequest_94: "O seu nome *",
    comp_publicmeetingrequest_95: "Telefone",
    comp_publicmeetingrequest_96: "Empresa",
    comp_publicmeetingrequest_97: "Assunto da reunião *",
    comp_publicmeetingrequest_98: "Data pretendida (opcional)",
    comp_publicmeetingrequest_99: "Apresente brevemente o seu pedido, a sua atividade, as suas expectativas…",
    comp_publicmeetingrequest_100: "Ao submeter este formulário, aceita que as suas informações sejam utilizadas pela equipa La WineTech para o/a recontactar. Consulte a nossa política de privacidade.",
    comp_renewalform_90: "Pagamento cancelado. Pode tentar novamente abaixo.",
    comp_renewalform_91: "A carregar…",
    comp_renewalform_92: "Link inválido ou expirado. Contacte La WineTech.",
    comp_renewalform_93: "A sua resposta foi registada. Teremos todo o gosto em continuar a conversar consigo.",
    comp_renewalform_94: "A redirecionar para o pagamento…",
    comp_renewalform_95: "Classificação geral (de 5)",
    comp_renewalform_96: "O seu comentário",
    comp_renewalform_97: "O seu feedback sobre o ano passado…",
    comp_renewalform_98: "Utilizado para calcular automaticamente a sua quota de acordo com a tabela La WineTech.",
    comp_renewalform_99: "Carregado",
    comp_renewalform_100: "Método de pagamento",
    comp_resetpassword_90: "O link de redefinição está incompleto ou expirou.",
    comp_resetpassword_91: "Pedir um novo link",
    comp_resetpassword_92: "Nova palavra-passe",
    comp_resetpassword_93: "Escolha uma palavra-passe com pelo menos 8 caracteres.",
    comp_resetpassword_94: "Confirmar palavra-passe",
    comp_resetpassword_95: "Palavra-passe atualizada",
    comp_resetpassword_96: "Será redirecionado(a) para a página de início de sessão…",
    press_pressdashboard_90: "Próximos eventos",
    press_pressdashboard_91: "Comunicados",
    press_pressdashboard_92: "Procurar notícias...",
    press_pressevents_90: "Procurar um evento, uma cidade…",
    press_pressmembers_90: "Pesquisar um membro, cidade, tecnologia…",
  
    join_seg_startups_name: "Startups e Inovação",
    join_seg_startups_desc: "Jovens empresas inovadoras a desenvolver soluções para o setor do vinho.",
    join_seg_startups_extra_1: "Visibilidade junto de produtores, parceiros e intervenientes do setor",
    join_seg_startups_extra_2: "Acesso a investidores e parceiros do ecossistema",
    join_seg_startups_extra_3: "Oportunidades de experimentação no terreno",
    join_seg_startups_extra_4: "Possibilidade de serem integradas em programas de aceleração e iniciativas coletivas",
    join_seg_startups_extra_5: "Participação em grupos de trabalho e projetos colaborativos",
    join_seg_experts_name: "Peritos e Consultores",
    join_seg_experts_desc: "Empresas de consultoria, peritos independentes e consultores especializados.",
    join_seg_experts_extra_1: "Referenciação como perito do ecossistema",
    join_seg_experts_extra_2: "Valorização das especializações e partilha de experiências",
    join_seg_experts_extra_3: "Participação em grupos de trabalho e projetos temáticos",
    join_seg_experts_extra_4: "Oportunidades de colaboração com os membros do ecossistema",
    join_seg_producteurs_name: "Produtores",
    join_seg_producteurs_desc: "Quintas, adegas cooperativas, casas comerciais e produtores empenhados na inovação.",
    join_seg_producteurs_extra_1: "Monitorização das inovações do setor",
    join_seg_producteurs_extra_2: "Descoberta de startups e soluções dos membros",
    join_seg_producteurs_extra_3: "Oportunidades de experimentação e colaboração",
    join_seg_producteurs_extra_4: "Possibilidade de participar em programas de aceleração temáticos",
    join_seg_producteurs_extra_5: "Participação em projetos coletivos promovidos pela WineTech",
    join_seg_fournisseurs_name: "Comunicação, Equipamento e Distribuição",
    join_seg_fournisseurs_desc: "Fornecedores de soluções, fabricantes de equipamentos, distribuidores e prestadores de serviços do setor.",
    join_seg_fournisseurs_extra_1: "Valorização das soluções e serviços propostos",
    join_seg_fournisseurs_extra_2: "Visibilidade junto de produtores e startups",
    join_seg_fournisseurs_extra_3: "Participação em projetos colaborativos",
    join_seg_fournisseurs_extra_4: "Integração em iniciativas coletivas do ecossistema",
    join_seg_ecoles_name: "Institutos e Escolas",
    join_seg_ecoles_desc: "Estabelecimentos de ensino, centros de investigação, laboratórios e organismos de formação.",
    join_seg_ecoles_extra_1: "Valorização de projetos pedagógicos e científicos",
    join_seg_ecoles_extra_2: "Conexão com empresas e startups do setor",
    join_seg_ecoles_extra_3: "Participação em projetos colaborativos",
    join_seg_ecoles_extra_4: "Contribuição para as reflexões e trabalhos do ecossistema",
    join_seg_partenaires_name: "Parceiros",
    join_seg_partenaires_desc: "Instituições, interprofissionais, organizações profissionais e empresas que desejam apoiar o ecossistema WineTech de forma duradoura.",
    join_seg_partenaires_extra_1: "Visibilidade institucional reforçada",
    join_seg_partenaires_extra_2: "Participação nas orientações estratégicas da associação",
    join_seg_partenaires_extra_3: "Apoio a programas estruturantes do setor",
    join_seg_partenaires_extra_4: "Presença privilegiada em eventos WineTech",
    join_seg_partenaires_extra_5: "Participação em iniciativas coletivas promovidas pela WineTech",
    join_common_1: "Perfil de membro na plataforma WineTech",
    join_common_2: "Presença no diretório de membros",
    join_common_3: "Acesso a eventos WineTech",
    join_common_4: "Acesso aos Wine Tech Coffee",
    join_common_5: "Participação no Wine Tech Campus",
    join_common_6: "Acesso à monitorização e notícias do ecossistema",
    join_common_7: "Acesso ao grupo da comunidade",
    join_common_8: "Identificação no ecossistema WineTech",
    join_common_9: "Referenciação nas comunicações WineTech",
    join_prog_accel_title: "Programas de aceleração",
    join_prog_accel_desc: "Acompanhamento coletivo focado na inovação, desenvolvimento comercial, crescimento, experimentação no terreno e financiamento.",
    join_prog_export_title: "Missões de exportação",
    join_prog_export_desc: "Descoberta de novos mercados, reuniões de negócios e operações coletivas a nível internacional.",
    join_prog_academy_title: "WineTech Academy",
    join_prog_academy_desc: "Formações, workshops, masterclasses e partilha de boas práticas entre membros e peritos.",
    join_prog_press_title: "Visibilidade e Imprensa",
    join_prog_press_desc: "Valorização de iniciativas, comunicação, relações com a imprensa e ações de promoção do ecossistema.",
    join_prog_events_title: "Eventos e operações coletivas",
    join_prog_events_desc: "Wine Tech Tour, Wine Tech Coffee, Wine Tech Campus, feiras profissionais e encontros temáticos.",
    apply_innovation_ai: "Inteligência artificial",
    apply_innovation_robot: "Robótica / AgTech",
    apply_innovation_iot: "Sensores / IoT",
    apply_innovation_blockchain: "Rastreabilidade / Blockchain",
    apply_innovation_marketplace: "Marketplace / Comércio eletrónico",
    apply_innovation_tourism: "Turismo e experiência",
    apply_innovation_energy: "Energia e sustentabilidade",
    apply_innovation_oeno: "Enologia / dados do vinho",
    apply_innovation_logistics: "Logística e cadeia de abastecimento",
    apply_innovation_other: "Outro",
    apply_interest_member: "Tornar-se membro da WineTech",
    apply_interest_partner: "Parceria comercial",
    apply_interest_invest: "Investimento / angariação de fundos",
    apply_interest_mentor: "Mentoria / rede",
    apply_interest_event: "Participar nos eventos",
    apply_interest_visibility: "Visibilidade na imprensa / comunicação",
    apply_interest_export: "Programa internacional",
  
    join_annual_fee: "Quota anual",
    apply_step_label: "Passo",
    apply_step_you: "Os seus dados",
    apply_step_you_short: "Identidade",
    apply_step_company: "A sua empresa",
    apply_step_company_short: "Empresa",
    apply_step_expectations: "As suas expectativas",
    apply_step_expectations_short: "Finalização",
    apply_btn_previous: "Anterior",
    apply_btn_continue: "Continuar",
    apply_btn_submit: "Enviar candidatura",
    apply_btn_submitting: "A enviar…",
    apply_desc_min_chars: "Mínimo 30 caracteres",
  
    portal_mycompany_collab_subtitle: "Convide os seus colegas para se juntarem à sua área de membro — eles irão beneficiar da sua adesão sem custos adicionais.",
    portal_mycompany_invite_cta_title: "Convide um colega para se juntar à sua empresa",
    portal_mycompany_invite_cta_subtitle: "A sua adesão abrange toda a equipa: adicione-os para que acedam aos eventos, ao matchmaking e à informação estratégica.",
  
    cta_apply: "Aplicar",
  
    join_calc_chip: "Simulador instantâneo",
    join_calc_word_fee: "quota",
    join_calc_revenue_label: "Faturação anual (€)",
    join_calc_revenue_placeholder: "ex: 1 500 000",
    join_calc_loading: "A calcular...",
    join_calc_submit: "Calcular a minha tarifa",
    join_calc_bracket: "Escalão estimado",
    apply_step0_title: "Vamos conhecer-nos",
    apply_field_lastname: "Apelido *",
    apply_field_email: "Email profissional *",
    apply_form_required_toast: "Por favor, preencha os campos obrigatórios antes de continuar.",
    apply_form_privacy_before: "Os seus dados são tratados de acordo com a nossa",
    apply_form_privacy_after: ". Sem spam, anule a subscrição com um clique.",
    not_found_title: "Página não encontrada",
    not_found_message: "Esta página não existe ou já não está acessível. Verifique o URL ou volte à página inicial.",
    not_found_back: "Voltar",
    not_found_home: "Início",
    portal_mycompany_collab_status_active: "Ativo",
    portal_mycompany_collab_status_pending: "Convite pendente",
    portal_mycompany_collab_status_no_account: "Sem conta",
  
    join_beyond_membership_desc: "A adesão constitui a porta de entrada para o ecossistema WineTech. Os membros podem, subsequentemente, participar nas iniciativas e programas desenvolvidos ao longo do ano.",
    apply_thanks_title: "Candidatura enviada",
    apply_thanks_intro: "Obrigado! Recebemos sua candidatura e um e-mail de confirmação acaba de ser enviado.",
    apply_thanks_within: "Nossa equipe entrará em contato em",
    apply_thanks_within_value: "48 horas úteis",
    apply_thanks_calendar_h: "Agende sua reunião de descoberta",
    apply_thanks_calendar_desc: "Para acelerar, escolha um horário de <strong>30 min</strong> com nossa equipe diretamente no calendário abaixo.",
    apply_thanks_book_cta: "Escolher um horário",
    apply_thanks_no_calendar: "📅 Entraremos em contato com uma proposta de horário.",
    apply_thanks_back_home: "Voltar ao início",
    apply_thanks_follow: "Siga a La WineTech",
    apply_thanks_questions: "Alguma pergunta?",
    apply_field_website: "Site",
    apply_field_revenue: "Receita anual (€)",
    apply_field_country: "País *",
    apply_field_choose: "— Escolher —",
    apply_toast_success: "Candidatura enviada!",
    apply_toast_error: "Erro no envio. Tente novamente ou entre em contato.",
    apply_toast_error_short: "Erro de envio",
    apply_lang_label: "Idioma / Language",
    application_validated_by: "Aprovada por {name} · em {date}",
    application_rejected_by: "Recusada por {name} · em {date}",
  },
  de: {
    res_dl_all: "Alles herunterladen ({n} Dateien, ZIP)",
    res_dl_error: "Download nicht möglich",
    res_dl_one: "Herunterladen",
    nl_invalid_email: "Ungültige E-Mail",
    nl_success_toast: "Vielen Dank! Sie haben sich für den Newsletter angemeldet",
    nl_confirmed: "Anmeldung bestätigt – bis bald!",
    nl_card_title: "Bleiben Sie informiert",
    nl_card_desc: "Erhalten Sie unseren monatlichen Newsletter: bevorstehende Veranstaltungen, Möglichkeiten, Neuigkeiten aus der WineTech.",
    nl_email_ph: "ihre@email.com",
    nl_subscribe: "Abonnieren",
    nl_gdpr: "Abmeldung mit 1 Klick in jeder E-Mail. Daten geschützt (DSGVO).",
    media_copy_failed: "URL konnte nicht kopiert werden — bitte manuell kopieren: {url}",
    unit_mb: "MB",
    unit_gb: "GB",
    media_load_error: "Mediathek konnte nicht geladen werden",
    media_format_unsupported: "Format nicht unterstützt. Akzeptiert: {formats}",
    media_too_large: "Datei zu groß ({size}). Max: {max}.",
    media_published: "Video veröffentlicht",
    media_upload_failed: "Upload fehlgeschlagen",
    media_delete_confirm: "Video \"{title}\" löschen?\n\nDiese Aktion ist endgültig.",
    media_deleted: "Video gelöscht",
    media_url_copied: "Öffentliche URL kopiert",
    media_meta_saved: "Metadaten gespeichert",
    media_title: "Meine Mediathek",
    media_intro: "Hosten Sie Ihre Pitches, Demos und Präsentationsvideos. Die generierten URLs können in Ihren Nachrichten, Veranstaltungen und Le Club-Angeboten kopiert werden.",
    media_upload_btn: "Video hochladen",
    media_finalizing: "Finalisierung…",
    media_uploading: "Upload läuft — {pct}%",
    media_formats_label: "Formate:",
    media_max_label: "Max. Größe:",
    media_hosting_label: "Hosting:",
    media_hosting_value: "sicherer Speicher, mobiloptimierte Wiedergabe",
    media_no_transcode: "Kein Transcoding",
    media_no_transcode_hint: "— exportieren Sie Ihre Videos vor dem Upload im Web-Format (MP4 H.264).",
    media_empty_title: "Ihre Mediathek ist leer",
    media_empty_desc: "Laden Sie Ihr erstes Video hoch (2-Minuten-Pitch, Produktdemo oder Präsentation).",
    media_edit: "Bearbeiten",
    media_edit_title: "Video bearbeiten",
    media_field_title: "Titel",
    media_field_desc: "Beschreibung",
    inv_status_paid: "Bezahlt",
    inv_status_open: "Offen",
    inv_status_pending: "Zahlung ausstehend",
    inv_status_draft: "Entwurf",
    inv_status_void: "Storniert",
    inv_status_uncollectible: "Uneinbringlich",
    inv_title: "Rechnungen",
    inv_my_title: "Meine Stripe-Rechnungen",
    inv_empty: "Noch keine Stripe-Rechnungen.",
    inv_my_empty: "Noch keine Stripe-Rechnungen. Ihre zukünftigen Mitgliedsbeiträge und Event-Zahlungen werden hier erscheinen.",
    inv_load_error: "Rechnungen konnten nicht geladen werden",
    inv_total_paid: "Gesamtzahlung:",
    inv_refresh_title: "Von Stripe aktualisieren",
    inv_refresh: "Aktualisieren",
    inv_stripe_not_configured: "Stripe ist serverseitig nicht konfiguriert – nur lokale Checkout-Sitzungen sind sichtbar.",
    inv_col_date: "Datum",
    inv_col_number: "Nummer",
    inv_col_description: "Beschreibung",
    inv_col_amount: "Betrag",
    inv_col_status: "Status",
    inv_col_actions: "Aktionen",
    inv_checkout_session: "Zahlungssitzung",
    inv_open_payment: "Zahlungsseite öffnen",
    inv_view_stripe: "Stripe-Rechnung ansehen",
    inv_pay: "Bezahlen",
    inv_view: "Ansehen",
    inv_download_pdf: "PDF herunterladen",
    proj_seo_title: "WineTech Projekte — Kollektive Initiativen der Weinbranche",
    proj_seo_desc: "Entdecken Sie die von La WineTech getragenen Projekte und Programme: Agrarökologie, kohlenstofffreie Logistik, Datensouveränität… Die Mitglieder, die die Zukunft des Weins gestalten.",
    proj_badge: "WineTech Programme",
    proj_h1_a: "Die Projekte, die",
    proj_h1_b: "den Wein von morgen gestalten",
    proj_intro: "Jedes Projekt bringt freiwillige Mitglieder zu einem strategischen Thema zusammen: Innovation, Nachhaltigkeit, Souveränität, neue Anwendungen. Entdecken Sie, lassen Sie sich inspirieren, treten Sie uns bei.",
    proj_empty: "Die WineTech-Projekte kommen bald. Kommen Sie bald wieder!",
    proj_tag: "Projekt",
    proj_discover: "Entdecken",
    proj_not_found: "Projekt nicht gefunden",
    proj_back: "Zurück zu den Projekten",
    proj_all: "Alle Projekte",
    proj_tag_full: "WineTech Projekt",
    proj_members_one: "{n} involviertes Mitglied",
    proj_members_many: "{n} involvierte Mitglieder",
    proj_members_title: "Die Mitglieder, die das Projekt tragen",
    proj_members_empty: "Seien Sie das erste Mitglied, das diesem Projekt beitritt.",
    exh_no_company: "Kein Firmenprofil mit Ihrem Konto verknüpft.",
    exh_resynced: "Informationen aus Ihrem Firmenprofil neu synchronisiert",
    exh_resync_error: "Synchronisierung fehlgeschlagen",
    exh_name_required: "Firmenname erforderlich",
    exh_choose_role: "Wählen Sie eine Rolle",
    exh_validated: "Aussteller validiert",
    exh_submitted: "Bewerbung gesendet — wartet auf Admin-Validierung",
    exh_title: "Aussteller-Registrierung",
    exh_company_card: "Mitglieds-Firmenprofil",
    exh_resync_title: "Informationen aus Ihrem Mitglieds-Firmenprofil neu laden",
    exh_resync: "Neu synchronisieren",
    exh_company_name: "Firmenname *",
    exh_role: "Ihre Rolle *",
    exh_select: "— Auswählen —",
    exh_booth: "Stand-Nr.",
    exh_booth_ph: "z.B. B12",
    exh_logo: "Logo (URL)",
    exh_desc: "Kurze Beschreibung",
    exh_desc_ph: "Stellen Sie Ihr Unternehmen in wenigen Worten vor…",
    exh_fee_title: "Anmeldegebühr für Aussteller",
    exh_secure_payment: "Sichere Zahlung durch Stripe. Ihre Registrierung wird nach Zahlungseingang automatisch validiert.",
    exh_free_title: "Kostenlose Registrierung",
    exh_auto_admin: "Automatische Validierung (Admin).",
    exh_review_team: "Ihre Bewerbung wird vom La WineTech-Team geprüft.",
    exh_pay: "{price} bezahlen",
    exh_confirm: "Registrierung bestätigen",
    sidebar_member_shared_services: "Gemeinsame Dienste",
    sidebar_member_media: "Mediathek",
    nav_formations: "Schulungen",
    nav_support_us: "Unterstützen Sie uns",
    nav_opportunities: "Möglichkeiten",
    nav_community: "Die Community",
    newsletter_band_title: "Bleiben Sie über WineTech-Neuigkeiten auf dem Laufenden",
    newsletter_band_desc: "Kommende Veranstaltungen, Möglichkeiten, Petitionen und Innovationen — 1 E-Mail pro Monat, Abmeldung mit 1 Klick.",
    newsletter_subscribe_aria: "Newsletter abonnieren",
    newsletter_later: "Später",
    credit_dev_by: "Plattform kostenlos entwickelt von",
    credit_for: "für La WineTech.",
    nav_home: "Startseite",
    nav_news: "Aktuelles",
    nav_events: "Veranstaltungen",
    nav_projects: "Projekte",
    nav_members: "Mitglieder",
    nav_about: "Über uns",
    nav_contact: "Kontakt",
    nav_back_to_site: "Zurück zur Website",
    auto_translated: "Automatisch übersetzt",
    loading: "Laden...",
    news_title: "Aktuelles",
    news_subtitle: "Alle Innovationen des WineTech-Ökosystems: Interviews, Analysen, Finanzierungsrunden, Markteinführungen.",
    news_seo_title: "Aktuelles & Analysen",
    news_seo_desc: "Aktuelle Nachrichten, Analysen und Geschichten aus dem globalen WineTech-Ökosystem.",
    news_search_placeholder: "Eine Nachricht suchen...",
    back_to_news: "Zurück zu den Nachrichten",
    related_articles: "Verwandte Artikel",
    read_more: "Weiterlesen",
    filter_all: "Alle",
    cat_innovation: "Innovation",
    cat_technology: "Technologie",
    cat_startup: "Startup",
    cat_market: "Markt",
    cat_digital: "Digital",
    cat_announcement: "Mitteilung",
    events_title: "Veranstaltungen",
    events_subtitle: "Konferenzen, Webinare, Afterworks, Masterclasses: die Treffpunkte der WineTech-Community.",
    events_seo_title: "Veranstaltungen",
    events_seo_desc: "Entdecken Sie die nächsten WineTech-Veranstaltungen — Konferenzen, 1:1-Meetings, Workshops und Innovationstreffen im globalen Weinökosystem.",
    events_upcoming: "Bevorstehend",
    events_past: "Vergangen",
    events_all_formats: "Alle Formate",
    events_format_physical: "Vor Ort",
    events_format_digital: "Digital",
    events_format_hybrid: "Hybrid",
    events_registered: "Angemeldete",
    back_to_events: "Zurück zu den Veranstaltungen",
    members_title: "Mitglieder",
    members_subtitle: "Alle Akteure der WineTech-Innovation.",
    home_hero_title: "Das internationale Wein-Innovationsnetzwerk",
    home_hero_subtitle: "La WineTech vereint Winzer, Startups, Anlagenbauer, Schulen und Investoren.",
    cta_join: "Beitreten",
    cta_explore: "Community entdecken",
    cta_see_events: "Veranstaltungen ansehen",
    cta_visit_website: "Website besuchen",
    hero_title_pre: "Die globale",
    hero_title_brand: "WineTech-Community",
    hero_subtitle: "Talente verbinden, Innovation teilen und gemeinsam die Zukunft des Weins gestalten.",
    innovate_together: "Gemeinsam innovieren",
    actu: "Aktuelles",
    upcoming_events: "Bevorstehende Veranstaltungen",
    community_members: "Community-Mitglieder",
    see_all_news: "Alle Nachrichten ansehen",
    see_all_events: "Alle Veranstaltungen ansehen",
    see_all_members: "Alle Mitglieder ansehen",
    learn_more: "Mehr erfahren",
    apply_now: "Jetzt bewerben",
    login: "Anmelden",
    login_title: "Anmelden",
    login_welcome_back: "Schön, Sie wiederzusehen.",
    login_loading: "Anmeldung läuft...",
    login_no_account: "Noch kein Mitglied?",
    login_create_account: "Konto erstellen",
    login_welcome_toast: "Willkommen!",
    login_brand_title_pre: "Willkommen in der",
    login_brand_title_brand: "WineTech-Community",
    login_brand_subtitle: "Melden Sie sich an, um auf Ihren eigenen Bereich, Ihre Termine und das private Verzeichnis zuzugreifen.",
    login_demo_accounts: "Demo-Konten (zum Befüllen klicken):",
    login_demo_admin: "Admin",
    login_demo_member: "Mitglied",
    login_demo_press: "Presse",
    email: "E-Mail",
    password: "Passwort",
    register: "Registrieren",
    register_title: "Konto erstellen",
    register_loading: "Erstellung...",
    register_have_account: "Bereits registriert?",
    register_first_name: "Vorname",
    register_last_name: "Nachname",
    register_submit: "Registrieren",
    logout: "Abmelden",
    forgot_password: "Passwort vergessen?",
    register_role_applicant: "Mitgliedskandidat",
    register_role_event: "Veranstaltungsbesucher",
    register_role_journalist: "Journalist / Presse",
    register_company_or_media: "Unternehmen / Medien",
    register_i_am: "Ich bin",
    register_brand_title_pre: "Treten Sie der",
    register_brand_subtitle: "Erstellen Sie Ihr Konto, um sich zu bewerben, an Veranstaltungen teilzunehmen oder auf den Pressebereich zuzugreifen.",
    dashboard: "Übersicht",
    my_profile: "Mein Profil",
    portal_member: "Mitgliederbereich",
    portal_press: "Pressebereich",
    portal_admin: "Admin CRM",
    apply_join: "Bei La WineTech bewerben",
    join_intro: "Treten Sie dem globalen WineTech-Ökosystem bei.",
    sidebar_member_dashboard: "Übersicht",
    sidebar_member_profile: "Unternehmensprofil",
    sidebar_member_my_company: "Mein Unternehmen",
    sidebar_member_score: "Mein Score",
    sidebar_member_notifications: "Benachrichtigungen",
    sidebar_member_matchmaking: "Matchmaking",
    sidebar_member_products: "Produkte & Dienstleistungen",
    sidebar_member_team: "Team",
    sidebar_member_news: "Beiträge",
    sidebar_member_events: "Veranstaltungen",
    sidebar_member_directory: "Verzeichnis",
    sidebar_member_meetings: "Termine",
    sidebar_member_messages: "Nachrichten",
    sidebar_member_resources: "Ressourcen",
    sidebar_personal_profile: "Persönliches Profil",
    sidebar_admin_dashboard: "Übersicht",
    sidebar_admin_pipeline: "CRM-Pipeline",
    sidebar_admin_members: "Mitglieder",
    sidebar_admin_applications: "Bewerbungen",
    sidebar_admin_news: "Aktuelles",
    sidebar_admin_events: "Veranstaltungen",
    sidebar_admin_meetings: "Termine",
    sidebar_admin_analytics: "Analytics",
    sidebar_admin_settings: "Einstellungen",
    sidebar_press_dashboard: "Übersicht",
    sidebar_press_releases: "Pressemitteilungen",
    sidebar_press_events: "Veranstaltungen",
    sidebar_press_members: "Mitglieder",
    sidebar_press_resources: "Ressourcen",
    sidebar_need_help: "Brauchen Sie Hilfe?",
    sidebar_help_text: "Unser Team ist für Sie da.",
    sidebar_contact_us: "Kontaktieren Sie uns",
    search: "Suchen",
    search_placeholder: "Ein Unternehmen, eine Technologie suchen...",
    category: "Kategorie",
    country: "Land",
    all: "Alle",
    all_categories: "Alle Kategorien",
    all_countries: "Alle Länder",
    all_poles: "Alle Bereiche",
    no_results: "Keine Ergebnisse.",
    no_members_found: "Keine Mitglieder gefunden. Filter anpassen.",
    submit: "Senden",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "Löschen",
    edit: "Bearbeiten",
    add: "Hinzufügen",
    close: "Schließen",
    confirm: "Bestätigen",
    publish: "Veröffentlichen",
    download: "Herunterladen",
    open: "Öffnen",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    draft: "Entwurf",
    active: "Aktiv",
    published: "Veröffentlicht",
    archived: "Archiviert",
    paid: "Bezahlt",
    pending_payment: "Zahlung ausstehend",
    confirmed: "Bestätigt",
    book_meeting: "Termin buchen",
    exhibitors: "Aussteller",
    matchmaking: "Matchmaking",
    register_for_event: "Zur Veranstaltung anmelden",
    visitor: "Besucher",
    exhibitor: "Aussteller",
    media: "Medien / Presse",
    free: "Kostenlos",
    speakers: "Referenten",
    sponsors: "Sponsoren",
    attendees: "Teilnehmer",
    check_in: "Check-in",
    pricing: "Preise",
    transactions: "Transaktionen",
    about: "Über",
    expertise: "Expertise",
    products_services: "Produkte & Dienstleistungen",
    company_news: "Aktuelles",
    technologies: "Technologien",
    activities: "Aktivitäten",
    founded_in: "Gegründet",
    employees: "Mitarbeiter",
    active_member: "Aktives Mitglied",
    tags: "Tags",
    community_score: "Community-Score",
    points: "Pkt.",
    back_to_members: "Zurück zu den Mitgliedern",
    resources: "Ressourcen",
    press_releases: "Pressemitteilungen",
    media_kit: "Medien-Kit",
    welcome: "Willkommen",
    success_saved: "Erfolgreich gespeichert",
    error_generic: "Ein Fehler ist aufgetreten",
    footer_intro: "La WineTech verbindet die Innovationstalente der Weinwelt — eine einzigartige Community zum Teilen, Lernen, Zusammenarbeiten.",
    footer_platform: "Plattform",
    footer_spaces: "Bereiche",
    footer_rights: "Alle Rechte vorbehalten.",
    footer_made_with: "Mit ♥ für die Weinindustrie gemacht.",
    members_directory_intro: "Entdecken Sie alle Akteure der WineTech-Innovation, ihre Spezialitäten und Technologien.",
    portal_exhibitormatchmaking_01: "Verfügbare Zeitfenster",
    portal_exhibitormatchmaking_02: "Keine Zeitfenster für diesen Kontakt verfügbar.",
    portal_matchmaking_01: "Vorschläge:",
    portal_matchmaking_02: "und was Sie",
    portal_matchmaking_03: ". Die Plattform bringt Sie automatisch mit den besten Profilen zusammen.",
    portal_matchmaking_04: "Ihre Fachgebiete, Dienstleistungen, Technologien, Märkte, die Sie ansprechen.",
    portal_matchmaking_05: "Partnerschaften, Technologien, Ressourcen, Märkte, die Sie erschließen möchten.",
    portal_memberdashboard_01: "Hier ist ein Überblick über Ihre Aktivitäten in der WineTech-Community.",
    portal_memberdashboard_02: "Mein Unternehmen",
    portal_memberdashboard_03: "Kein Unternehmen verknüpft.",
    portal_memberdashboard_04: "Mein Profil vervollständigen →",
    portal_memberdashboard_05: "Kommende Veranstaltungen",
    portal_memberdashboard_06: "Alle anzeigen",
    portal_memberdashboard_07: "Steigern Sie Ihre Sichtbarkeit in der Community",
    portal_memberdashboard_08: "Veröffentlichen Sie Neuigkeiten, nehmen Sie an Veranstaltungen teil, vereinbaren Sie Termine mit anderen Akteuren.",
    portal_memberdashboard_09: "Neuigkeit veröffentlichen",
    portal_memberdirectory_01: "Entdecken und vernetzen Sie sich mit anderen Mitgliedern der Community.",
    portal_memberdirectory_02: "Neueste zuerst",
    portal_memberevents_01: "Veranstaltungen",
    portal_memberevents_02: "Registrieren Sie sich für die kommenden Veranstaltungen der Community.",
    portal_memberevents_03: "Bevorstehend",
    portal_memberevents_04: "Vergangen",
    portal_memberevents_05: "Alle Zielgruppen",
    portal_memberevents_06: "Nächstes Datum",
    portal_memberevents_07: "Entferntestes Datum",
    portal_memberevents_08: "Zuletzt veröffentlicht",
    portal_memberevents_09: "Vor langer Zeit veröffentlicht",
    portal_membermeetings_01: "Meine Termine",
    portal_membermeetings_02: "Verwalten Sie Ihre Termine, Verfügbarkeiten und Ihren 1:1-Meetings-Plan.",
    portal_membermeetings_03: "Mein 1:1-Meetings-Plan",
    portal_membermeetings_04: "Entdecken Sie Veranstaltungen",
    portal_membermeetings_05: "und buchen Sie Ihren nächsten Termin.",
    portal_membermeetings_06: "Meine Veranstaltungen als Aussteller",
    portal_membermeetings_07: "Wählen Sie die Zeitfenster aus, in denen Sie für Besuchergespräche zur Verfügung stehen. Nur die ausgewählten Zeitfenster können gebucht werden.",
    portal_membermeetings_08: "Bestätigt",
    portal_membermeetings_09: "⚠️ Keine Zeitfenster ausgewählt. Besucher können nicht buchen, solange Sie Ihre Verfügbarkeit nicht angegeben haben.",
    portal_membermeetings_10: "Meine Verfügbarkeiten",
    portal_membermessages_01: "Private Unterhaltungen mit der Community.",
    portal_membermessages_02: "Wählen Sie eine Unterhaltung aus.",
    portal_membernews_01: "Meine Neuigkeiten",
    portal_membernews_02: "Reichen Sie Ihre Neuigkeiten, Markteinführungen, Kapitalrunden ein.",
    portal_membernews_03: "Validierung durch das La WineTech-Team erforderlich",
    portal_membernews_04: "Ihre Neuigkeit wird von einem Administrator überprüft. Validierungszeit:",
    portal_membernews_05: "24 bis 72 Stunden",
    portal_membernews_06: "Zur Validierung einreichen",
    portal_membernews_07: "Kategorie",
    portal_membernews_08: "Bisher keine Neuigkeiten veröffentlicht.",
    portal_memberproducts_01: "Kein Unternehmen zugeordnet.",
    portal_memberproducts_02: "Präsentation Ihrer Angebote im WineTech-Ökosystem.",
    portal_memberproducts_03: "Video",
    portal_memberproducts_04: "Demo",
    portal_memberproducts_05: "Keine Produkte oder Dienstleistungen veröffentlicht.",
    portal_memberprofile_01: "Pflegen Sie Ihr Profil, um im Ökosystem an Sichtbarkeit zu gewinnen.",
    portal_memberprofile_02: "Mein öffentliches Profil ansehen",
    portal_memberprofile_03: "Eine Neuigkeit veröffentlichen",
    portal_memberprofile_04: "Vollständigkeit",
    portal_memberprofile_05: "Meine Veranstaltungen",
    portal_memberprofile_06: "Alle ansehen →",
    portal_memberprofile_07: "Keine bevorstehenden Veranstaltungen.",
    portal_memberprofile_08: "Veranstaltungen entdecken →",
    portal_memberprofile_09: "Meine Veröffentlichungen",
    portal_memberprofile_10: "Verwalten →",
    portal_memberprofile_11: "Teilen Sie Ihre Neuigkeiten mit der WineTech-Community, um Ihre Sichtbarkeit zu erhöhen.",
    portal_memberprofile_12: "Lange Beschreibung (Markdown)",
    portal_memberprofile_13: "Hauptbereich",
    portal_memberprofile_14: "Spezielle Tags",
    portal_memberprofile_15: "Sekundäre Aktivitäten",
    portal_memberprofile_16: "Adressierte Märkte",
    portal_memberprofile_17: "Helfen Sie dem Ökosystem, Sie zu finden – wählen Sie alle Tags aus, die auf Ihre Aktivität zutreffen. Diese sind im Verzeichnis filterbar und werden auf Veranstaltungsseiten verwendet.",
    portal_memberresources_01: "Herunterladen",
    portal_memberteam_01: "Kein Unternehmen zugeordnet.",
    portal_memberteam_02: "Team",
    portal_memberteam_03: "Verwalten Sie die Mitarbeiter Ihres Unternehmens und deren Rollen.",
    portal_memberteam_04: "Einladung erstellt ✓",
    portal_memberteam_05: "Temporäres Passwort",
    portal_memberteam_06: "(manuell zu übermitteln – die Brevo-Einladungs-E-Mail wird in einer späteren Iteration verbunden):",
    portal_memberteam_07: "Weiteren Mitarbeiter einladen",
    portal_memberteam_08: "Rolle",
    portal_mycompany_01: "Mein Unternehmen",
    portal_mycompany_02: "Vervollständigen Sie die Informationen Ihres Unternehmensprofils und verwalten Sie Ihre Mitarbeiter.",
    portal_mycompany_03: "Der",
    portal_mycompany_04: "wird überall angezeigt (Verzeichnis, Veranstaltungen, Grafiken, Badges). Die",
    portal_mycompany_05: "juristische Einheit",
    portal_mycompany_06: "wird ausschließlich für die Stripe-Rechnungsstellung verwendet.",
    portal_mycompany_07: "Wird auf allen öffentlichen Medien angezeigt",
    portal_mycompany_08: "Juristische Einheit (Rechnungsstellung)",
    portal_mycompany_09: "Wird für Stripe & Rechnungen verwendet",
    portal_mycompany_10: "Nur der Hauptkontakt kann diese Informationen ändern",
    portal_mycompany_11: "Mitarbeiter hinzufügen",
    portal_mycompany_12: "Als Hauptkontakt festlegen",
    portal_mycompany_13: "Keine Mitarbeiter. Fügen Sie Ihr Team hinzu, um die Vorteile von La WineTech voll auszuschöpfen.",
    portal_myeventpage_01: "← Mein Portal",
    portal_myeventpage_02: "Abmelden",
    portal_myeventpage_03: "Öffentliche Seite anzeigen",
    portal_myeventpage_04: "Sie sind noch nicht für diese Veranstaltung angemeldet.",
    portal_myeventpage_05: "Gehen Sie zur",
    portal_myeventpage_06: "um sich anzumelden.",
    portal_myeventpage_07: "🎥 Online-Veranstaltung",
    portal_myeventpage_08: "Zugangscode:",
    portal_myeventpage_09: "Videoanruf beitreten →",
    portal_myeventpage_10: "Schritt 1",
    portal_myeventpage_11: "Laden Sie Ihr Badge herunter",
    portal_myeventpage_12: "Zeigen Sie es am Veranstaltungstag am Empfang vor.",
    portal_myeventpage_13: "PDF herunterladen",
    portal_myeventpage_14: "Schritt 2",
    portal_myeventpage_15: "Abschnitt anzeigen ↓",
    portal_myeventpage_16: "Am Veranstaltungstag",
    portal_myeventpage_17: "Meine Verfügbarkeiten für 1:1-Meetings",
    portal_myeventpage_18: "Sie sind als Aussteller angemeldet",
    portal_myeventpage_19: "Markieren Sie die Zeitfenster, in denen Sie für Besuchergespräche zur Verfügung stehen. Nur die markierten Zeitfenster werden zur Buchung angeboten.",
    portal_myeventpage_20: "Bestätigt",
    portal_myeventpage_21: "Kein Zeitfenster ausgewählt – Besucher können Sie nicht buchen.",
    portal_myeventpage_22: "Vollständige Kalenderansicht",
    portal_myeventpage_23: "Derzeit keine bestätigten Aussteller. Kommen Sie später wieder ⏳",
    portal_myeventpage_24: "Meine bestätigten Termine",
    portal_myscore_01: "Mein Community-Score",
    portal_myscore_02: "Ihr Engagement in der WineTech-Community, berechnet nach transparenten Kriterien.",
    portal_myscore_03: "Je mehr Sie beitragen, desto größer wird Ihre Sichtbarkeit",
    portal_myscore_04: "Punktdetails",
    portal_myscore_05: "Vervollständigen Sie Ihr Unternehmensprofil (Logo, Beschreibung, Website) — sofortiger Gewinn.",
    portal_myscore_06: "Hinterlegen Sie LinkedIn und einen Kalender-Link für jeden Mitarbeiter.",
    portal_myscore_07: "Veröffentlichen Sie Ihre Neuigkeiten über Ihr Mitgliederportal.",
    portal_myscore_08: "Melden Sie sich an und nehmen Sie an Community-Veranstaltungen teil.",
    portal_myscore_09: "Fügen Sie Ihre Mitarbeiter von der Seite „Mein Unternehmen“ hinzu.",
    portal_notifications_01: "Alles, was in Ihrer Community passiert, auf einen Blick.",
    portal_notifications_02: "E-Mail-Einstellungen",
    portal_notifications_03: "Wählen Sie für jede Kategorie, ob Sie zusätzlich zur Benachrichtigung in der App eine E-Mail erhalten möchten.",
    portal_notifications_04: "Zurzeit keine Benachrichtigungen.",
    portal_notifications_05: "Anzeigen →",
    portal_personalprofile_01: "Mein persönliches Profil",
    portal_personalprofile_02: "Aktualisieren Sie Ihre persönlichen Daten, Ihr Foto und Ihren öffentlichen Kalender.",
    portal_personalprofile_03: "Persönliche Daten",
    portal_personalprofile_04: "Vorname",
    portal_personalprofile_05: "Telefon",
    portal_personalprofile_06: "Calendly, Cal.com, Google Kalender… dieser Link wird zum Buchen von Terminen mit Ihnen verwendet.",
    press_pressdashboard_01: "Willkommen in Ihrem WineTech Pressebereich. Greifen Sie auf die neuesten Community-Nachrichten zu.",
    press_pressdashboard_02: "Genehmigter Journalisten-Zugang",
    press_pressdashboard_03: "Sie haben vollen Zugriff auf alle Neuigkeiten der Plattform.",
    press_pressdashboard_04: "Mein Profil anzeigen",
    press_pressdashboard_05: "Neueste Nachrichten",
    press_pressdashboard_06: "Kategorien",
    press_pressdashboard_07: "Alle Kategorien",
    press_pressdashboard_08: "Unser Presseteam steht Ihnen für jegliche Anfragen zur Verfügung.",
    press_pressevents_01: "Veranstaltungen",
    press_pressevents_02: "Greifen Sie auf alle Veranstaltungen der WineTech Community zu.",
    press_pressevents_03: "Kommende",
    press_pressevents_04: "Vergangene",
    press_pressevents_05: "Nächstes Datum zuerst",
    press_pressevents_06: "Entferntestes Datum zuerst",
    press_pressevents_07: "Zuletzt veröffentlicht",
    press_pressevents_08: "Vor längerer Zeit veröffentlicht",
    press_pressmembers_01: "Entdecken Sie die Akteure der Wein-Innovation.",
    press_pressmembers_02: "Neueste zuerst",
    press_pressreleases_01: "Pressemitteilungen",
    press_pressreleases_02: "Neueste zuerst",
    press_pressreleases_03: "Zurzeit keine Pressemitteilungen.",
    press_pressresources_01: "Medien-Kit & Ressourcen",
    press_pressresources_02: "Logos, offizielle Fotos, Pressemitteilungen und Berichte.",
    press_pressresources_03: "Herunterladen",
    layout_publiclayout_01: "📝 Meine Bewerbung einreichen",
    layout_publiclayout_02: "Benötigen Sie ein CRM, ein Kundenportal, ein Extranet, eine Fachanwendung oder eine maßgeschneiderte SaaS-Plattform, um Ihr Wachstum zu fördern?",
    portal_mycompany_readonly: "Sie betrachten dieses Profil schreibgeschützt. Nur der Hauptkontakt (oder ein Administrator) kann diese Informationen bearbeiten. Bitten Sie Ihren Hauptkontakt, die Option „Anderen Mitarbeitern die Bearbeitung erlauben“ auf dieser Seite zu aktivieren.",
  
    portal_exhibitormatchmaking_90: "Wird geladen...",
    portal_memberdashboard_90: "Veröffentlichte Neuigkeiten",
    portal_memberdashboard_91: "Beigetretene Veranstaltungen",
    portal_memberdashboard_92: "Profilansichten",
    portal_memberdashboard_93: "Bearbeiten",
    portal_memberevents_90: "Veranstaltung, Stadt suchen…",
    portal_membermeetings_90: "Hinzufügen",
    portal_membermessages_90: "Neue Nachricht",
    portal_membermessages_91: "Ihre Antwort…",
    portal_membermessages_92: "Senden",
    portal_membermessages_93: "Mitglied, Admin, Presse suchen…",
    portal_membermessages_94: "Ihre Nachricht…",
    portal_membernews_90: "Titelbild",
    portal_memberproducts_90: "Detaillierte Beschreibung",
    portal_memberproducts_91: "YouTube/Vimeo Video-URL",
    portal_memberproducts_92: "Demo-URL",
    portal_memberproducts_93: "Hinzufügen",
    portal_memberproducts_94: "Löschen",
    portal_memberprofile_90: "Identität",
    portal_memberprofile_91: "Banner (16:5 empfohlen)",
    portal_memberprofile_92: "Gründungsjahr",
    portal_memberprofile_93: "Vorstellung",
    portal_memberprofile_94: "Soziale Netzwerke",
    portal_memberteam_90: "Vorname",
    portal_memberteam_91: "Einladung senden",
    portal_memberteam_92: "Keine Mitarbeiter.",
    portal_mycompany_90: "Wird geladen…",
    portal_mycompany_91: "Kontakt-E-Mail",
    portal_mycompany_92: "Telefon",
    portal_mycompany_93: "Beschreibung / Vorstellung",
    portal_mycompany_94: "Logo (quadratisch, 512×512 empfohlen)",
    portal_mycompany_95: "Banner (16:9, 1600×900 empfohlen)",
    portal_mycompany_96: "Speichern",
    portal_mycompany_97: "Vorname *",
    portal_mycompany_98: "Hinzufügen &amp; Einladung senden",
    portal_mycompany_99: "Abbrechen",
    portal_mycompany_100: "Erneut senden",
    portal_mycompany_101: "Einladen",
    portal_myeventpage_90: "Wird geladen…",
    portal_myscore_90: "Wird geladen…",
    portal_personalprofile_90: "Wird geladen...",
    portal_personalprofile_91: "Foto hochladen (JPG/PNG, ≤ 5 MB)",
    portal_personalprofile_92: "Ein paar Zeilen, um sich vorzustellen…",
    layout_portallayout_90: "Menü schließen",
    layout_portallayout_91: "Menü öffnen",
    layout_publiclayout_90: "La WineTech-Mitgliedschaft entdecken",
    layout_publiclayout_91: "Meine Bewerbung einreichen",
  
    sidebar_help_mode_emploi: "Anleitung",
    sidebar_admin_prospects: "Interessenten",
    sidebar_admin_contacts: "Kontakte",
    sidebar_admin_formations: "Schulungen",
    sidebar_admin_checkin_qr: "Check-in (QR)",
    sidebar_admin_administrators: "Administratoren",
    sidebar_admin_emails: "E-Mails",
    sidebar_admin_mailshot: "Mailshot CRM",
    sidebar_admin_scoring: "Scoring",
    sidebar_admin_renewals: "Verlängerungen",
    sidebar_admin_activity_log: "Aktivitätsprotokoll",
    sidebar_admin_ai_feedback: "KI-Feedback",
    subtitle_admin: "Admin",
    subtitle_press: "Innovation & Austausch",
    subtitle_member: "Community & Innovation",
    user_label_default: "Benutzer",
    role_admin: "Administrator",
    role_member: "Mitglied",
    role_press: "Presse",
    role_applicant: "Bewerber",
    role_event_visitor: "Event-Besucher",
    role_journalist: "Journalist",
    title_admin_dashboard: "Admin-Dashboard",
    title_press_portal: "Presseportal",
    title_member_portal: "Mitgliederportal",
  
    portal_mycompany_section_title: "Firmenprofil",
    portal_mycompany_name_label: "Handelsname *",
    portal_mycompany_legal_label: "Rechtsform",
    portal_mycompany_name_term: "Handelsname",
    portal_mycompany_legal_term: "Rechtsform",
    portal_mycompany_name_placeholder: "Beispiel: VineaTech",
    portal_mycompany_legal_placeholder: "Beispiel: VineaTech GmbH",
    portal_mycompany_vat_placeholder: "USt-IdNr.",
    portal_mycompany_website_placeholder: "Website",
    portal_mycompany_city_placeholder: "Ort",
    portal_mycompany_collaborators_title: "Mitarbeiter",
    portal_mycompany_email_required_placeholder: "E-Mail *",
    portal_mycompany_lastname_required_placeholder: "Nachname *",
    portal_mycompany_jobtitle_placeholder: "Funktion",
    portal_mycompany_linkedin_placeholder: "LinkedIn URL",
    portal_mycompany_calendar_placeholder: "Kalender-Link (Calendly, Google…)",
    portal_mycompany_primary_badge: "Primär",
    image_upload_replace: "Ersetzen",
    image_upload_loading: "Upload läuft…",
    search_button: "Suchen",
    common_required: "(erforderlich)",
  
    comp_aboutpage_90: "Über La WineTech",
    comp_aboutpage_91: "Über La WineTech",
    comp_aboutpage_92: "Unsere Mission",
    comp_aboutpage_93: "Das Ökosystem",
    comp_activateaccount_90: "Mein Konto aktivieren",
    comp_activateaccount_91: "Link wird überprüft…",
    comp_activateaccount_92: "Neuen Link anfordern",
    comp_activateaccount_93: "Konto aktiviert!",
    comp_activateaccount_94: "Weiterleitung zur Anmeldeseite…",
    comp_activateaccount_95: "Ihr Konto aktivieren",
    comp_activateaccount_96: "Wählen Sie ein Passwort, um die Aktivierung abzuschließen.",
    comp_activateaccount_97: "Passwort (mind. 6 Zeichen)",
    comp_activateaccount_98: "Passwort bestätigen",
    comp_applypage_90: "Bewerben | La WineTech",
    comp_applypage_91: "La WineTech",
    comp_applypage_92: "Der Community beitreten",
    comp_applypage_93: "3 Minuten, um uns Ihr Projekt vorzustellen. Unser Team meldet sich innerhalb von 48 Stunden bei Ihnen.",
    comp_applypage_94: "Ihre persönlichen Daten. Wir verarbeiten Ihre Daten gemäß der DSGVO.",
    comp_applypage_95: "Vorname *",
    comp_applypage_96: "Telefon",
    comp_applypage_97: "Ihr LinkedIn-Profil",
    comp_applypage_98: "Ich bin damit einverstanden, Mitteilungen von La WineTech (Veranstaltungen, Möglichkeiten, Newsletter) zu erhalten. Abmeldung jederzeit möglich.",
    comp_applypage_99: "Über Ihr Unternehmen",
    comp_applypage_100: "Diese Informationen ermöglichen es uns, Ihr Profil und den passenden Beitrag zu bewerten.",
    comp_applypage_101: "Name des Unternehmens *",
    comp_applypage_102: "Ihre Funktion",
    comp_applypage_103: "Wir passen den Beitrag an die Größe Ihres Unternehmens an.",
    comp_applypage_104: "Kategorie *",
    comp_applypage_105: "Art(en) der Innovation / der Interessen",
    comp_applypage_106: "Stellen Sie Ihr Unternehmen in wenigen Zeilen vor *",
    comp_applypage_107: "Was ist Ihre Tätigkeit? Was sind Ihre wichtigsten Herausforderungen?",
    comp_applypage_108: "Letzter Schritt",
    comp_applypage_109: "Helfen Sie uns zu verstehen, was Sie von La WineTech erwarten.",
    comp_applypage_110: "Was Sie vorrangig interessiert *",
    comp_applypage_111: "💡 Nächste Schritte",
    comp_applypage_112: "Wir prüfen Ihre Bewerbung innerhalb von 48 Arbeitsstunden",
    comp_applypage_113: "Sie erhalten umgehend eine Bestätigung per E-Mail",
    comp_applypage_114: "Bei Eignung wird Ihnen ein Termin für ein Gespräch vorgeschlagen",
    comp_applypage_115: "Datenschutzerklärung",
    comp_applythankspage_90: "Bewerbung gesendet | La WineTech",
    comp_applythankspage_91: "48 Arbeitsstunden",
    comp_applythankspage_92: "Vereinbaren Sie Ihr Kennenlern-Meeting",
    comp_applythankspage_93: "Folgen Sie La WineTech",
    comp_applythankspage_94: "Eine Frage?",
    comp_billingpage_90: "Rechnungsinformationen übermittelt",
    comp_billingpage_91: "Unser Team wird nun Ihre Rechnung erstellen. Sie erhalten in Kürze eine E-Mail mit dem sicheren Stripe-Zahlungslink.",
    comp_billingpage_92: "! Ihre Bewerbung für",
    comp_billingpage_93: "USt-IdNr.",
    comp_billingsuccess_90: "Zahlungsbestätigung…",
    comp_billingsuccess_91: "Willkommen bei",
    comp_billingsuccess_92: "Die Gemeinschaft",
    comp_billingsuccess_93: "Ihre Zahlung von",
    comp_billingsuccess_94: "ist bestätigt. Unser Team wird Ihr Onboarding abschließen und Sie schnell für Ihren Willkommensanruf kontaktieren.",
    comp_billingsuccess_95: "Auf meinen Bereich zugreifen",
    comp_billingsuccess_96: "Stripe bearbeitet Ihre Zahlung. Sie erhalten eine E-Mail, sobald die Bestätigung vorliegt.",
    comp_billingsuccess_97: "Fehler",
    comp_billingsuccess_98: "Zahlung konnte nicht überprüft werden. Kontaktieren Sie das Team.",
    comp_contactpage_90: "Eine Frage, ein Projekt, eine Bewerbung? Schreiben Sie uns, unser Team antwortet Ihnen innerhalb von 48 Stunden.",
    comp_contactpage_91: "Nachricht erhalten!",
    comp_contactpage_92: "Unser Team hat Ihre Nachricht erhalten und wird sich in Kürze bei Ihnen melden.",
    comp_contactpage_93: "Eine weitere Nachricht senden",
    comp_contactpage_94: "Vorname *",
    comp_contactpage_95: "Telefon",
    comp_contactpage_96: "— Tätigkeitsbereich (optional) —",
    comp_contactpage_97: "Ihre Nachricht *",
    comp_contactpage_98: "Ich bin damit einverstanden, dass meine Daten von La WineTech zur Bearbeitung meiner Anfrage (gemäß DSGVO) gespeichert werden. Meine Daten werden niemals weiterverkauft.",
    comp_contactpage_99: "Oder schreiben Sie uns direkt an",
    comp_digestsubscribepage_90: "Notiert!",
    comp_digestsubscribepage_91: "Sie erhalten Ihren ersten Weekly Digest nächsten Donnerstag um 9 Uhr. Sie können Ihre Präferenzen ändern oder sich von jeder E-Mail abmelden.",
    comp_digestsubscribepage_92: "Jeden Donnerstag um 9 Uhr erhalten Sie das Wichtigste aus der WineTech-Welt, basierend auf Ihren Interessen – Mitgliedernachrichten, Innovationen, Wissenschaft, Regulierung und kommende Veranstaltungen.",
    comp_digestsubscribepage_93: "Vorname",
    comp_digestsubscribepage_94: "🇫🇷 Französisch",
    comp_digestsubscribepage_95: "🇵🇹 Portugiesisch",
    comp_digestsubscribepage_96: "Interessen",
    comp_digestsubscribepage_97: "— alles standardmäßig ausgewählt",
    comp_eventdetail_90: "Wird geladen...",
    comp_eventdetail_91: "Sie sind angemeldet als",
    comp_eventdetail_92: "← Zurück zu meinem Bereich",
    comp_eventdetail_93: "📄 Veranstaltungskatalog",
    comp_eventdetail_94: "Vollständiges PDF mit der Liste der Aussteller, Besucher und Redner – in Echtzeit aktualisiert.",
    comp_eventdetail_95: "Termine anzeigen",
    comp_eventdetail_96: "Wer wird dabei sein?",
    comp_eventdetail_97: "Öffentliche Liste der bestätigten Anmeldungen – treffen Sie diese Mitglieder und Aussteller der WineTech-Community.",
    comp_eventdetail_98: "Anmeldung bestätigt",
    comp_eventdetail_99: "Abmeldung bestätigen?",
    comp_eventdetail_100: "Bestätigen",
    comp_eventdetail_101: "Abbrechen",
    comp_eventdetail_102: "Schon Mitglied?",
    comp_eventdetail_103: "Anmeldung bestätigt!",
    comp_eventdetail_104: "Ihr Konto aktivieren",
    comp_eventdetail_105: "Meinen PDF-Ausweis herunterladen",
    comp_eventdetail_106: "Anmeldung zur Veranstaltung",
    comp_eventdetail_107: "💳 Nach diesem Formular werden Sie zur sicheren Stripe-Zahlungsseite weitergeleitet. Ihr Badge wird nach Zahlungseingang ausgestellt.",
    comp_eventdetail_108: "— Kostenlos. Ihr Badge wird sofort ausgestellt.",
    comp_eventdetail_109: "Vorname *",
    comp_eventdetail_110: "Firma",
    comp_eventdetail_111: "Telefon",
    comp_eventdetail_112: "Ein persönliches Konto wird automatisch für Sie erstellt (Aktivierungs-E-Mail wird gesendet), damit Sie Ihren Ausweis abrufen und an den 1:1-Meetings teilnehmen können.",
    comp_eventdetail_113: "Namen, Firma, Produkt suchen…",
    comp_eventdetail_114: "Sortieren: Vorname A→Z",
    comp_eventdetail_115: "Sortieren: Unternehmen A→Z",
    comp_eventdetail_116: "Sortieren: Reichste Profile",
    comp_eventpaymentsuccess_90: "Zahlung wird überprüft…",
    comp_eventpaymentsuccess_91: "Zahlung bestätigt!",
    comp_eventpaymentsuccess_92: "Ihre Anmeldung ist bestätigt. Hier ist Ihr Badge.",
    comp_eventpaymentsuccess_93: "Die Zahlungsüberprüfung dauert länger als erwartet. Sie erhalten eine Bestätigungs-E-Mail, sobald sie validiert ist.",
    comp_eventpaymentsuccess_94: "Zurück zum Event",
    comp_eventpaymentsuccess_95: "Zahlung nicht bestätigt",
    comp_eventpaymentsuccess_96: "Es ist ein Fehler aufgetreten. Falls Ihr Konto belastet wurde, kontaktieren Sie uns bitte.",
    comp_eventslist_90: "Event, Stadt suchen…",
    comp_eventslist_91: "Nächstes Datum",
    comp_eventslist_92: "Entferntestes Datum",
    comp_eventslist_93: "Zuletzt veröffentlicht",
    comp_eventslist_94: "Vor langer Zeit veröffentlicht",
    comp_exhibitorpaymentsuccess_90: "Zahlung wird überprüft…",
    comp_exhibitorpaymentsuccess_91: "Aussteller-Anmeldung bestätigt!",
    comp_exhibitorpaymentsuccess_92: "Ihre Zahlung wurde erfolgreich bearbeitet. Sie sind nun als Aussteller für diese 1:1-Meetings validiert.",
    comp_exhibitorpaymentsuccess_93: "Nächster Schritt:",
    comp_exhibitorpaymentsuccess_94: "gehen Sie zu Ihrem",
    comp_exhibitorpaymentsuccess_95: "Event-Bereich",
    comp_exhibitorpaymentsuccess_96: "um",
    comp_exhibitorpaymentsuccess_97: "Ihre Verfügbarkeits-Slots auszuwählen",
    comp_exhibitorpaymentsuccess_98: "Verfügbarkeiten verwalten",
    comp_exhibitorpaymentsuccess_99: "Zurück zum Event",
    comp_exhibitorpaymentsuccess_100: "Zahlung nicht bestätigt",
    comp_exhibitorpaymentsuccess_101: "Die Zahlung konnte nicht überprüft werden. Falls Sie bereits bezahlt haben, wird der Stripe-Webhook die Anmeldung innerhalb weniger Minuten abschließen.",
    comp_forgotpassword_90: "Passwort vergessen?",
    comp_forgotpassword_91: "Geben Sie Ihre E-Mail-Adresse ein. Falls ein Konto existiert, erhalten Sie einen auf 1 Stunde gültigen Zurücksetzungslink.",
    comp_forgotpassword_92: "E-Mail gesendet",
    comp_formationdetail_90: "Wird geladen…",
    comp_formationdetail_91: "Login-Link (Angemeldete)",
    comp_formationdetail_92: "Passwort:",
    comp_formationdetail_93: "Vorname *",
    comp_formationslist_90: "Schulungen der La WineTech Academy",
    comp_formationslist_91: "Sessions zur Kompetenzerweiterung in der Welt des Weins & der damit verbundenen Technologien.",
    comp_formationslist_92: "Schulung suchen…",
    comp_formationslist_93: "Zurzeit keine Schulungen verfügbar.",
    comp_home_90: "die WineTech-Gemeinschaft",
    comp_home_91: "Tauschen Sie sich aus, arbeiten Sie zusammen und gestalten Sie die Zukunft des Weins mit.",
    comp_joinpage_90: "Der La WineTech beitreten | Mitgliedschaft & Beiträge",
    comp_joinpage_91: "Treten Sie dem internationalen Ökosystem von",
    comp_joinpage_92: "Innovationsökosystem",
    comp_joinpage_93: "Die gemeinsame Basis",
    comp_joinpage_94: "Unabhängig von Ihrer Mitgliedschaftskategorie profitieren Sie von diesen Vorteilen.",
    comp_joinpage_95: "Wählen Sie Ihre Kategorie",
    comp_joinpage_96: "Jedes Profil profitiert von zusätzlichen Vorteilen, die auf seinen Beruf zugeschnitten sind.",
    comp_joinpage_97: "Zusätzlich zur gemeinsamen Basis",
    comp_joinpage_98: "Berechnen Sie Ihr",
    comp_joinpage_99: "Geben Sie Ihre Kategorie und Ihren jährlichen Umsatz an, um Ihren geschätzten Mitgliedsbeitrag zu erfahren. Keine Kontoerstellung erforderlich.",
    comp_joinpage_100: "Kategorie",
    comp_joinpage_101: "Indikativer Jahresbeitrag — vorbehaltlich der Genehmigung durch unseren Ausschuss.",
    comp_joinpage_102: "Über die Mitgliedschaft hinaus",
    comp_joinpage_103: "Unser Ausschuss prüft Ihre Bewerbung und antwortet Ihnen innerhalb von 5 Werktagen.",
    comp_joinpage_104: "Bereits Kandidat/in? Anmelden",
    comp_leaderboard_90: "Top La WineTech Mitglieder",
    comp_leaderboard_91: "Die engagiertesten Akteure der Community jeden Monat.",
    comp_leaderboard_92: "Rangliste wird erstellt.",
    comp_leaderboard_93: "Was unsere Mitglieder sagen",
    comp_memberprofile_90: "Sie sind angemeldet als",
    comp_memberprofile_91: "← Zurück zu meinem Bereich",
    comp_memberprofile_92: "Video",
    comp_memberprofile_93: "Demo",
    comp_memberprofile_94: "Direkt mit dem Team verbinden.",
    comp_memberprofile_95: "Telefon",
    comp_memberprofile_96: "Termin buchen",
    comp_membersdirectory_90: "Neueste zuerst",
    comp_newslist_90: "Neueste zuerst",
    comp_publicmeetingrequest_90: "Termin anfragen",
    comp_publicmeetingrequest_91: "Anfrage gesendet!",
    comp_publicmeetingrequest_92: "Unser Team meldet sich in Kürze bei Ihnen unter",
    comp_publicmeetingrequest_93: ". Bis bald 🍷",
    comp_publicmeetingrequest_94: "Ihr Name *",
    comp_publicmeetingrequest_95: "Telefon",
    comp_publicmeetingrequest_96: "Firma",
    comp_publicmeetingrequest_97: "Betreff des Termins *",
    comp_publicmeetingrequest_98: "Gewünschtes Datum (optional)",
    comp_publicmeetingrequest_99: "Beschreiben Sie kurz Ihre Anfrage, Ihre Tätigkeit, Ihre Erwartungen…",
    comp_publicmeetingrequest_100: "Mit dem Absenden dieses Formulars stimmen Sie zu, dass Ihre Daten vom La WineTech Team zur Kontaktaufnahme verwendet werden dürfen. Lesen Sie unsere Datenschutzrichtlinie.",
    comp_renewalform_90: "Zahlung storniert. Sie können es unten erneut versuchen.",
    comp_renewalform_91: "Wird geladen…",
    comp_renewalform_92: "Ungültiger oder abgelaufener Link. Kontaktieren Sie La WineTech.",
    comp_renewalform_93: "Ihre Antwort wurde gespeichert. Wir würden uns freuen, weiterhin mit Ihnen im Austausch zu bleiben.",
    comp_renewalform_94: "Weiterleitung zur Zahlung…",
    comp_renewalform_95: "Gesamtbewertung (von 5)",
    comp_renewalform_96: "Ihr Kommentar",
    comp_renewalform_97: "Ihr Feedback zum vergangenen Jahr…",
    comp_renewalform_98: "Dient zur automatischen Berechnung Ihres Beitrags gemäß der La WineTech Tabelle.",
    comp_renewalform_99: "Geladen",
    comp_renewalform_100: "Zahlungsmethode",
    comp_resetpassword_90: "Der Link zur Passwortrücksetzung ist unvollständig oder abgelaufen.",
    comp_resetpassword_91: "Neuen Link anfordern",
    comp_resetpassword_92: "Neues Passwort",
    comp_resetpassword_93: "Wählen Sie ein Passwort mit mindestens 8 Zeichen.",
    comp_resetpassword_94: "Passwort bestätigen",
    comp_resetpassword_95: "Passwort aktualisiert",
    comp_resetpassword_96: "Sie werden zur Anmeldeseite weitergeleitet…",
    press_pressdashboard_90: "Kommende Veranstaltungen",
    press_pressdashboard_91: "Pressemitteilungen",
    press_pressdashboard_92: "Nach Nachrichten suchen...",
    press_pressevents_90: "Nach einem Event, einer Stadt suchen…",
    press_pressmembers_90: "Mitglied, Stadt, Technologie suchen…",
  
    join_seg_startups_name: "Start-ups & Innovation",
    join_seg_startups_desc: "Junge innovative Unternehmen, die Lösungen für die Weinbranche entwickeln.",
    join_seg_startups_extra_1: "Sichtbarkeit bei Produzenten, Partnern und Akteuren der Branche",
    join_seg_startups_extra_2: "Zugang zu Investoren und Partnern des Ökosystems",
    join_seg_startups_extra_3: "Möglichkeiten für Feldversuche",
    join_seg_startups_extra_4: "Möglichkeit zur Integration in Beschleunigungsprogramme und Gemeinschaftsinitiativen",
    join_seg_startups_extra_5: "Teilnahme an Arbeitsgruppen und kollaborativen Projekten",
    join_seg_experts_name: "Experten & Berater",
    join_seg_experts_desc: "Beratungsfirmen, unabhängige Experten und spezialisierte Begleiter.",
    join_seg_experts_extra_1: "Referenzierung als Experte des Ökosystems",
    join_seg_experts_extra_2: "Nutzbarmachung von Fachwissen und Erfahrungsberichten",
    join_seg_experts_extra_3: "Teilnahme an Arbeitsgruppen und thematischen Projekten",
    join_seg_experts_extra_4: "Möglichkeiten zur Zusammenarbeit mit den Mitgliedern des Ökosystems",
    join_seg_producteurs_name: "Produzenten",
    join_seg_producteurs_desc: "Weingüter, Genossenschaftskellereien, Handelshäuser und Produzenten, die sich für Innovation engagieren.",
    join_seg_producteurs_extra_1: "Beobachtung von Brancheninnovationen",
    join_seg_producteurs_extra_2: "Entdeckung von Start-ups und Mitgliedslösungen",
    join_seg_producteurs_extra_3: "Möglichkeiten für Experimente und Zusammenarbeit",
    join_seg_producteurs_extra_4: "Möglichkeit zur Teilnahme an thematischen Beschleunigungsprogrammen",
    join_seg_producteurs_extra_5: "Teilnahme an kollektiven Projekten, die von WineTech getragen werden",
    join_seg_fournisseurs_name: "Kommunikation, Ausrüstung & Vertrieb",
    join_seg_fournisseurs_desc: "Lösungsanbieter, Ausrüster, Distributoren und Dienstleister der Branche.",
    join_seg_fournisseurs_extra_1: "Nutzbarmachung der angebotenen Lösungen und Dienstleistungen",
    join_seg_fournisseurs_extra_2: "Sichtbarkeit bei Produzenten und Start-ups",
    join_seg_fournisseurs_extra_3: "Teilnahme an kollaborativen Projekten",
    join_seg_fournisseurs_extra_4: "Integration in die Gemeinschaftsinitiativen des Ökosystems",
    join_seg_ecoles_name: "Institute & Schulen",
    join_seg_ecoles_desc: "Bildungseinrichtungen, Forschungszentren, Laboratorien und Bildungsträger.",
    join_seg_ecoles_extra_1: "Nutzbarmachung von pädagogischen und wissenschaftlichen Projekten",
    join_seg_ecoles_extra_2: "Verbindung zu Unternehmen und Start-ups der Branche",
    join_seg_ecoles_extra_3: "Teilnahme an kollaborativen Projekten",
    join_seg_ecoles_extra_4: "Beitrag zu den Überlegungen und Arbeiten des Ökosystems",
    join_seg_partenaires_name: "Partner",
    join_seg_partenaires_desc: "Institutionen, Branchenverbände, Berufsverbände und Unternehmen, die das WineTech-Ökosystem nachhaltig unterstützen möchten.",
    join_seg_partenaires_extra_1: "Verstärkte institutionelle Sichtbarkeit",
    join_seg_partenaires_extra_2: "Teilnahme an den strategischen Ausrichtungen des Vereins",
    join_seg_partenaires_extra_3: "Unterstützung strukturierender Programme der Branche",
    join_seg_partenaires_extra_4: "Privilegierte Präsenz bei WineTech-Veranstaltungen",
    join_seg_partenaires_extra_5: "Teilnahme an kollektiven Initiativen, die von WineTech getragen werden",
    join_common_1: "Mitgliederprofil auf der WineTech-Plattform",
    join_common_2: "Eintrag im Mitgliederverzeichnis",
    join_common_3: "Zugang zu WineTech-Veranstaltungen",
    join_common_4: "Zugang zu den Wine Tech Coffees",
    join_common_5: "Teilnahme am Wine Tech Campus",
    join_common_6: "Zugang zu Monitoring und Neuigkeiten des Ökosystems",
    join_common_7: "Zugang zur Community-Gruppe",
    join_common_8: "Identifikation innerhalb des WineTech-Ökosystems",
    join_common_9: "Referenzierung in den WineTech-Kommunikationen",
    join_prog_accel_title: "Beschleunigungsprogramme",
    join_prog_accel_desc: "Kollektive Begleitung in den Bereichen Innovation, Geschäftsentwicklung, Wachstum, Feldversuche und Finanzierung.",
    join_prog_export_title: "Exportmissionen",
    join_prog_export_desc: "Entdeckung neuer Märkte, Geschäftsbegegnungen und gemeinsame internationale Aktivitäten.",
    join_prog_academy_title: "WineTech Academy",
    join_prog_academy_desc: "Schulungen, Workshops, Masterclasses und Austausch bewährter Verfahren zwischen Mitgliedern und Experten.",
    join_prog_press_title: "Sichtbarkeit & Presse",
    join_prog_press_desc: "Nutzbarmachung von Initiativen, Kommunikation, Pressearbeit und Fördermaßnahmen für das Ökosystem.",
    join_prog_events_title: "Veranstaltungen & Gemeinschaftsaktionen",
    join_prog_events_desc: "Wine Tech Tour, Wine Tech Coffee, Wine Tech Campus, Fachmessen und thematische Treffen.",
    apply_innovation_ai: "Künstliche Intelligenz",
    apply_innovation_robot: "Robotik / Agrartechnik",
    apply_innovation_iot: "Sensoren / IoT",
    apply_innovation_blockchain: "Rückverfolgbarkeit / Blockchain",
    apply_innovation_marketplace: "Marktplatz / E-Commerce",
    apply_innovation_tourism: "Tourismus & Erlebnis",
    apply_innovation_energy: "Energie & Nachhaltigkeit",
    apply_innovation_oeno: "Önologie / Weindaten",
    apply_innovation_logistics: "Logistik & Supply Chain",
    apply_innovation_other: "Sonstiges",
    apply_interest_member: "WineTech-Mitglied werden",
    apply_interest_partner: "Kommerzielle Partnerschaft",
    apply_interest_invest: "Investition / Kapitalbeschaffung",
    apply_interest_mentor: "Mentoring / Netzwerk",
    apply_interest_event: "An Veranstaltungen teilnehmen",
    apply_interest_visibility: "Sichtbarkeit Presse / Kommunikation",
    apply_interest_export: "Internationales Programm",
  
    join_annual_fee: "Jahresbeitrag",
    apply_step_label: "Schritt",
    apply_step_you: "Sie",
    apply_step_you_short: "Identität",
    apply_step_company: "Ihr Unternehmen",
    apply_step_company_short: "Unternehmen",
    apply_step_expectations: "Ihre Erwartungen",
    apply_step_expectations_short: "Finalisierung",
    apply_btn_previous: "Zurück",
    apply_btn_continue: "Weiter",
    apply_btn_submit: "Bewerbung abschicken",
    apply_btn_submitting: "Wird gesendet…",
    apply_desc_min_chars: "Mindestens 30 Zeichen",
  
    portal_mycompany_collab_subtitle: "Laden Sie Ihre Kollegen ein, Ihrem Mitgliederbereich beizutreten – sie profitieren von Ihrer Mitgliedschaft ohne zusätzliche Kosten.",
    portal_mycompany_invite_cta_title: "Laden Sie einen Kollegen ein, Ihrem Unternehmen beizutreten",
    portal_mycompany_invite_cta_subtitle: "Ihre Mitgliedschaft deckt das gesamte Team ab: Fügen Sie sie hinzu, damit sie Zugang zu Veranstaltungen, Matchmaking und Marktbeobachtung erhalten.",
  
    cta_apply: "Bewerben",
  
    join_calc_chip: "Sofortrechner",
    join_calc_word_fee: "Beitrag",
    join_calc_revenue_label: "Jährlicher Umsatz (€)",
    join_calc_revenue_placeholder: "z.B. 1 500 000",
    join_calc_loading: "Berechne...",
    join_calc_submit: "Meinen Tarif berechnen",
    join_calc_bracket: "Geschätzte Spanne",
    apply_step0_title: "Lernen wir uns kennen",
    apply_field_lastname: "Nachname *",
    apply_field_email: "Geschäfts-E-Mail *",
    apply_form_required_toast: "Bitte füllen Sie die Pflichtfelder aus, bevor Sie fortfahren.",
    apply_form_privacy_before: "Ihre Daten werden gemäß unserer",
    apply_form_privacy_after: ". Kein Spam, Abmeldung mit 1 Klick.",
    not_found_title: "Seite nicht gefunden",
    not_found_message: "Diese Seite existiert nicht oder ist nicht mehr zugänglich. Überprüfen Sie die URL oder kehren Sie zur Startseite zurück.",
    not_found_back: "Zurück",
    not_found_home: "Startseite",
    portal_mycompany_collab_status_active: "Aktiv",
    portal_mycompany_collab_status_pending: "Einladung ausstehend",
    portal_mycompany_collab_status_no_account: "Ohne Konto",
  
    join_beyond_membership_desc: "Die Mitgliedschaft ist das Tor zum WineTech-Ökosystem. Mitglieder können sich danach an den Initiativen und Programmen beteiligen, die das ganze Jahr über entwickelt werden.",


    apply_thanks_title: "Bewerbung gesendet",
    apply_thanks_intro: "Vielen Dank! Wir haben Ihre Bewerbung erhalten und soeben eine Bestätigungs-E-Mail gesendet.",
    apply_thanks_within: "Unser Team meldet sich bei Ihnen innerhalb von",
    apply_thanks_within_value: "48 Werktagsstunden",
    apply_thanks_calendar_h: "Vereinbaren Sie Ihr Kennenlerngespräch",
    apply_thanks_calendar_desc: "Wählen Sie direkt im Kalender unten einen <strong>30-Minuten</strong>-Termin mit unserem Team.",
    apply_thanks_book_cta: "Termin auswählen",
    apply_thanks_no_calendar: "📅 Wir melden uns mit einem Terminvorschlag.",
    apply_thanks_back_home: "Zurück zur Startseite",
    apply_thanks_follow: "Folgen Sie La WineTech",
    apply_thanks_questions: "Haben Sie Fragen?",
    apply_field_website: "Webseite",
    apply_field_revenue: "Jahresumsatz (€)",
    apply_field_country: "Land *",
    apply_field_choose: "— Bitte wählen —",
    apply_toast_success: "Bewerbung gesendet!",
    apply_toast_error: "Fehler beim Senden. Bitte erneut versuchen oder uns kontaktieren.",
    apply_toast_error_short: "Sendefehler",
    apply_lang_label: "Sprache / Language",
    application_validated_by: "Genehmigt von {name} · am {date}",
    application_rejected_by: "Abgelehnt von {name} · am {date}",
  }
};
